import {
    AccessControlId,
    AccessControlEntityId,
    ActivityId,
    ActivityParentEntityId,
    ActivitySourceId,
    AnswerEntityId,
    AreaCode,
    AudienceId,
    AuditId,
    BillableEntityId,
    CalendarDateSerialized,
    CalendarEventId,
    CalendarEventParentId,
    EventId,
    EventInviteeId,
    PlacementId,
    ClientTransferRequestId,
    CommunityId,
    CommunityLicenseId,
    CommunityMasterId,
    CommunityMasterLicenseTypeId,
    ContactId,
    ConversationThreadId,
    InboundLeadEmailId,
    CurrencyInCents,
    CustomListId,
    CustomListItemId,
    CustomListCategoryId,
    DisclosureAcknowledgementId,
    DisclosureId,
    EmailEntityId,
    EmailTemplateId,
    EntitySummaryId,
    EvergreenCommunityId,
    EvergreenCommunityListingId,
    EvergreenLicenseTypeId,
    EvergreenReviewId,
    FileEntityId,
    FileId,
    GooglePlaceId,
    HomeCareLeadId,
    HostedFormId,
    HostedFormEntityId,
    HostedFormResponseId,
    HostedFormSlugId,
    HostedFormSessionId,
    HostedFormTokenId,
    IdentityId,
    ImportId,
    InternalId,
    InvoiceId,
    InvoiceLineItemId,
    InvoicePaymentScheduleItemId,
    IsoTimestamp,
    LayoutContainerId,
    LayoutItemId,
    LayoutSectionId,
    LayoutSectionSettingId,
    LicenseId,
    NoteId,
    NoteEntityId,
    OrganizationId,
    PhoneNumberE164,
    PhotoId,
    PipelineId,
    PipelineStageId,
    PromptId,
    PublicRecordId,
    PublicRecordContactId,
    QuestionId,
    ReferenceBusinessId,
    ReferenceContactId,
    ReferralId,
    RegionId,
    RegionLicenseMapId,
    ReportExportId,
    SavedQueryId,
    SentMessageId,
    SignatureRequestFieldId,
    SignatureRequestId,
    SignatureRequestRecipientId,
    SignatureTemplateId,
    SignatureTemplateFieldId,
    SignatureTemplateRecipientId,
    SimpleSearchEntityId,
    SmsMessageId,
    SmtpCredentialId,
    TaskId,
    TaskTypeId,
    TaskParentId,
    TelecomContactId,
    TelecomPhoneLineId,
    TenantCredentialId,
    TenantId,
    TokenId,
    TourId,
    TwoFactorVerificationId,
    Url,
    UserId,
    UserGroupId,
    UserMailboxId,
    UserMailboxContactId,
    UserMailboxMessageId,
    UserMailboxMessageRecipientId,
    UserProfileId,
    UserTerritoryId,
    UUID,
    VoiceCallEventId,
    VoiceCallId,
    WorkflowExecutionId,
    WorkflowId,
    WorkflowActionId,
    WorkflowTargetId,
} from "@sp-crm/core";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
    ID: { input: string; output: string };
    String: { input: string; output: string };
    Boolean: { input: boolean; output: boolean };
    Int: { input: number; output: number };
    Float: { input: number; output: number };
    /** EntityIdScalar(AccessControlEntityId) type */
    AccessControlEntityId: {
        input: AccessControlEntityId;
        output: AccessControlEntityId;
    };
    /** EntityIdScalar(AccessControlId) type */
    AccessControlId: { input: AccessControlId; output: AccessControlId };
    /** EntityIdScalar(ActivityId) type */
    ActivityId: { input: ActivityId; output: ActivityId };
    /** EntityIdScalar(ActivityParentEntityId) type */
    ActivityParentEntityId: {
        input: ActivityParentEntityId;
        output: ActivityParentEntityId;
    };
    /** EntityIdScalar(ActivitySourceId) type */
    ActivitySourceId: { input: ActivitySourceId; output: ActivitySourceId };
    /** EntityIdScalar(AnswerEntityId) type */
    AnswerEntityId: { input: AnswerEntityId; output: AnswerEntityId };
    /** AreaCode Scalar type */
    AreaCode: { input: AreaCode; output: AreaCode };
    /** EntityIdScalar(AudienceId) type */
    AudienceId: { input: AudienceId; output: AudienceId };
    /** EntityIdScalar(BillableEntityId) type */
    BillableEntityId: { input: BillableEntityId; output: BillableEntityId };
    /** Calendar date in YYYY-MM-DD format */
    CalendarDateSerialized: {
        input: CalendarDateSerialized;
        output: CalendarDateSerialized;
    };
    /** EntityIdScalar(CalendarEventId) type */
    CalendarEventId: { input: CalendarEventId; output: CalendarEventId };
    /** EntityIdScalar(CalendarEventParentId) type */
    CalendarEventParentId: {
        input: CalendarEventParentId;
        output: CalendarEventParentId;
    };
    /** EntityIdScalar(ClientTransferRequestId) type */
    ClientTransferRequestId: {
        input: ClientTransferRequestId;
        output: ClientTransferRequestId;
    };
    /** EntityIdScalar(CommunityId) type */
    CommunityId: { input: CommunityId; output: CommunityId };
    /** EntityIdScalar(CommunityLicenseId) type */
    CommunityLicenseId: { input: CommunityLicenseId; output: CommunityLicenseId };
    /** EntityIdScalar(CommunityMasterId) type */
    CommunityMasterId: { input: CommunityMasterId; output: CommunityMasterId };
    /** EntityIdScalar(ContactId) type */
    ContactId: { input: ContactId; output: ContactId };
    /** EntityIdScalar(ConversationThreadId) type */
    ConversationThreadId: { input: ConversationThreadId; output: ConversationThreadId };
    /** Whole number depicting a currency amount in cents */
    CurrencyInCents: { input: CurrencyInCents; output: CurrencyInCents };
    /** EntityIdScalar(CustomListCategoryId) type */
    CustomListCategoryId: { input: CustomListCategoryId; output: CustomListCategoryId };
    /** EntityIdScalar(CustomListId) type */
    CustomListId: { input: CustomListId; output: CustomListId };
    /** EntityIdScalar(CustomListItemId) type */
    CustomListItemId: { input: CustomListItemId; output: CustomListItemId };
    /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
    DateTime: { input: any; output: any };
    /** EntityIdScalar(DisclosureAcknowledgementId) type */
    DisclosureAcknowledgementId: {
        input: DisclosureAcknowledgementId;
        output: DisclosureAcknowledgementId;
    };
    /** EntityIdScalar(DisclosureId) type */
    DisclosureId: { input: DisclosureId; output: DisclosureId };
    /** EntityIdScalar(EmailEntityId) type */
    EmailEntityId: { input: EmailEntityId; output: EmailEntityId };
    /** EntityIdScalar(EmailTemplateId) type */
    EmailTemplateId: { input: EmailTemplateId; output: EmailTemplateId };
    /** EntityIdScalar(EvergreenCommunityId) type */
    EvergreenCommunityId: { input: EvergreenCommunityId; output: EvergreenCommunityId };
    /** EntityIdScalar(EvergreenCommunityListingId) type */
    EvergreenCommunityListingId: {
        input: EvergreenCommunityListingId;
        output: EvergreenCommunityListingId;
    };
    /** EntityIdScalar(EvergreenLicenseTypeId) type */
    EvergreenLicenseTypeId: {
        input: EvergreenLicenseTypeId;
        output: EvergreenLicenseTypeId;
    };
    /** EntityIdScalar(EvergreenReviewId) type */
    EvergreenReviewId: { input: EvergreenReviewId; output: EvergreenReviewId };
    /** EntityIdScalar(FileEntityId) type */
    FileEntityId: { input: FileEntityId; output: FileEntityId };
    /** EntityIdScalar(FileId) type */
    FileId: { input: FileId; output: FileId };
    /** EntityIdScalar(GooglePlaceId) type */
    GooglePlaceId: { input: GooglePlaceId; output: GooglePlaceId };
    /** EntityIdScalar(HomeCareLeadId) type */
    HomeCareLeadId: { input: HomeCareLeadId; output: HomeCareLeadId };
    /** EntityIdScalar(HostedFormEntityId) type */
    HostedFormEntityId: { input: HostedFormEntityId; output: HostedFormEntityId };
    /** EntityIdScalar(HostedFormId) type */
    HostedFormId: { input: HostedFormId; output: HostedFormId };
    /** EntityIdScalar(HostedFormSlugId) type */
    HostedFormSlugId: { input: HostedFormSlugId; output: HostedFormSlugId };
    /** EntityIdScalar(HostedFormTokenId) type */
    HostedFormTokenId: { input: HostedFormTokenId; output: HostedFormTokenId };
    /** EntityIdScalar(IdentityId) type */
    IdentityId: { input: IdentityId; output: IdentityId };
    /** EntityIdScalar(ImportId) type */
    ImportId: { input: ImportId; output: ImportId };
    /** EntityIdScalar(InboundLeadEmailId) type */
    InboundLeadEmailId: { input: InboundLeadEmailId; output: InboundLeadEmailId };
    /** EntityIdScalar(InvoiceId) type */
    InvoiceId: { input: InvoiceId; output: InvoiceId };
    /** EntityIdScalar(InvoiceLineItemId) type */
    InvoiceLineItemId: { input: InvoiceLineItemId; output: InvoiceLineItemId };
    /** EntityIdScalar(InvoicePaymentScheduleItemId) type */
    InvoicePaymentScheduleItemId: {
        input: InvoicePaymentScheduleItemId;
        output: InvoicePaymentScheduleItemId;
    };
    /** Timestamp in ISO 8601 format */
    IsoTimestamp: { input: IsoTimestamp; output: IsoTimestamp };
    /** EntityIdScalar(LayoutContainerId) type */
    LayoutContainerId: { input: LayoutContainerId; output: LayoutContainerId };
    /** EntityIdScalar(LayoutItemId) type */
    LayoutItemId: { input: LayoutItemId; output: LayoutItemId };
    /** EntityIdScalar(LayoutSectionId) type */
    LayoutSectionId: { input: LayoutSectionId; output: LayoutSectionId };
    /** EntityIdScalar(LayoutSectionSettingId) type */
    LayoutSectionSettingId: {
        input: LayoutSectionSettingId;
        output: LayoutSectionSettingId;
    };
    /** EntityIdScalar(LicenseId) type */
    LicenseId: { input: LicenseId; output: LicenseId };
    /** EntityIdScalar(NoteEntityId) type */
    NoteEntityId: { input: NoteEntityId; output: NoteEntityId };
    /** EntityIdScalar(NoteId) type */
    NoteId: { input: NoteId; output: NoteId };
    /** EntityIdScalar(OrganizationId) type */
    OrganizationId: { input: OrganizationId; output: OrganizationId };
    /** PhoneNumberE164 Scalar type */
    PhoneNumberE164: { input: PhoneNumberE164; output: PhoneNumberE164 };
    /** EntityIdScalar(PhotoId) type */
    PhotoId: { input: PhotoId; output: PhotoId };
    /** EntityIdScalar(PipelineId) type */
    PipelineId: { input: PipelineId; output: PipelineId };
    /** EntityIdScalar(PipelineStageId) type */
    PipelineStageId: { input: PipelineStageId; output: PipelineStageId };
    /** EntityIdScalar(PlacementId) type */
    PlacementId: { input: PlacementId; output: PlacementId };
    /** EntityIdScalar(PromptId) type */
    PromptId: { input: PromptId; output: PromptId };
    /** EntityIdScalar(PublicRecordContactId) type */
    PublicRecordContactId: {
        input: PublicRecordContactId;
        output: PublicRecordContactId;
    };
    /** EntityIdScalar(PublicRecordId) type */
    PublicRecordId: { input: PublicRecordId; output: PublicRecordId };
    /** EntityIdScalar(QuestionId) type */
    QuestionId: { input: QuestionId; output: QuestionId };
    /** EntityIdScalar(ReferenceBusinessId) type */
    ReferenceBusinessId: { input: ReferenceBusinessId; output: ReferenceBusinessId };
    /** EntityIdScalar(ReferenceContactId) type */
    ReferenceContactId: { input: ReferenceContactId; output: ReferenceContactId };
    /** EntityIdScalar(ReferralId) type */
    ReferralId: { input: ReferralId; output: ReferralId };
    /** EntityIdScalar(RegionId) type */
    RegionId: { input: RegionId; output: RegionId };
    /** EntityIdScalar(RegionLicenseMapId) type */
    RegionLicenseMapId: { input: RegionLicenseMapId; output: RegionLicenseMapId };
    /** EntityIdScalar(ReportExportId) type */
    ReportExportId: { input: ReportExportId; output: ReportExportId };
    /** EntityIdScalar(SavedQueryId) type */
    SavedQueryId: { input: SavedQueryId; output: SavedQueryId };
    /** EntityIdScalar(SentMessageId) type */
    SentMessageId: { input: SentMessageId; output: SentMessageId };
    /** EntityIdScalar(SignatureRequestFieldId) type */
    SignatureRequestFieldId: {
        input: SignatureRequestFieldId;
        output: SignatureRequestFieldId;
    };
    /** EntityIdScalar(SignatureRequestId) type */
    SignatureRequestId: { input: SignatureRequestId; output: SignatureRequestId };
    /** EntityIdScalar(SignatureRequestRecipientId) type */
    SignatureRequestRecipientId: {
        input: SignatureRequestRecipientId;
        output: SignatureRequestRecipientId;
    };
    /** EntityIdScalar(SignatureTemplateFieldId) type */
    SignatureTemplateFieldId: {
        input: SignatureTemplateFieldId;
        output: SignatureTemplateFieldId;
    };
    /** EntityIdScalar(SignatureTemplateId) type */
    SignatureTemplateId: { input: SignatureTemplateId; output: SignatureTemplateId };
    /** EntityIdScalar(SignatureTemplateRecipientId) type */
    SignatureTemplateRecipientId: {
        input: SignatureTemplateRecipientId;
        output: SignatureTemplateRecipientId;
    };
    /** EntityIdScalar(SimpleSearchEntityId) type */
    SimpleSearchEntityId: { input: SimpleSearchEntityId; output: SimpleSearchEntityId };
    /** EntityIdScalar(SmsMessageId) type */
    SmsMessageId: { input: SmsMessageId; output: SmsMessageId };
    /** EntityIdScalar(SmtpCredentialId) type */
    SmtpCredentialId: { input: SmtpCredentialId; output: SmtpCredentialId };
    /** EntityIdScalar(TaskId) type */
    TaskId: { input: TaskId; output: TaskId };
    /** EntityIdScalar(TaskParentId) type */
    TaskParentId: { input: TaskParentId; output: TaskParentId };
    /** EntityIdScalar(TaskTypeId) type */
    TaskTypeId: { input: TaskTypeId; output: TaskTypeId };
    /** EntityIdScalar(TelecomContactId) type */
    TelecomContactId: { input: TelecomContactId; output: TelecomContactId };
    /** EntityIdScalar(TelecomPhoneLineId) type */
    TelecomPhoneLineId: { input: TelecomPhoneLineId; output: TelecomPhoneLineId };
    /** EntityIdScalar(TenantCredentialId) type */
    TenantCredentialId: { input: TenantCredentialId; output: TenantCredentialId };
    /** EntityIdScalar(TenantId) type */
    TenantId: { input: TenantId; output: TenantId };
    /** EntityIdScalar(TokenId) type */
    TokenId: { input: TokenId; output: TokenId };
    /** EntityIdScalar(TourId) type */
    TourId: { input: TourId; output: TourId };
    /** UUID Scalar type */
    UUID: { input: InternalId; output: InternalId };
    /** EntityIdScalar(UserGroupId) type */
    UserGroupId: { input: UserGroupId; output: UserGroupId };
    /** EntityIdScalar(UserId) type */
    UserId: { input: UserId; output: UserId };
    /** EntityIdScalar(UserMailboxContactId) type */
    UserMailboxContactId: { input: UserMailboxContactId; output: UserMailboxContactId };
    /** EntityIdScalar(UserMailboxId) type */
    UserMailboxId: { input: UserMailboxId; output: UserMailboxId };
    /** EntityIdScalar(UserMailboxMessageId) type */
    UserMailboxMessageId: { input: UserMailboxMessageId; output: UserMailboxMessageId };
    /** EntityIdScalar(UserMailboxMessageRecipientId) type */
    UserMailboxMessageRecipientId: {
        input: UserMailboxMessageRecipientId;
        output: UserMailboxMessageRecipientId;
    };
    /** EntityIdScalar(UserProfileId) type */
    UserProfileId: { input: UserProfileId; output: UserProfileId };
    /** EntityIdScalar(UserTerritoryId) type */
    UserTerritoryId: { input: UserTerritoryId; output: UserTerritoryId };
    /** Free text entered by a user. Null characters are stripped on the way in because Postgres cannot store them. Length is enforced in the service layer, not here, so an over-long value is never echoed back in a coercion error. */
    UserText: { input: string; output: string };
    /** EntityIdScalar(VoiceCallId) type */
    VoiceCallId: { input: VoiceCallId; output: VoiceCallId };
    /** EntityIdScalar(WorkflowActionId) type */
    WorkflowActionId: { input: WorkflowActionId; output: WorkflowActionId };
    /** EntityIdScalar(WorkflowExecutionId) type */
    WorkflowExecutionId: { input: WorkflowExecutionId; output: WorkflowExecutionId };
    /** EntityIdScalar(WorkflowId) type */
    WorkflowId: { input: WorkflowId; output: WorkflowId };
    /** EntityIdScalar(WorkflowTargetId) type */
    WorkflowTargetId: { input: WorkflowTargetId; output: WorkflowTargetId };
};

export type AccessControlInput = {
    groupId: Scalars["UserGroupId"]["input"];
    id: Scalars["AccessControlId"]["input"];
};

export type AccessControlResult = {
    __typename?: "AccessControlResult";
    entityId: Scalars["AccessControlEntityId"]["output"];
    groupId: Scalars["UserGroupId"]["output"];
    id: Scalars["AccessControlId"]["output"];
};

export enum ActionType {
    AddAnswer = "AddAnswer",
    AddExistingExternalInvoice = "AddExistingExternalInvoice",
    AddNote = "AddNote",
    AdvancedSearchExplicitExecute = "AdvancedSearchExplicitExecute",
    AdvancedSearchImplicitExecute = "AdvancedSearchImplicitExecute",
    BulkImport = "BulkImport",
    BypassAcls = "BypassAcls",
    ClientCommunitiesPdf = "ClientCommunitiesPdf",
    ClientPdf = "ClientPdf",
    CreateAudience = "CreateAudience",
    CreateBulkMessage = "CreateBulkMessage",
    CreateCalendarEvent = "CreateCalendarEvent",
    CreateClient = "CreateClient",
    CreateCommunity = "CreateCommunity",
    CreateEmailTemplate = "CreateEmailTemplate",
    CreateEvent = "CreateEvent",
    CreateFranchiseTerritory = "CreateFranchiseTerritory",
    CreateHomeCareLead = "CreateHomeCareLead",
    CreateHostedForm = "CreateHostedForm",
    CreateModifyInvoice = "CreateModifyInvoice",
    CreateOrEditSignatureTemplate = "CreateOrEditSignatureTemplate",
    CreateQuestion = "CreateQuestion",
    CreateReference = "CreateReference",
    CreateReferral = "CreateReferral",
    CreateTask = "CreateTask",
    CreateTenant = "CreateTenant",
    CreateTour = "CreateTour",
    CreateUser = "CreateUser",
    CreateWorkflow = "CreateWorkflow",
    DeleteAudience = "DeleteAudience",
    DeleteBulkMessage = "DeleteBulkMessage",
    DeleteCalendarEvent = "DeleteCalendarEvent",
    DeleteEmailTemplate = "DeleteEmailTemplate",
    DeleteEvent = "DeleteEvent",
    DeleteFranchiseTerritory = "DeleteFranchiseTerritory",
    DeleteHomeCareLead = "DeleteHomeCareLead",
    DeleteHostedForm = "DeleteHostedForm",
    DeleteNote = "DeleteNote",
    DeleteQuestion = "DeleteQuestion",
    DeleteReferral = "DeleteReferral",
    DeleteSignatureTemplate = "DeleteSignatureTemplate",
    DeleteTask = "DeleteTask",
    DeleteTour = "DeleteTour",
    DeleteWorkflow = "DeleteWorkflow",
    EvergreenManageCommunityListings = "EvergreenManageCommunityListings",
    EvergreenPublicRecordCreate = "EvergreenPublicRecordCreate",
    EvergreenReadCommunityListings = "EvergreenReadCommunityListings",
    EvergreenReadDataSources = "EvergreenReadDataSources",
    EvergreenSchedulePropagate = "EvergreenSchedulePropagate",
    EvergreenThumbnail = "EvergreenThumbnail",
    ExportCsv = "ExportCsv",
    FailedLogin = "FailedLogin",
    Geocode = "Geocode",
    IntegrationHipaaAcknowledgment = "IntegrationHipaaAcknowledgment",
    InternalReportingLoadAllUsers = "InternalReportingLoadAllUsers",
    InternalReportingModify = "InternalReportingModify",
    InternalReportingShowActivity = "InternalReportingShowActivity",
    InternalReportingViewTenant = "InternalReportingViewTenant",
    InternalTrackEvergreenSignupRequest = "InternalTrackEvergreenSignupRequest",
    ListAudiences = "ListAudiences",
    ListBulkMessages = "ListBulkMessages",
    LoadClients = "LoadClients",
    LoadCollabClients = "LoadCollabClients",
    LoadCommunities = "LoadCommunities",
    LoadEmailTemplates = "LoadEmailTemplates",
    LoadHomeCareLeads = "LoadHomeCareLeads",
    LoadOwnClients = "LoadOwnClients",
    LoadOwnSentMessages = "LoadOwnSentMessages",
    LoadQuestions = "LoadQuestions",
    LoadReferences = "LoadReferences",
    LoadReferrals = "LoadReferrals",
    LoadReferralsForEntity = "LoadReferralsForEntity",
    LoadSentMessages = "LoadSentMessages",
    LoadTasks = "LoadTasks",
    LoadTenant = "LoadTenant",
    LoadUsers = "LoadUsers",
    ManageEmployeeCommissions = "ManageEmployeeCommissions",
    ManageFranchisePayments = "ManageFranchisePayments",
    ManageIntegrations = "ManageIntegrations",
    MigrateFile = "MigrateFile",
    ModifyAcls = "ModifyAcls",
    ModifyEmailTemplate = "ModifyEmailTemplate",
    ModifySharedEmailTemplate = "ModifySharedEmailTemplate",
    ModifyTaskType = "ModifyTaskType",
    MomsHouseReferral = "MomsHouseReferral",
    MultiAccountSwitch = "MultiAccountSwitch",
    Noop = "Noop",
    ReadHostedForm = "ReadHostedForm",
    ReadWorkflow = "ReadWorkflow",
    ResetPassword = "ResetPassword",
    SelfManageCreateUser = "SelfManageCreateUser",
    SelfManageDisableUser = "SelfManageDisableUser",
    SelfManageModifyUser = "SelfManageModifyUser",
    SelfManageViewApiKey = "SelfManageViewApiKey",
    SelfManageViewUser = "SelfManageViewUser",
    SetPassword = "SetPassword",
    SuccessfulLogin = "SuccessfulLogin",
    SuperuserCloneUser = "SuperuserCloneUser",
    SuperuserCreatePipelineShare = "SuperuserCreatePipelineShare",
    SuperuserCreateTenantPartnership = "SuperuserCreateTenantPartnership",
    SuperuserGenerateApiKey = "SuperuserGenerateApiKey",
    SuperuserGeneric = "SuperuserGeneric",
    SuperuserModifyCommunityMaster = "SuperuserModifyCommunityMaster",
    SuperuserModifyTenant = "SuperuserModifyTenant",
    SuperuserModifyUser = "SuperuserModifyUser",
    SuperuserResetTenant = "SuperuserResetTenant",
    SuperuserRevokePipelineShare = "SuperuserRevokePipelineShare",
    SuperuserRevokeTenantPartnership = "SuperuserRevokeTenantPartnership",
    SuperuserUpdateBusinessProfile = "SuperuserUpdateBusinessProfile",
    SuperuserUpdateTenantPartnership = "SuperuserUpdateTenantPartnership",
    SuperuserViewBusinessProfiles = "SuperuserViewBusinessProfiles",
    SuperuserViewTenantPartnerships = "SuperuserViewTenantPartnerships",
    UpdateAllSavedQueries = "UpdateAllSavedQueries",
    UpdateAudience = "UpdateAudience",
    UpdateBulkMessage = "UpdateBulkMessage",
    UpdateCalendarEvent = "UpdateCalendarEvent",
    UpdateClient = "UpdateClient",
    UpdateClientAddCommunity = "UpdateClientAddCommunity",
    UpdateClientAddContactPerson = "UpdateClientAddContactPerson",
    UpdateClientDeleteContactPerson = "UpdateClientDeleteContactPerson",
    UpdateClientRemoveCommunity = "UpdateClientRemoveCommunity",
    UpdateClientUpdateContactPerson = "UpdateClientUpdateContactPerson",
    UpdateCollabClient = "UpdateCollabClient",
    UpdateCommunity = "UpdateCommunity",
    UpdateCommunityAddContact = "UpdateCommunityAddContact",
    UpdateCommunityRemoveContact = "UpdateCommunityRemoveContact",
    UpdateCommunitySearch = "UpdateCommunitySearch",
    UpdateCommunityUpdateContact = "UpdateCommunityUpdateContact",
    UpdateCustomList = "UpdateCustomList",
    UpdateEvent = "UpdateEvent",
    UpdateFeatureTrack = "UpdateFeatureTrack",
    UpdateFranchiseTerritory = "UpdateFranchiseTerritory",
    UpdateHomeCareLead = "UpdateHomeCareLead",
    UpdateInboundLeadSources = "UpdateInboundLeadSources",
    UpdateLayout = "UpdateLayout",
    UpdateNote = "UpdateNote",
    UpdateOwnClient = "UpdateOwnClient",
    UpdateOwnHomeCareLead = "UpdateOwnHomeCareLead",
    UpdateQuestion = "UpdateQuestion",
    UpdateReference = "UpdateReference",
    UpdateReferral = "UpdateReferral",
    UpdateRegionSettings = "UpdateRegionSettings",
    UpdateTask = "UpdateTask",
    UpdateTenant = "UpdateTenant",
    UpdateTour = "UpdateTour",
    UpdateUser = "UpdateUser",
    ViewAllInvoices = "ViewAllInvoices",
    ViewAudience = "ViewAudience",
    ViewBulkMessage = "ViewBulkMessage",
    ViewCalendarEvent = "ViewCalendarEvent",
    ViewCallRecording = "ViewCallRecording",
    ViewCallTranscript = "ViewCallTranscript",
    ViewClient = "ViewClient",
    ViewCollabClient = "ViewCollabClient",
    ViewCommunity = "ViewCommunity",
    ViewCommunityContract = "ViewCommunityContract",
    ViewCustomList = "ViewCustomList",
    ViewEvent = "ViewEvent",
    ViewFranchiseRoyaltyReport = "ViewFranchiseRoyaltyReport",
    ViewFranchiseTerritories = "ViewFranchiseTerritories",
    ViewHomeCareLead = "ViewHomeCareLead",
    ViewInboundLeadSources = "ViewInboundLeadSources",
    ViewLayout = "ViewLayout",
    ViewOwnClient = "ViewOwnClient",
    ViewOwnHomeCareLead = "ViewOwnHomeCareLead",
    ViewOwnInvoices = "ViewOwnInvoices",
    ViewReference = "ViewReference",
    ViewReports = "ViewReports",
    ViewRestrictedWhiteLabelContent = "ViewRestrictedWhiteLabelContent",
    ViewSharedHomeCareLead = "ViewSharedHomeCareLead",
    ViewSharedPipeline = "ViewSharedPipeline",
    ViewSignatureRequest = "ViewSignatureRequest",
    ViewTask = "ViewTask",
    ViewTenant = "ViewTenant",
    ViewTour = "ViewTour",
}

export type Activity = {
    __typename?: "Activity";
    activityType: ActivityType;
    appLink: Scalars["String"]["output"];
    createdAt: Scalars["DateTime"]["output"];
    createdBy: Scalars["UserId"]["output"];
    createdByEntity: User;
    id: Scalars["ActivityId"]["output"];
    metadata?: Maybe<ActivityMetadata>;
    parentClient?: Maybe<Client>;
    parentCommunity?: Maybe<Community>;
    parentEntityId: Scalars["ActivityParentEntityId"]["output"];
    parentHomeCareLead?: Maybe<HomeCareLead>;
    parentReferenceBusiness?: Maybe<ReferenceBusiness>;
    parentReferenceContact?: Maybe<ReferenceContact>;
    sourceFile?: Maybe<File>;
    sourceFileId?: Maybe<Scalars["FileId"]["output"]>;
    sourceId: Scalars["ActivitySourceId"]["output"];
    sourceMessage?: Maybe<SentMessage>;
    sourceMessageId?: Maybe<Scalars["SentMessageId"]["output"]>;
    sourceNote?: Maybe<Note>;
    sourceNoteId?: Maybe<Scalars["NoteId"]["output"]>;
    sourceTask?: Maybe<Task>;
    sourceTaskId?: Maybe<Scalars["TaskId"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    updatedByEntity: User;
    voiceCall?: Maybe<VoiceCall>;
    voiceCallId?: Maybe<Scalars["VoiceCallId"]["output"]>;
};

export type ActivityFeed = {
    __typename?: "ActivityFeed";
    activities: Array<ActivityFeedEvent>;
};

export type ActivityFeedEvent = {
    __typename?: "ActivityFeedEvent";
    activity: Activity;
    file?: Maybe<File>;
    message?: Maybe<SentMessage>;
    note?: Maybe<Note>;
    sourceType: ActivitySourceType;
    task?: Maybe<Task>;
};

export type ActivityMetadata = {
    __typename?: "ActivityMetadata";
    events: Array<ActivityMetadataEvent>;
    version: Scalars["Int"]["output"];
};

export type ActivityMetadataEvent = {
    __typename?: "ActivityMetadataEvent";
    entityCollaboratorAdded?: Maybe<EntityCollaboratorAdded>;
    entityCollaboratorRemoved?: Maybe<EntityCollaboratorRemoved>;
    entityFieldChange?: Maybe<EntityFieldChange>;
    entityReassign?: Maybe<EntityReassign>;
    eventInvited?: Maybe<EventInvited>;
    eventRsvp?: Maybe<EventRsvp>;
    organizationMembership?: Maybe<OrganizationMembership>;
    outgoingCall?: Maybe<OutgoingCall>;
    pipelineStageChange?: Maybe<PipelineStageChange>;
    sentToPartner?: Maybe<SentToPartner>;
    smsSent?: Maybe<SmsSent>;
    touchpointLogged?: Maybe<TouchpointLogged>;
    touchpointSnoozed?: Maybe<TouchpointSnoozed>;
    type: ActivityMetadataEventType;
    visitScheduled?: Maybe<VisitScheduled>;
};

export enum ActivityMetadataEventType {
    EntityCollaboratorAdded = "EntityCollaboratorAdded",
    EntityCollaboratorRemoved = "EntityCollaboratorRemoved",
    EntityFieldChange = "EntityFieldChange",
    EntityReassign = "EntityReassign",
    EventInvited = "EventInvited",
    EventRsvp = "EventRsvp",
    OrganizationMembership = "OrganizationMembership",
    OutgoingCall = "OutgoingCall",
    PipelineStageChange = "PipelineStageChange",
    SentToPartner = "SentToPartner",
    SmsSent = "SmsSent",
    TouchpointLogged = "TouchpointLogged",
    TouchpointSnoozed = "TouchpointSnoozed",
    VisitScheduled = "VisitScheduled",
}

export enum ActivitySourceType {
    Entity = "Entity",
    File = "File",
    Message = "Message",
    Note = "Note",
    Task = "Task",
    VoiceCall = "VoiceCall",
}

export enum ActivityType {
    CommunityDeleted = "CommunityDeleted",
    CommunityRestored = "CommunityRestored",
    EntityCollaboratorAdded = "EntityCollaboratorAdded",
    EntityCollaboratorRemoved = "EntityCollaboratorRemoved",
    EntityCreate = "EntityCreate",
    EntityFieldChange = "EntityFieldChange",
    EntityReassign = "EntityReassign",
    EventInvited = "EventInvited",
    EventRsvp = "EventRsvp",
    FileUpload = "FileUpload",
    MessageSent = "MessageSent",
    NoteCreate = "NoteCreate",
    NoteDelete = "NoteDelete",
    NoteUpdate = "NoteUpdate",
    OrganizationMemberAdded = "OrganizationMemberAdded",
    OrganizationMemberRemoved = "OrganizationMemberRemoved",
    OutgoingCall = "OutgoingCall",
    PipelineCardAdded = "PipelineCardAdded",
    PipelineCardMoved = "PipelineCardMoved",
    PipelineCardRemoved = "PipelineCardRemoved",
    SentToPartner = "SentToPartner",
    SmsSent = "SmsSent",
    TaskComplete = "TaskComplete",
    TaskCreate = "TaskCreate",
    TaskDelete = "TaskDelete",
    TaskReassign = "TaskReassign",
    TaskUncomplete = "TaskUncomplete",
    TaskUpdate = "TaskUpdate",
    TouchpointLogged = "TouchpointLogged",
    TouchpointSnoozed = "TouchpointSnoozed",
    VisitScheduled = "VisitScheduled",
}

export type AddClientCommunityRequest = {
    communityId: Scalars["CommunityId"]["input"];
    familyView: Scalars["Boolean"]["input"];
};

export type AddExternalInvoiceRequest = {
    clientId: Scalars["PlacementId"]["input"];
    externalInvoiceId: Scalars["String"]["input"];
};

export type AdditionalNotesImpl = {
    additionalClientNotes?: InputMaybe<Scalars["String"]["input"]>;
    primaryClientNotes?: InputMaybe<Scalars["String"]["input"]>;
    sameForBoth: Scalars["Boolean"]["input"];
};

export type AdvancedSearchAggregate = {
    __typename?: "AdvancedSearchAggregate";
    column: Scalars["String"]["output"];
    operator: AdvancedSearchAggregateOperator;
};

export type AdvancedSearchAggregateInput = {
    column: Scalars["String"]["input"];
    operator: AdvancedSearchAggregateOperator;
};

export enum AdvancedSearchAggregateOperator {
    Average = "Average",
    Count = "Count",
    Max = "Max",
    Min = "Min",
    Sum = "Sum",
}

export type AdvancedSearchAggregateResult = {
    __typename?: "AdvancedSearchAggregateResult";
    dateValue?: Maybe<Scalars["DateTime"]["output"]>;
    formattedValue?: Maybe<Scalars["String"]["output"]>;
    numberValue?: Maybe<Scalars["Float"]["output"]>;
    textValue?: Maybe<Scalars["String"]["output"]>;
};

export type AdvancedSearchCondition = {
    __typename?: "AdvancedSearchCondition";
    calendarDateValue?: Maybe<Scalars["String"]["output"]>;
    children?: Maybe<Array<AdvancedSearchCondition>>;
    dateValue?: Maybe<Scalars["DateTime"]["output"]>;
    fieldName?: Maybe<Scalars["String"]["output"]>;
    nodeType: AdvancedSearchConditionNodeType;
    numberValue?: Maybe<Scalars["Float"]["output"]>;
    operator?: Maybe<FieldConditionOperator>;
    promptId?: Maybe<Scalars["PromptId"]["output"]>;
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
    relativeDate?: Maybe<AdvancedSearchRelativeDate>;
    textValue?: Maybe<Scalars["String"]["output"]>;
};

/** Type of entity to search for */
export enum AdvancedSearchConditionNodeType {
    And = "And",
    FieldCondition = "FieldCondition",
    Or = "Or",
    RelationCondition = "RelationCondition",
}

/** Type of entity to search for */
export enum AdvancedSearchEntityType {
    Activity = "Activity",
    CalendarEvent = "CalendarEvent",
    Client = "Client",
    Community = "Community",
    CommunityContact = "CommunityContact",
    HomeCareLead = "HomeCareLead",
    Invoice = "Invoice",
    ReferenceBusiness = "ReferenceBusiness",
    ReferenceContact = "ReferenceContact",
    Task = "Task",
    Tour = "Tour",
    WorkflowExecution = "WorkflowExecution",
}

export type AdvancedSearchGroupKey = {
    __typename?: "AdvancedSearchGroupKey";
    appLink?: Maybe<Scalars["String"]["output"]>;
    formattedValue?: Maybe<Scalars["String"]["output"]>;
    textValue?: Maybe<Scalars["String"]["output"]>;
};

export type AdvancedSearchRelativeDate = {
    __typename?: "AdvancedSearchRelativeDate";
    interval: AdvancedSearchRelativeDateInterval;
    value: Scalars["Int"]["output"];
};

/** Interval of the value in an AdvancedSearchRelativeDate */
export enum AdvancedSearchRelativeDateInterval {
    Day = "day",
    Hour = "hour",
    Minute = "minute",
    Month = "month",
    Second = "second",
    Thismonth = "thismonth",
    Today = "today",
    Week = "week",
    Year = "year",
}

export type AdvancedSearchRequest = {
    condition: AdvancedSearchRequestCondition;
    entityType: AdvancedSearchEntityType;
    page?: InputMaybe<Scalars["Int"]["input"]>;
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    select: Array<AdvancedSearchSelectInput>;
    sort: AdvancedSearchRequestSort;
    summaries?: InputMaybe<Array<AdvancedSearchRequestSummaryInput>>;
    type: AdvancedSearchRequestType;
};

export type AdvancedSearchRequestCondition = {
    calendarDateValue?: InputMaybe<Scalars["String"]["input"]>;
    children?: InputMaybe<Array<AdvancedSearchRequestCondition>>;
    dateValue?: InputMaybe<Scalars["DateTime"]["input"]>;
    fieldName?: InputMaybe<Scalars["String"]["input"]>;
    nodeType: AdvancedSearchConditionNodeType;
    numberValue?: InputMaybe<Scalars["Float"]["input"]>;
    operator?: InputMaybe<FieldConditionOperator>;
    promptId?: InputMaybe<Scalars["PromptId"]["input"]>;
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
    relativeDate?: InputMaybe<AdvancedSearchRequestRelativeDate>;
    textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdvancedSearchRequestRelativeDate = {
    interval: AdvancedSearchRelativeDateInterval;
    value: Scalars["Int"]["input"];
};

export type AdvancedSearchRequestSort = {
    ascending: Scalars["Boolean"]["input"];
    column?: InputMaybe<Scalars["String"]["input"]>;
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
};

export type AdvancedSearchRequestSummary = {
    __typename?: "AdvancedSearchRequestSummary";
    aggregates: Array<AdvancedSearchAggregate>;
    groupBy?: Maybe<Array<Scalars["String"]["output"]>>;
    page?: Maybe<Scalars["Int"]["output"]>;
    pageSize?: Maybe<Scalars["Int"]["output"]>;
    sort?: Maybe<AdvancedSearchSummarySort>;
};

export type AdvancedSearchRequestSummaryInput = {
    aggregates: Array<AdvancedSearchAggregateInput>;
    groupBy?: InputMaybe<Array<Scalars["String"]["input"]>>;
    page?: InputMaybe<Scalars["Int"]["input"]>;
    pageSize?: InputMaybe<Scalars["Int"]["input"]>;
    sort?: InputMaybe<AdvancedSearchSummarySortInput>;
};

export enum AdvancedSearchRequestType {
    Explicit = "Explicit",
    Implicit = "Implicit",
}

export type AdvancedSearchResult = {
    __typename?: "AdvancedSearchResult";
    entities: Array<AdvancedSearchResultEntity>;
    page?: Maybe<Scalars["Int"]["output"]>;
    pageSize?: Maybe<Scalars["Int"]["output"]>;
    summaries?: Maybe<Array<AdvancedSearchResultSummary>>;
    total: Scalars["Int"]["output"];
};

export type AdvancedSearchResultEntity =
    | Activity
    | CalendarEvent
    | Client
    | Community
    | CommunityContact
    | HomeCareLead
    | Invoice
    | ReferenceBusiness
    | ReferenceContact
    | Task
    | Tour
    | WorkflowExecution;

export type AdvancedSearchResultSummary = {
    __typename?: "AdvancedSearchResultSummary";
    groupTotal: Scalars["Int"]["output"];
    groups: Array<AdvancedSearchResultSummaryGroup>;
    totals: Array<AdvancedSearchTotalResult>;
};

export type AdvancedSearchResultSummaryGroup = {
    __typename?: "AdvancedSearchResultSummaryGroup";
    aggregates: Array<AdvancedSearchAggregateResult>;
    groupKey?: Maybe<Array<AdvancedSearchGroupKey>>;
};

export type AdvancedSearchSelect = {
    __typename?: "AdvancedSearchSelect";
    fieldName?: Maybe<Scalars["String"]["output"]>;
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

export type AdvancedSearchSelectInput = {
    fieldName?: InputMaybe<Scalars["String"]["input"]>;
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
};

export type AdvancedSearchSort = {
    __typename?: "AdvancedSearchSort";
    ascending: Scalars["Boolean"]["output"];
    column?: Maybe<Scalars["String"]["output"]>;
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
};

export type AdvancedSearchSummarySort = {
    __typename?: "AdvancedSearchSummarySort";
    aggregateIndex: Scalars["Float"]["output"];
    ascending: Scalars["Boolean"]["output"];
};

export type AdvancedSearchSummarySortInput = {
    aggregateIndex: Scalars["Float"]["input"];
    ascending: Scalars["Boolean"]["input"];
};

export type AdvancedSearchTotalResult = {
    __typename?: "AdvancedSearchTotalResult";
    dateValue?: Maybe<Scalars["DateTime"]["output"]>;
    formattedValue?: Maybe<Scalars["String"]["output"]>;
    numberValue?: Maybe<Scalars["Float"]["output"]>;
    textValue?: Maybe<Scalars["String"]["output"]>;
};

/** Individual answer */
export type Answer = {
    __typename?: "Answer";
    booleanAnswer?: Maybe<Scalars["Boolean"]["output"]>;
    calendarDateAnswer?: Maybe<Scalars["String"]["output"]>;
    dateAnswer?: Maybe<Scalars["String"]["output"]>;
    idReferenceAnswer?: Maybe<Scalars["UserId"]["output"]>;
    numberAnswer?: Maybe<Scalars["Float"]["output"]>;
    numberAnswerHigh?: Maybe<Scalars["Float"]["output"]>;
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
    selectionAnnotations?: Maybe<Array<AnswerSelectionAnnotation>>;
    selections?: Maybe<Array<Scalars["String"]["output"]>>;
    textAnswer?: Maybe<Scalars["String"]["output"]>;
};

export type AnswerInput = {
    booleanAnswer?: InputMaybe<Scalars["Boolean"]["input"]>;
    calendarDateAnswer?: InputMaybe<Scalars["String"]["input"]>;
    dateAnswer?: InputMaybe<Scalars["String"]["input"]>;
    idReferenceAnswer?: InputMaybe<Scalars["UserId"]["input"]>;
    numberAnswer?: InputMaybe<Scalars["Float"]["input"]>;
    numberAnswerHigh?: InputMaybe<Scalars["Float"]["input"]>;
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
    selectionAnnotations?: InputMaybe<Array<AnswerSelectionAnnotationInput>>;
    selections?: InputMaybe<Array<Scalars["String"]["input"]>>;
    textAnswer?: InputMaybe<Scalars["String"]["input"]>;
};

/** Answer selection annotation */
export type AnswerSelectionAnnotation = {
    __typename?: "AnswerSelectionAnnotation";
    selectionId?: Maybe<Scalars["String"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
};

export type AnswerSelectionAnnotationInput = {
    selectionId?: InputMaybe<Scalars["String"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

/** Attachment scopes */
export type AttachmentScope = {
    __typename?: "AttachmentScope";
    entityName: Scalars["String"]["output"];
    files: Array<File>;
};

export type AudienceLatestSyncResult = {
    __typename?: "AudienceLatestSyncResult";
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    durationMs?: Maybe<Scalars["Float"]["output"]>;
    errorMessage?: Maybe<Scalars["String"]["output"]>;
    historyId: Scalars["String"]["output"];
    membersAdded: Scalars["Float"]["output"];
    membersRemoved: Scalars["Float"]["output"];
    membersUpdated: Scalars["Float"]["output"];
    queuedAt: Scalars["DateTime"]["output"];
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    status: Scalars["String"]["output"];
    totalMembers: Scalars["Float"]["output"];
};

export type AudienceQueryInput = {
    queries: Array<AudienceQueryItemInput>;
};

export type AudienceQueryItemInput = {
    condition: AdvancedSearchRequestCondition;
    entityType: AdvancedSearchEntityType;
    select: Array<AdvancedSearchSelectInput>;
    sort: AdvancedSearchRequestSort;
};

export type AudienceQueryResultItem = {
    __typename?: "AudienceQueryResultItem";
    condition: AdvancedSearchCondition;
    entityType: AdvancedSearchEntityType;
    select: Array<AdvancedSearchSelect>;
    sort: AdvancedSearchSort;
};

export type AudienceRecipient = {
    __typename?: "AudienceRecipient";
    email: Scalars["String"]["output"];
    entityId: Scalars["String"]["output"];
    entityType: AdvancedSearchEntityType;
    firstName: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type AudienceResult = {
    __typename?: "AudienceResult";
    constantContact: ProviderSync;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["AudienceId"]["output"];
    mailchimp: ProviderSync;
    name: Scalars["String"]["output"];
    query: AudienceResultQuery;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export type AudienceResultQuery = {
    __typename?: "AudienceResultQuery";
    queries: Array<AudienceQueryResultItem>;
};

export type AuditRecord = {
    __typename?: "AuditRecord";
    actorTenantId: Scalars["TenantId"]["output"];
    actorUserId: Scalars["UserId"]["output"];
    affectedTenantId?: Maybe<Scalars["TenantId"]["output"]>;
    affectedUserId?: Maybe<Scalars["UserId"]["output"]>;
    auditId: Scalars["UUID"]["output"];
    newUser?: Maybe<AuditRecordUpdateUserDetails>;
    oldUser?: Maybe<AuditRecordUpdateUserDetails>;
    operation: ActionType;
    subOperation?: Maybe<Scalars["String"]["output"]>;
    when: Scalars["DateTime"]["output"];
};

export type AuditRecordUpdateUserDetails = {
    __typename?: "AuditRecordUpdateUserDetails";
    disabled: Scalars["Boolean"]["output"];
    email: Scalars["String"]["output"];
    firstName?: Maybe<Scalars["String"]["output"]>;
    hidden: Scalars["Boolean"]["output"];
};

/** Availability observation data */
export type AvailabilityObservationData = {
    __typename?: "AvailabilityObservationData";
    freshness: ObservationFreshness;
    lastUpdatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    notes?: Maybe<Scalars["String"]["output"]>;
    status: EvergreenCommunityListingAvailability;
};

/** Result of batchUpdateCommunityMaster operation */
export type BatchUpdateCommunityMasterResult = {
    __typename?: "BatchUpdateCommunityMasterResult";
    communitiesCreated: Scalars["Int"]["output"];
    duplicates: Scalars["Int"]["output"];
    error: Scalars["Int"]["output"];
    errorMessages: Array<Scalars["String"]["output"]>;
    message?: Maybe<Scalars["String"]["output"]>;
    skipped: Scalars["Int"]["output"];
};

export type BillableEntity = {
    __typename?: "BillableEntity";
    activatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    clientStats: ClientStats;
    deactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    demoEndedAt?: Maybe<Scalars["DateTime"]["output"]>;
    demoStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
    featureTrack: FeatureTrack;
    features: Array<TenantFeature>;
    id: Scalars["BillableEntityId"]["output"];
    internalAttributes?: Maybe<Dictionary>;
    name: Scalars["String"]["output"];
    onboardingStartedAt?: Maybe<Scalars["DateTime"]["output"]>;
    premiumActivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    premiumDeactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    regionId?: Maybe<Scalars["RegionId"]["output"]>;
    regions: Array<Region>;
    /** @deprecated Use skus */
    sku: Scalars["String"]["output"];
    skus: Array<Scalars["String"]["output"]>;
    tenantId: Scalars["TenantId"]["output"];
    users: Array<User>;
};

export type BillableEntityCreatePayload = {
    regionId: Scalars["RegionId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type BillableEntityDatePayload = {
    activatedAt?: InputMaybe<Scalars["String"]["input"]>;
    dateAdded?: InputMaybe<Scalars["String"]["input"]>;
    deactivatedAt?: InputMaybe<Scalars["String"]["input"]>;
    demoEndedAt?: InputMaybe<Scalars["String"]["input"]>;
    demoStartedAt?: InputMaybe<Scalars["String"]["input"]>;
    onboardingStartedAt?: InputMaybe<Scalars["String"]["input"]>;
    premiumActivatedAt?: InputMaybe<Scalars["String"]["input"]>;
    premiumDeactivatedAt?: InputMaybe<Scalars["String"]["input"]>;
};

export type BoundsInput = {
    northWest: CoordinatesInput;
    southEast: CoordinatesInput;
};

export type BridgeEntityResult = {
    __typename?: "BridgeEntityResult";
    allowAnswers: Scalars["Boolean"]["output"];
    defaultSelect?: Maybe<Array<AdvancedSearchSelect>>;
    fields: Array<BridgeFieldResult>;
    identifierFields: Array<Scalars["String"]["output"]>;
    layoutParents: Array<LayoutSectionParentKey>;
    name: Scalars["String"]["output"];
    preferredDisplay?: Maybe<BridgePreferredDisplay>;
    preferredFilterField?: Maybe<Scalars["String"]["output"]>;
    preferredGroupBy?: Maybe<Array<Scalars["String"]["output"]>>;
    priorityFields: Array<AdvancedSearchSelect>;
    questions: Array<BridgeQuestion>;
    relations: Array<BridgeRelationResult>;
    supportsTasks: Scalars["Boolean"]["output"];
    supportsWorkflows: Scalars["Boolean"]["output"];
    title: Scalars["String"]["output"];
};

/** Strategy to format this field */
export enum BridgeFieldFormatter {
    Computed = "Computed",
    CurrencyInCents = "CurrencyInCents",
    DateAndTime = "DateAndTime",
    Percentage = "Percentage",
    Type = "Type",
}

export type BridgeFieldResult = {
    __typename?: "BridgeFieldResult";
    aliases?: Maybe<Array<Scalars["String"]["output"]>>;
    category: Scalars["Float"]["output"];
    customListKey?: Maybe<CustomListKey>;
    dependsOn?: Maybe<Array<Scalars["String"]["output"]>>;
    formatter: BridgeFieldFormatter;
    name: Scalars["String"]["output"];
    naryValues?: Maybe<Array<BridgeNaryValueResult>>;
    questionType: Scalars["Float"]["output"];
    reportBehavior: BridgeReportBehaviorResult;
    title: Scalars["String"]["output"];
};

export type BridgeNaryValueResult = {
    __typename?: "BridgeNaryValueResult";
    label: Scalars["String"]["output"];
    value: Scalars["String"]["output"];
};

export type BridgePreferredDisplay = {
    __typename?: "BridgePreferredDisplay";
    fieldName?: Maybe<Scalars["String"]["output"]>;
    relation?: Maybe<BridgePreferredRelationDisplay>;
};

export type BridgePreferredRelationDisplay = {
    __typename?: "BridgePreferredRelationDisplay";
    name: Scalars["String"]["output"];
};

export type BridgePromptInput = {
    id: Scalars["String"]["input"];
    key: Scalars["String"]["input"];
    order: Scalars["Float"]["input"];
    title: Scalars["String"]["input"];
};

export type BridgeQuestion = {
    __typename?: "BridgeQuestion";
    annotation: Scalars["String"]["output"];
    category: Scalars["String"]["output"];
    editable: Scalars["Boolean"]["output"];
    id: Scalars["QuestionId"]["output"];
    interaction: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Float"]["output"];
    prompts?: Maybe<Array<BridgeQuestionPrompt>>;
    questionType: Scalars["String"]["output"];
    regionMask: Array<Scalars["String"]["output"]>;
    regionVisibility?: Maybe<EntityRegionVisibility>;
    rulesString?: Maybe<Scalars["String"]["output"]>;
    searchBehavior: Scalars["String"]["output"];
    source: QuestionSource;
    title: Scalars["String"]["output"];
};

export type BridgeQuestionInput = {
    annotation: Scalars["String"]["input"];
    category: Scalars["String"]["input"];
    id: Scalars["QuestionId"]["input"];
    interaction: Scalars["String"]["input"];
    key: Scalars["String"]["input"];
    order: Scalars["Float"]["input"];
    prompts?: InputMaybe<Array<BridgePromptInput>>;
    questionType: Scalars["String"]["input"];
    regionVisibility?: InputMaybe<EntityRegionVisibilityInput>;
    rulesString?: InputMaybe<Scalars["String"]["input"]>;
    title: Scalars["String"]["input"];
};

export type BridgeQuestionPrompt = {
    __typename?: "BridgeQuestionPrompt";
    annotation: Scalars["Boolean"]["output"];
    id: Scalars["PromptId"]["output"];
    key: Scalars["String"]["output"];
    order: Scalars["Float"]["output"];
    title: Scalars["String"]["output"];
};

/** Relation type */
export enum BridgeRelationKind {
    ManyToOne = "ManyToOne",
    OneToMany = "OneToMany",
    OneToOne = "OneToOne",
}

export type BridgeRelationResult = {
    __typename?: "BridgeRelationResult";
    aliases?: Maybe<Array<Scalars["String"]["output"]>>;
    kind: BridgeRelationKind;
    name: Scalars["String"]["output"];
    otherEntityName: Scalars["String"]["output"];
    selectable: Scalars["Boolean"]["output"];
    title: Scalars["String"]["output"];
};

export type BridgeReportBehaviorResult = {
    __typename?: "BridgeReportBehaviorResult";
    canAggregate: Scalars["Boolean"]["output"];
    filterable: Scalars["Boolean"]["output"];
    newReportSelectOrder?: Maybe<Scalars["Int"]["output"]>;
    selectable: Scalars["Boolean"]["output"];
    sortable: Scalars["Boolean"]["output"];
    summaryGroupable: Scalars["Boolean"]["output"];
};

export type CalculatedCrmEntity = CrmEntity & {
    __typename?: "CalculatedCrmEntity";
    contact?: Maybe<CrmEntityContact>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
};

export type CalendarEvent = {
    __typename?: "CalendarEvent";
    appLink: Scalars["String"]["output"];
    business?: Maybe<ReferenceBusiness>;
    businessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    community?: Maybe<Community>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    dateAdded: Scalars["IsoTimestamp"]["output"];
    eventDate: Scalars["CalendarDateSerialized"]["output"];
    eventDuration: Scalars["Int"]["output"];
    eventTime?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["CalendarEventId"]["output"];
    outcome?: Maybe<Scalars["String"]["output"]>;
    parentHomeCareLead?: Maybe<HomeCareLead>;
    parentId: Scalars["CalendarEventParentId"]["output"];
    parentReferenceBusiness?: Maybe<ReferenceBusiness>;
    parentReferenceContact?: Maybe<ReferenceContact>;
    privateNotes?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
    updatedAt: Scalars["IsoTimestamp"]["output"];
    userId: Scalars["UserId"]["output"];
};

export type CalendarSubscription = {
    __typename?: "CalendarSubscription";
    calendarUrl: Scalars["String"]["output"];
};

export type ClaimPhoneNumberRequest = {
    phoneNumber: Scalars["PhoneNumberE164"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type ClickedLink = {
    __typename?: "ClickedLink";
    events: Array<Scalars["String"]["output"]>;
    eventsV2?: Maybe<Array<ClickedLinkEvent>>;
    link: Scalars["String"]["output"];
    redacted?: Maybe<Scalars["Boolean"]["output"]>;
};

export type ClickedLinkEvent = {
    __typename?: "ClickedLinkEvent";
    recipient?: Maybe<Scalars["String"]["output"]>;
    timestamp: Scalars["String"]["output"];
};

/** Client */
export type Client = {
    __typename?: "Client";
    activityEntities?: Maybe<Array<Activity>>;
    additionalClientBirthday?: Maybe<Scalars["String"]["output"]>;
    additionalClientIsBirthdayFake?: Maybe<Scalars["Boolean"]["output"]>;
    additionalClientName?: Maybe<Scalars["String"]["output"]>;
    address?: Maybe<Scalars["String"]["output"]>;
    allContacts: Array<Contact>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    assignedUser?: Maybe<User>;
    assignedUserId?: Maybe<Scalars["UserId"]["output"]>;
    baseLocation?: Maybe<Coordinates>;
    bestContactEmail?: Maybe<Scalars["String"]["output"]>;
    bestContactEntity?: Maybe<ContactEntity>;
    bestContactName?: Maybe<Scalars["String"]["output"]>;
    bestContactPhone?: Maybe<Scalars["String"]["output"]>;
    bestLocationAddress?: Maybe<Scalars["String"]["output"]>;
    bestLocationCity?: Maybe<Scalars["String"]["output"]>;
    bestLocationState?: Maybe<Scalars["String"]["output"]>;
    bestLocationZip?: Maybe<Scalars["String"]["output"]>;
    birthday?: Maybe<Scalars["String"]["output"]>;
    budgetMonthly?: Maybe<Scalars["String"]["output"]>;
    budgetTotal?: Maybe<Scalars["String"]["output"]>;
    cellPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    chosenCommunity?: Maybe<Community>;
    chosenCommunityId?: Maybe<Scalars["CommunityId"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    clientCommunities: Array<ClientCommunity>;
    contactedOtherAgency?: Maybe<Scalars["Boolean"]["output"]>;
    contactedOtherAgencyNotes?: Maybe<Scalars["String"]["output"]>;
    createdBy?: Maybe<Scalars["UserId"]["output"]>;
    currentLocationNotes?: Maybe<Scalars["String"]["output"]>;
    currentLocationType?: Maybe<Scalars["String"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    dateAddedManualOverride?: Maybe<Scalars["String"]["output"]>;
    dischargeDate?: Maybe<Scalars["String"]["output"]>;
    disclosures?: Maybe<Array<Disclosure>>;
    email?: Maybe<Scalars["String"]["output"]>;
    emailOptOut?: Maybe<Scalars["Boolean"]["output"]>;
    gender?: Maybe<Scalars["String"]["output"]>;
    genericReferralSource?: Maybe<Scalars["String"]["output"]>;
    height?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["PlacementId"]["output"];
    insuranceAdditionalCoverage?: Maybe<Scalars["String"]["output"]>;
    insuranceAdditionalPhone?: Maybe<Scalars["String"]["output"]>;
    insuranceAdditionalPolicyNumber?: Maybe<Scalars["String"]["output"]>;
    insuranceCompany?: Maybe<Scalars["String"]["output"]>;
    insuranceNotes?: Maybe<Scalars["String"]["output"]>;
    insurancePhone?: Maybe<Scalars["String"]["output"]>;
    insurancePolicyNumber?: Maybe<Scalars["String"]["output"]>;
    insurancePreAuthRequired?: Maybe<Scalars["Boolean"]["output"]>;
    invoiceSentDate?: Maybe<Scalars["String"]["output"]>;
    invoices?: Maybe<Array<Invoice>>;
    isBirthdayFake?: Maybe<Scalars["Boolean"]["output"]>;
    locationName?: Maybe<Scalars["String"]["output"]>;
    maritalStatus?: Maybe<Scalars["String"]["output"]>;
    moveTimeline?: Maybe<Scalars["String"]["output"]>;
    moveTimelineActual?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    nextTask?: Maybe<Task>;
    noteEntities?: Maybe<Array<Note>>;
    otherHealthNotes?: Maybe<Scalars["String"]["output"]>;
    otherLocationNotes?: Maybe<Scalars["String"]["output"]>;
    paymentReceivedDate?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    potentialDuplicates: Array<ClientMatchResponse>;
    preferredName: Scalars["String"]["output"];
    referralBusiness?: Maybe<ReferenceBusiness>;
    referralCommunity?: Maybe<Community>;
    referralContact?: Maybe<ReferenceContact>;
    referralNotes?: Maybe<Scalars["String"]["output"]>;
    referrals: Array<Referral>;
    regionId: Scalars["RegionId"]["output"];
    serial?: Maybe<Scalars["Int"]["output"]>;
    signedAgencyAgreement?: Maybe<Scalars["Boolean"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    status: Scalars["String"]["output"];
    statusCheckLaterDate?: Maybe<Scalars["String"]["output"]>;
    statusClosedDate?: Maybe<Scalars["String"]["output"]>;
    statusIntakeCompletedDate?: Maybe<Scalars["String"]["output"]>;
    statusListItem?: Maybe<CustomListItem>;
    statusListItemId: Scalars["CustomListItemId"]["output"];
    totalInvoiceAmountCents: Scalars["Int"]["output"];
    touredPreviously?: Maybe<Scalars["Boolean"]["output"]>;
    touredPreviouslyNotes?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy?: Maybe<Scalars["UserId"]["output"]>;
    weight?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ClientCommunity = {
    __typename?: "ClientCommunity";
    community: Community;
    communityId: Scalars["CommunityId"]["output"];
    createdBy?: Maybe<Scalars["UserId"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    order?: Maybe<Scalars["Int"]["output"]>;
    placement: Client;
    placementId: Scalars["PlacementId"]["output"];
    privateNotes?: Maybe<Scalars["String"]["output"]>;
    publicNotes?: Maybe<Scalars["String"]["output"]>;
    referred: Scalars["Boolean"]["output"];
    relationship: Scalars["Int"]["output"];
    tours?: Maybe<Array<Tour>>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy?: Maybe<Scalars["UserId"]["output"]>;
};

/** client contact entity */
export type ClientContact = {
    __typename?: "ClientContact";
    /** @deprecated use placement */
    client: Client;
    /** @deprecated use placementId */
    clientId: Scalars["PlacementId"]["output"];
    contact: ContactEntity;
    contactId: Scalars["ContactId"]["output"];
    order: Scalars["Float"]["output"];
    placement: Client;
    placementId: Scalars["PlacementId"]["output"];
    powerOfAttorney?: Maybe<Array<Scalars["String"]["output"]>>;
    relationship: ClientContactRelationship;
};

export enum ClientContactRelationship {
    CareProvider = "CareProvider",
    MoreContact = "MoreContact",
}

export type ClientEntity = CrmEntity & {
    __typename?: "ClientEntity";
    contact?: Maybe<CrmEntityContact>;
    createdAt: Scalars["DateTime"]["output"];
    displayName: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type ClientIntakeFaxRecipient = {
    __typename?: "ClientIntakeFaxRecipient";
    communityId: Scalars["CommunityId"]["output"];
    communityName: Scalars["String"]["output"];
    faxNumber?: Maybe<Scalars["String"]["output"]>;
};

export type ClientMatchResponse = {
    __typename?: "ClientMatchResponse";
    assignedUser?: Maybe<User>;
    bestContactName?: Maybe<Scalars["String"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["PlacementId"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
    viewable: Scalars["Boolean"]["output"];
};

/** Client placement revenue by time period breakdown */
export type ClientPlacementRevenueResult = {
    __typename?: "ClientPlacementRevenueResult";
    segments: Array<ReportSegment>;
};

export type ClientSearchRequest = {
    archived?: InputMaybe<Scalars["Boolean"]["input"]>;
    assignedReferralUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    assignedUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    collaboratorUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    excludeStatuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
    includeStatuses?: InputMaybe<Array<Scalars["String"]["input"]>>;
    moveTimelineWindow?: InputMaybe<Scalars["String"]["input"]>;
    openClosed?: InputMaybe<Scalars["String"]["input"]>;
    /** 1-indexed page number */
    page: Scalars["Int"]["input"];
    perPage: Scalars["Int"]["input"];
    referralBusinessId?: InputMaybe<Scalars["ReferenceBusinessId"]["input"]>;
    referralCommunityId?: InputMaybe<Scalars["CommunityId"]["input"]>;
    referralContactId?: InputMaybe<Scalars["ReferenceContactId"]["input"]>;
    regionId: Scalars["RegionId"]["input"];
    relatedTo?: InputMaybe<Array<Scalars["PlacementId"]["input"]>>;
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    searchType?: InputMaybe<Scalars["String"]["input"]>;
    sort: ClientSearchSort;
    status?: InputMaybe<Scalars["String"]["input"]>;
    statusAtOrEarlier?: InputMaybe<Scalars["String"]["input"]>;
    statusAtOrLater?: InputMaybe<Scalars["String"]["input"]>;
    updatedAfter?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export enum ClientSearchSort {
    BestContactAsc = "BestContactAsc",
    BestContactDesc = "BestContactDesc",
    CreatedAtAsc = "CreatedAtAsc",
    CreatedAtDesc = "CreatedAtDesc",
    NameAsc = "NameAsc",
    NameDesc = "NameDesc",
    TaskDueAsc = "TaskDueAsc",
    TaskDueDesc = "TaskDueDesc",
    UpdatedAtAsc = "UpdatedAtAsc",
    UpdatedAtDesc = "UpdatedAtDesc",
}

export type ClientStats = {
    __typename?: "ClientStats";
    clientsLast30Days: Scalars["Int"]["output"];
    clientsLast60Days: Scalars["Int"]["output"];
    clientsLast90Days: Scalars["Int"]["output"];
};

export type ClientTransferRequest = {
    __typename?: "ClientTransferRequest";
    client: Client;
    createdBy: Scalars["UserId"]["output"];
    createdByEntity: User;
    dateAdded: Scalars["DateTime"]["output"];
    fromUserProfile: UserProfile;
    fromUserProfileId: Scalars["UserProfileId"]["output"];
    id: Scalars["ClientTransferRequestId"]["output"];
    lastEmailSentAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    note?: Maybe<Scalars["String"]["output"]>;
    placementId: Scalars["PlacementId"]["output"];
    status: ClientTransferRequestStatus;
    targetTenantId: Scalars["TenantId"]["output"];
    tenantId: Scalars["TenantId"]["output"];
    toContactId: Scalars["ReferenceContactId"]["output"];
    toUserProfile: UserProfile;
    toUserProfileId: Scalars["UserProfileId"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    updatedByEntity: User;
};

export enum ClientTransferRequestStatus {
    Accepted = "Accepted",
    Cancelled = "Cancelled",
    Pending = "Pending",
    Rejected = "Rejected",
}

/** result of getClients */
export type ClientsSearchResult = {
    __typename?: "ClientsSearchResult";
    clients: Array<Client>;
    total: Scalars["Int"]["output"];
};

/** Tenant's community instance */
export type Community = {
    __typename?: "Community";
    activityEntities?: Maybe<Array<Activity>>;
    address?: Maybe<Scalars["String"]["output"]>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    availability?: Maybe<AvailabilityObservationData>;
    caregiverRatio?: Maybe<Scalars["Float"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    communityContacts: Array<CommunityContact>;
    communityMasterId: Scalars["CommunityMasterId"]["output"];
    communityMasterVersion?: Maybe<Scalars["Int"]["output"]>;
    contacts: Array<ContactEntity>;
    contractExpiresDate?: Maybe<Scalars["DateTime"]["output"]>;
    contractIssuedDate?: Maybe<Scalars["DateTime"]["output"]>;
    contractNotes?: Maybe<Scalars["String"]["output"]>;
    contractStatus?: Maybe<Scalars["String"]["output"]>;
    county?: Maybe<Scalars["String"]["output"]>;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    depositPriceLastModified?: Maybe<Scalars["DateTime"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    emailOptOut: Scalars["Boolean"]["output"];
    evergreenCommunityId: Scalars["EvergreenCommunityId"]["output"];
    faxNumber?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    feeType?: Maybe<Scalars["String"]["output"]>;
    gender?: Maybe<Scalars["String"]["output"]>;
    googleInfo?: Maybe<CommunityGoogleInfo>;
    id: Scalars["CommunityId"]["output"];
    invoices?: Maybe<Array<Invoice>>;
    isAvailabilityAllowed: Scalars["Boolean"]["output"];
    isConnectedToEvergreen: Scalars["Boolean"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    licenseStatus?: Maybe<Scalars["String"]["output"]>;
    licenses: Array<CommunityLicense>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    mainPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    matchInfo: CommunityMatchInfo;
    monthlyPrice?: Maybe<Scalars["Float"]["output"]>;
    monthlyPriceLastModified?: Maybe<Scalars["DateTime"]["output"]>;
    moveInDeposit?: Maybe<Scalars["Float"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    noteEntities?: Maybe<Array<Note>>;
    paymentFee?: Maybe<Scalars["String"]["output"]>;
    paymentPercentage?: Maybe<Scalars["String"]["output"]>;
    paymentType?: Maybe<Scalars["String"]["output"]>;
    petDeposit?: Maybe<Scalars["String"]["output"]>;
    photoEntities: Array<Photo>;
    photos?: Maybe<Array<File>>;
    priceDetails?: Maybe<Scalars["String"]["output"]>;
    priceHighEnd?: Maybe<Scalars["Float"]["output"]>;
    priceHighEndLastModified?: Maybe<Scalars["DateTime"]["output"]>;
    pricing?: Maybe<PricingObservationData>;
    pricingNotesLastModified?: Maybe<Scalars["DateTime"]["output"]>;
    primaryContacts: Array<ContactEntity>;
    rating?: Maybe<Scalars["Float"]["output"]>;
    regionId: Scalars["RegionId"]["output"];
    secondPersonFee?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    tierListItem?: Maybe<CustomListItem>;
    unitsOrCapacity?: Maybe<Scalars["Int"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    virtualTourURL?: Maybe<Scalars["String"]["output"]>;
    website?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type CommunityContact = {
    __typename?: "CommunityContact";
    appLink: Scalars["String"]["output"];
    community: Community;
    communityId: Scalars["CommunityId"]["output"];
    contact: ContactEntity;
    contactId: Scalars["ContactId"]["output"];
    order: Scalars["Int"]["output"];
    primary: Scalars["Boolean"]["output"];
};

export type CommunityContactDto = {
    __typename?: "CommunityContactDto";
    communityId: Scalars["CommunityId"]["output"];
    contact: ContactEntity;
    contactId: Scalars["ContactId"]["output"];
    primary: Scalars["Boolean"]["output"];
    referenceContact?: Maybe<ReferenceContact>;
};

export type CommunityCoordinates = {
    __typename?: "CommunityCoordinates";
    appLink: Scalars["String"]["output"];
    contractStatus?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["CommunityId"]["output"];
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type CommunityEntity = CrmEntity & {
    __typename?: "CommunityEntity";
    contact?: Maybe<CrmEntityContact>;
    createdAt: Scalars["DateTime"]["output"];
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type CommunityFaxNumber = {
    communityId: Scalars["CommunityId"]["input"];
    faxNumber: Scalars["String"]["input"];
};

/** Community Google info */
export type CommunityGoogleInfo = {
    __typename?: "CommunityGoogleInfo";
    rating?: Maybe<Scalars["Float"]["output"]>;
    ratingCount?: Maybe<Scalars["Int"]["output"]>;
};

export type CommunityInsightsAvailability = {
    __typename?: "CommunityInsightsAvailability";
    freshness: ObservationFreshness;
    lastRequestedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    lastUpdatedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    notes?: Maybe<Scalars["String"]["output"]>;
    status: EvergreenCommunityListingAvailability;
};

export type CommunityInsightsPricing = {
    __typename?: "CommunityInsightsPricing";
    files?: Maybe<Array<ObservationFileDto>>;
    freshness: ObservationFreshness;
    lastUpdatedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    maxPrice?: Maybe<Scalars["String"]["output"]>;
    minPrice?: Maybe<Scalars["String"]["output"]>;
    notes: Scalars["String"]["output"];
};

export type CommunityInsightsResult = {
    __typename?: "CommunityInsightsResult";
    address: Scalars["String"]["output"];
    availability: CommunityInsightsAvailability;
    averageRating: Scalars["Float"]["output"];
    city: Scalars["String"]["output"];
    evergreenCommunityId: Scalars["EvergreenCommunityId"]["output"];
    googleMapsUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["EvergreenCommunityListingId"]["output"];
    lastGooglePlaceSynchronizedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    name: Scalars["String"]["output"];
    phoneNumbers?: Maybe<Array<ListingPhoneNumber>>;
    pricing?: Maybe<CommunityInsightsPricing>;
    ratingCount: Scalars["Int"]["output"];
    reviews: Array<CommunityInsightsReview>;
    state: Scalars["String"]["output"];
    website?: Maybe<Scalars["String"]["output"]>;
    zip: Scalars["String"]["output"];
};

export type CommunityInsightsReview = {
    __typename?: "CommunityInsightsReview";
    authorDisplayName: Scalars["String"]["output"];
    authorPhotoUri?: Maybe<Scalars["String"]["output"]>;
    authorUri?: Maybe<Scalars["String"]["output"]>;
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["EvergreenReviewId"]["output"];
    publishedAt: Scalars["IsoTimestamp"]["output"];
    rating: Scalars["Float"]["output"];
    source: EvergreenReviewSource;
    text: Scalars["String"]["output"];
    webUri: Scalars["String"]["output"];
};

/** Individual license record for community */
export type CommunityLicense = {
    __typename?: "CommunityLicense";
    communityId: Scalars["CommunityId"]["output"];
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    evergreenLicensesId?: Maybe<Scalars["LicenseId"]["output"]>;
    href?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["CommunityLicenseId"]["output"];
    licenseEndDate?: Maybe<Scalars["String"]["output"]>;
    licenseNumber?: Maybe<Scalars["String"]["output"]>;
    licenseStartDate?: Maybe<Scalars["String"]["output"]>;
    licensee?: Maybe<Scalars["String"]["output"]>;
    status?: Maybe<Scalars["String"]["output"]>;
    tenantId: Scalars["TenantId"]["output"];
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type CommunityLicenseInput = {
    communityId: Scalars["CommunityId"]["input"];
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    evergreenLicensesId?: InputMaybe<Scalars["LicenseId"]["input"]>;
    href?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["CommunityLicenseId"]["input"];
    licenseEndDate?: InputMaybe<Scalars["String"]["input"]>;
    licenseNumber?: InputMaybe<Scalars["String"]["input"]>;
    licenseStartDate?: InputMaybe<Scalars["String"]["input"]>;
    licensee?: InputMaybe<Scalars["String"]["input"]>;
    status?: InputMaybe<Scalars["String"]["input"]>;
    tenantId: Scalars["TenantId"]["input"];
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CommunityMarkerCollection = {
    __typename?: "CommunityMarkerCollection";
    communityClusters: Array<MapCluster>;
    communityCoordinates: Array<CommunityCoordinates>;
    /** lat/lng coordinates if applicable */
    coordinates?: Maybe<Coordinates>;
    recommendedZoom: Scalars["Float"]["output"];
};

/** Community <-> CommunityMaster match details */
export type CommunityMatchInfo = {
    __typename?: "CommunityMatchInfo";
    evergreenCommunityAliasId?: Maybe<Scalars["UUID"]["output"]>;
    evergreenLicenseId?: Maybe<Scalars["UUID"]["output"]>;
    matchRule?: Maybe<Scalars["String"]["output"]>;
    matchScore?: Maybe<Scalars["Float"]["output"]>;
    originalMatchDate?: Maybe<Scalars["String"]["output"]>;
    v2MigrationResult?: Maybe<Scalars["String"]["output"]>;
};

/** Individual community name */
export type CommunityName = {
    __typename?: "CommunityName";
    id: Scalars["CommunityId"]["output"];
    /** name of community */
    name?: Maybe<Scalars["String"]["output"]>;
};

/** All community names and IDs */
export type CommunityNamesResult = {
    __typename?: "CommunityNamesResult";
    communities: Array<CommunityName>;
};

export type CommunityOrdering = {
    communityId: Scalars["CommunityId"]["input"];
    order: Scalars["Int"]["input"];
};

/** Individual community with metadata */
export type CommunitySearchHit = {
    __typename?: "CommunitySearchHit";
    address?: Maybe<Scalars["String"]["output"]>;
    answers: Array<Answer>;
    availability?: Maybe<AvailabilityObservationData>;
    caregiverRatio?: Maybe<Scalars["Float"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    contacts: Array<ContactObject>;
    contractExpiresDate?: Maybe<Scalars["DateTime"]["output"]>;
    contractIssuedDate?: Maybe<Scalars["DateTime"]["output"]>;
    contractNotes?: Maybe<Scalars["String"]["output"]>;
    /** contractStatus */
    contractStatus?: Maybe<Scalars["String"]["output"]>;
    county?: Maybe<Scalars["String"]["output"]>;
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    deleted: Scalars["Boolean"]["output"];
    email?: Maybe<Scalars["String"]["output"]>;
    /** Alternate names from the linked Evergreen community, excluding the current community name, ordered most-recently-seen first */
    evergreenAliases: Array<Scalars["String"]["output"]>;
    feeType?: Maybe<Scalars["String"]["output"]>;
    gender?: Maybe<Scalars["String"]["output"]>;
    googleInfo?: Maybe<CommunityGoogleInfo>;
    id: Scalars["CommunityId"]["output"];
    isAvailabilityAllowed: Scalars["Boolean"]["output"];
    isConnectedToEvergreen: Scalars["Boolean"]["output"];
    /** latitude */
    lat?: Maybe<Scalars["String"]["output"]>;
    /** licenseStatus */
    licenseStatus?: Maybe<Scalars["String"]["output"]>;
    licenses?: Maybe<Array<CommunityLicense>>;
    /** longitude */
    lng?: Maybe<Scalars["String"]["output"]>;
    mainPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    /** Alternate names from the linked Evergreen community that matched the current search string */
    matchedAliases: Array<Scalars["String"]["output"]>;
    monthlyPrice?: Maybe<Scalars["String"]["output"]>;
    /** Most recent placement as CalendarDate-parseable */
    mostRecentPlacement?: Maybe<Scalars["String"]["output"]>;
    moveInDeposit?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    paymentFee?: Maybe<Scalars["String"]["output"]>;
    paymentPercentage?: Maybe<Scalars["String"]["output"]>;
    petDeposit?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    /** Count of placements */
    placements: Scalars["Int"]["output"];
    priceDetails?: Maybe<Scalars["String"]["output"]>;
    priceHighEnd?: Maybe<Scalars["String"]["output"]>;
    pricing?: Maybe<PricingObservationData>;
    primaryContacts: Array<ContactObject>;
    /** rating */
    rating?: Maybe<Scalars["Float"]["output"]>;
    referralCount: Scalars["Int"]["output"];
    regionId?: Maybe<Scalars["RegionId"]["output"]>;
    secondPersonFee?: Maybe<Scalars["String"]["output"]>;
    showInSearchResults: Scalars["Boolean"]["output"];
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    /** thumbnail */
    thumbnail?: Maybe<Scalars["String"]["output"]>;
    /** Capactity */
    unitsOrCapacity?: Maybe<Scalars["Int"]["output"]>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    url?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type CommunitySearchRangeFilter = {
    max: Scalars["Int"]["input"];
    min: Scalars["Int"]["input"];
    questionId: Scalars["QuestionId"]["input"];
};

export type CommunitySearchRequest = {
    /** geo lookup address */
    address?: InputMaybe<Scalars["String"]["input"]>;
    availability?: InputMaybe<Array<EvergreenCommunityListingAvailability>>;
    /** (advanced) Maximum number of beds */
    bedCountMax?: InputMaybe<Scalars["Int"]["input"]>;
    /** (advanced) Minimum number of beds */
    bedCountMin?: InputMaybe<Scalars["Int"]["input"]>;
    /** List of boolean answers that must be true */
    booleans?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** geo lookup bounds */
    bounds?: InputMaybe<BoundsInput>;
    /** geo lookup city */
    city?: InputMaybe<Scalars["String"]["input"]>;
    /** Only include results from this list of IDs */
    communityIdFilter?: InputMaybe<Array<Scalars["CommunityId"]["input"]>>;
    /** Contract status (comma separated) */
    contract?: InputMaybe<Scalars["String"]["input"]>;
    /** geo lookup county */
    county?: InputMaybe<Scalars["String"]["input"]>;
    /** geo lookup distance */
    distance?: InputMaybe<Scalars["Int"]["input"]>;
    gender?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Hide "showInSearchResults=false" (aka !"Allow clients to be matched with this community") hits */
    hideDontShow: Scalars["Boolean"]["input"];
    includeLicenses?: InputMaybe<Scalars["Boolean"]["input"]>;
    /** Include communities with no base price */
    includeNoPrice: Scalars["Boolean"]["input"];
    includeQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
    /** Include unrated */
    includeUnrated: Scalars["Boolean"]["input"];
    /** License status (comma separated) */
    license?: InputMaybe<Scalars["String"]["input"]>;
    /** (advanced) Matched high score */
    matchHighScore?: InputMaybe<Scalars["Int"]["input"]>;
    /** (advanced) Matched low score */
    matchLowScore?: InputMaybe<Scalars["Int"]["input"]>;
    /** (advanced) Matched rule */
    matchRule?: InputMaybe<Scalars["String"]["input"]>;
    /** geo lookup type (one of distance | zip | city | bounds | county) */
    matchType?: InputMaybe<Scalars["String"]["input"]>;
    /** List of nary values, one of which must be found for a community to be returned (format questionId:val1,val2) */
    nary?: InputMaybe<Array<Scalars["String"]["input"]>>;
    /** Page of results */
    page: Scalars["Int"]["input"];
    /** Number of results per page */
    perPage: Scalars["Int"]["input"];
    /** Price high end */
    priceMax: Scalars["Int"]["input"];
    /** Price low end */
    priceMin: Scalars["Int"]["input"];
    /** Advanced range filters */
    rangeFilters?: InputMaybe<Array<CommunitySearchRangeFilter>>;
    /** Minimum rating */
    rating: Scalars["Int"]["input"];
    /** Region for search */
    regionId: Scalars["RegionId"]["input"];
    /** Search string */
    searchString?: InputMaybe<Scalars["String"]["input"]>;
    /** Sort key ("name" | "distance" | "number" | "recent") */
    sortKey?: InputMaybe<Scalars["String"]["input"]>;
    /** geo lookup state */
    state?: InputMaybe<Scalars["String"]["input"]>;
    /** geo lookup zip */
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type CommunitySearchRequestMapComponent = {
    bounds?: InputMaybe<BoundsInput>;
    viewportHeight: Scalars["Float"]["input"];
    viewportWidth: Scalars["Float"]["input"];
    zoomLevel?: InputMaybe<Scalars["Float"]["input"]>;
};

/** Community search results */
export type CommunitySearchResult = {
    __typename?: "CommunitySearchResult";
    /** lat/lng coordinates if applicable */
    coordinates?: Maybe<Coordinates>;
    /** Deleted communities matching search (only when result count < 6) */
    deletedHits: Array<CommunitySearchHit>;
    hits: Array<CommunitySearchHit>;
    /** Total number of results */
    total: Scalars["Int"]["output"];
};

/** Community update response */
export type CommunityUpdateResult = {
    __typename?: "CommunityUpdateResult";
    propagations: Array<PropagationResult>;
};

/** User */
export type ConcreteUser = {
    __typename?: "ConcreteUser";
    /** Human readable name */
    displayName: Scalars["String"]["output"];
    /** First name for bulk emails to our users */
    friendlyFirstName: Scalars["String"]["output"];
    /** User ID */
    id: Scalars["UserId"]["output"];
};

/** ConstantContact Credential Details */
export type ConstantContactDetails = {
    __typename?: "ConstantContactDetails";
    accountId: Scalars["String"]["output"];
};

/** contact entity */
export type Contact = {
    __typename?: "Contact";
    address1?: Maybe<Scalars["String"]["output"]>;
    address2?: Maybe<Scalars["String"]["output"]>;
    cellPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    clientPowerOfAttorney?: Maybe<Array<Scalars["String"]["output"]>>;
    contactNotes?: Maybe<Scalars["String"]["output"]>;
    contactType?: Maybe<Scalars["String"]["output"]>;
    email1?: Maybe<Scalars["String"]["output"]>;
    fax?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    phone1?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    preferredName?: Maybe<Scalars["String"]["output"]>;
    relationship?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    website?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

/** contact entity */
export type ContactEntity = {
    __typename?: "ContactEntity";
    address1?: Maybe<Scalars["String"]["output"]>;
    address2?: Maybe<Scalars["String"]["output"]>;
    birthday?: Maybe<Scalars["String"]["output"]>;
    cellPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    clientContacts: Array<ClientContact>;
    clientPowerOfAttorney?: Maybe<Array<Scalars["String"]["output"]>>;
    communityContacts: Array<CommunityContact>;
    contactNotes?: Maybe<Scalars["String"]["output"]>;
    contactType?: Maybe<Scalars["String"]["output"]>;
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    email1?: Maybe<Scalars["String"]["output"]>;
    email1OptOut: Scalars["Boolean"]["output"];
    fax?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    homeCareLeadContacts: Array<HomeCareLeadContact>;
    id?: Maybe<Scalars["ContactId"]["output"]>;
    isBirthdayFake?: Maybe<Scalars["Boolean"]["output"]>;
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    phone1?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    phoneNumbers: Array<PhoneNumber>;
    preferredName?: Maybe<Scalars["String"]["output"]>;
    referenceContacts: Array<ReferenceContact>;
    relationship?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    website?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

/** contact entity */
export type ContactInput = {
    address1?: InputMaybe<Scalars["String"]["input"]>;
    address2?: InputMaybe<Scalars["String"]["input"]>;
    cellPhone?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    city?: InputMaybe<Scalars["String"]["input"]>;
    clientPowerOfAttorney?: InputMaybe<Scalars["String"]["input"]>;
    contactNotes?: InputMaybe<Scalars["String"]["input"]>;
    contactType?: InputMaybe<Scalars["String"]["input"]>;
    email1?: InputMaybe<Scalars["String"]["input"]>;
    email1OptOut?: InputMaybe<Scalars["Boolean"]["input"]>;
    fax?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    id?: InputMaybe<Scalars["ContactId"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    phone1?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    phoneNumbers?: InputMaybe<Array<PhoneNumberInput>>;
    preferredName?: InputMaybe<Scalars["String"]["input"]>;
    primary?: InputMaybe<Scalars["Boolean"]["input"]>;
    relationship?: InputMaybe<Scalars["String"]["input"]>;
    role?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    website?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

/** Individual contact */
export type ContactObject = {
    __typename?: "ContactObject";
    cellPhone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    email1?: Maybe<Scalars["String"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    phone1?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    phoneNumbers: Array<PhoneNumber>;
    role?: Maybe<Scalars["String"]["output"]>;
};

export type ContactSearchFieldMatch = {
    __typename?: "ContactSearchFieldMatch";
    email?: Maybe<Scalars["String"]["output"]>;
    phoneNumber?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    type: ContactSearchFieldMatchType;
};

export enum ContactSearchFieldMatchType {
    CellPhone = "CellPhone",
    Email = "Email",
    Fax = "Fax",
    Phone = "Phone",
}

export type ContactSearchHit = {
    __typename?: "ContactSearchHit";
    appLink: Scalars["String"]["output"];
    client?: Maybe<Client>;
    clientContact?: Maybe<ClientContact>;
    community?: Maybe<Community>;
    communityContact?: Maybe<CommunityContact>;
    contact?: Maybe<ContactEntity>;
    fieldMatches: Array<ContactSearchFieldMatch>;
    id: Scalars["String"]["output"];
    referenceBusiness?: Maybe<ReferenceBusiness>;
    referenceContact?: Maybe<ReferenceContact>;
    type: ContactSearchHitType;
};

export enum ContactSearchHitType {
    BestContact = "BestContact",
    Client = "Client",
    ClientContact = "ClientContact",
    Community = "Community",
    CommunityContact = "CommunityContact",
    ReferenceBusiness = "ReferenceBusiness",
    ReferenceContact = "ReferenceContact",
}

/** Conversation feed */
export type ConversationFeed = {
    __typename?: "ConversationFeed";
    threads: Array<ConversationThread>;
};

/** Conversation thread */
export type ConversationThread = {
    __typename?: "ConversationThread";
    contactSearchHits: Array<ContactSearchHit>;
    emailThread?: Maybe<EmailThread>;
    id: Scalars["ConversationThreadId"]["output"];
    latestTimestamp: Scalars["IsoTimestamp"]["output"];
    leadSourceEmail?: Maybe<LeadSourceEmailThread>;
    mailboxMessage?: Maybe<UserMailboxMessage>;
    ownerUserId?: Maybe<Scalars["UserId"]["output"]>;
    sentMessage?: Maybe<SentMessage>;
    smsThread?: Maybe<SmsThread>;
    type: ConversationThreadType;
    voiceCall?: Maybe<VoiceCall>;
};

export enum ConversationThreadType {
    Email = "Email",
    EmailThread = "EmailThread",
    LeadSourceEmail = "LeadSourceEmail",
    MailboxMessage = "MailboxMessage",
    Sms = "Sms",
    VoiceCall = "VoiceCall",
}

/** latitude/longitude coordinates */
export type Coordinates = {
    __typename?: "Coordinates";
    lat: Scalars["String"]["output"];
    lng: Scalars["String"]["output"];
};

export type CoordinatesInput = {
    lat: Scalars["String"]["input"];
    lng: Scalars["String"]["input"];
};

export type CreateAudienceGraphQlInput = {
    name: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type CreateClientContactInput = {
    relationship: ClientContactRelationship;
};

export type CreateContactInput = {
    clientContactParams?: InputMaybe<CreateClientContactInput>;
    homeCareLeadContactParams?: InputMaybe<CreateHomeCareLeadContactInput>;
    linkedContactId?: InputMaybe<Scalars["ContactId"]["input"]>;
    linkedEntityId: Scalars["AnswerEntityId"]["input"];
    linkedEntityType: AdvancedSearchEntityType;
    referenceContactParams?: InputMaybe<ReferenceContactInput>;
};

export type CreateCustomListItemRequest = {
    customListId: Scalars["CustomListId"]["input"];
    name: Scalars["String"]["input"];
};

export type CreateEvergreenCommunityListingRequest = {
    evergreenCommunityId: Scalars["EvergreenCommunityId"]["input"];
};

export type CreateExternalInvoiceCustomerRequest = {
    name: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type CreateHomeCareLeadContactInput = {
    relationship: HomeCareLeadContactRelationship;
};

export type CreateLayoutSectionInput = {
    entityType: Scalars["String"]["input"];
    layoutContainerId: Scalars["LayoutContainerId"]["input"];
};

export type CreateNoteInput = {
    text: Scalars["UserText"]["input"];
};

export type CreateSmtpCredentialRequest = {
    host: Scalars["String"]["input"];
    password: Scalars["String"]["input"];
    port: Scalars["Int"]["input"];
    username: Scalars["String"]["input"];
};

export type CreateTaskPayload = {
    completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    createdAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    dueDate?: InputMaybe<Scalars["String"]["input"]>;
    dueDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    involvedContactIds?: InputMaybe<Array<Scalars["ReferenceContactId"]["input"]>>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    ownerId?: InputMaybe<Scalars["UserId"]["input"]>;
    recurrenceDayOfMonth?: InputMaybe<Scalars["Float"]["input"]>;
    recurrenceDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
    recurrenceInterval?: InputMaybe<Scalars["Float"]["input"]>;
    recurrencePattern?: InputMaybe<RecurrencePattern>;
    status?: InputMaybe<Scalars["String"]["input"]>;
    taskTypeId?: InputMaybe<Scalars["TaskTypeId"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type CrmEntity = {
    contact?: Maybe<CrmEntityContact>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
};

export type CrmEntityContact = {
    __typename?: "CrmEntityContact";
    contactType: CrmEntityContactType;
    name?: Maybe<Scalars["String"]["output"]>;
    phoneNumber?: Maybe<Scalars["String"]["output"]>;
};

export enum CrmEntityContactType {
    BestContact = "BestContact",
    Cell = "Cell",
    Main = "Main",
    Other = "Other",
}

export type CustomList = {
    __typename?: "CustomList";
    categories: Array<CustomListCategory>;
    id: Scalars["CustomListId"]["output"];
    items: Array<CustomListItem>;
    key: CustomListKey;
};

export type CustomListCategory = {
    __typename?: "CustomListCategory";
    customListId: Scalars["CustomListId"]["output"];
    id: Scalars["CustomListCategoryId"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
};

export type CustomListItem = {
    __typename?: "CustomListItem";
    customListCategoryId?: Maybe<Scalars["CustomListCategoryId"]["output"]>;
    customListId: Scalars["CustomListId"]["output"];
    icon?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["CustomListItemId"]["output"];
    isArchived: Scalars["Boolean"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
    pipelineDateField?: Maybe<Scalars["String"]["output"]>;
    pipelineDateLabel?: Maybe<Scalars["String"]["output"]>;
    pipelineVisibility?: Maybe<PipelineVisibility>;
    updateBehavior: CustomListItemUpdateBehavior;
};

export enum CustomListItemUpdateBehavior {
    Full = "Full",
    Limited = "Limited",
}

export enum CustomListKey {
    ClientStatus = "ClientStatus",
    HomeCareLeadStatus = "HomeCareLeadStatus",
    ReferralSourceTier = "ReferralSourceTier",
}

export enum DayOfWeek {
    Friday = "Friday",
    Monday = "Monday",
    Saturday = "Saturday",
    Sunday = "Sunday",
    Thursday = "Thursday",
    Tuesday = "Tuesday",
    Wednesday = "Wednesday",
}

export type DeleteAudienceGraphQlInput = {
    id: Scalars["AudienceId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type DeleteClientContactResult = {
    __typename?: "DeleteClientContactResult";
    clientId: Scalars["PlacementId"]["output"];
    contactId: Scalars["ContactId"]["output"];
};

export type DeleteCommunityContactResult = {
    __typename?: "DeleteCommunityContactResult";
    communityId: Scalars["CommunityId"]["output"];
    contactId: Scalars["ContactId"]["output"];
};

export type DeleteNoteResult = {
    __typename?: "DeleteNoteResult";
    _id: Scalars["NoteId"]["output"];
};

export type DeletePhotoInput = {
    entityId: Scalars["FileEntityId"]["input"];
    id: Scalars["PhotoId"]["input"];
};

export type DeleteQuestionResult = {
    __typename?: "DeleteQuestionResult";
    questionId: Scalars["QuestionId"]["output"];
};

export type DeleteRegionSettingRequest = {
    key: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type DeleteRegionSettingsRequest = {
    keys: Array<Scalars["String"]["input"]>;
    regionId: Scalars["RegionId"]["input"];
};

export type Dictionary = {
    __typename?: "Dictionary";
    entries: Array<DictionaryEntry>;
};

export type DictionaryEntry = {
    __typename?: "DictionaryEntry";
    key: Scalars["String"]["output"];
    value?: Maybe<Scalars["String"]["output"]>;
};

/** A key-value pair. Set a key with a nullish value to unset the key. */
export type DictionaryEntryInput = {
    key: Scalars["String"]["input"];
    value?: InputMaybe<Scalars["String"]["input"]>;
};

export type DictionaryInput = {
    entries: Array<DictionaryEntryInput>;
};

export type Disclosure = {
    __typename?: "Disclosure";
    acknowledgements: Array<DisclosureAcknowledgement>;
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["DisclosureId"]["output"];
    publicUrl: Scalars["String"]["output"];
};

export type DisclosureAcknowledgement = {
    __typename?: "DisclosureAcknowledgement";
    agreed: Scalars["Boolean"]["output"];
    createdBy?: Maybe<Scalars["UserId"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    email: Scalars["String"]["output"];
    id: Scalars["DisclosureAcknowledgementId"]["output"];
    ipAddress: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    phone: Scalars["String"]["output"];
    response?: Maybe<DisclosureAcknowledgementResponse>;
};

export type DisclosureAcknowledgementInput = {
    agreed: Scalars["Boolean"]["input"];
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    email: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    phone: Scalars["String"]["input"];
    response: DisclosureAcknowledgementResponse;
};

export enum DisclosureAcknowledgementResponse {
    Agreed = "Agreed",
    Declined = "Declined",
    NotRequired = "NotRequired",
}

export type DraftSignatureRequest = {
    __typename?: "DraftSignatureRequest";
    actualRecipients: Array<SignatureRequestRecipientPayloadResponse>;
    ccRecipients: Array<SignatureRequestCcRecipient>;
    completedEmailTemplate?: Maybe<DraftSignatureRequestEmailContent>;
    draftFields?: Maybe<Array<PrefilledSignatureRequestFieldPayload>>;
    emailTemplate: DraftSignatureRequestEmailContent;
    entityType?: Maybe<AdvancedSearchEntityType>;
    potentialRecipients: Array<SignaturePotentialRecipient>;
    signatureTemplate: SignatureTemplate;
};

export type DraftSignatureRequestEmailContent = {
    __typename?: "DraftSignatureRequestEmailContent";
    attachments: Array<Scalars["FileId"]["output"]>;
    body: Scalars["String"]["output"];
    subject: Scalars["String"]["output"];
};

export type EmailContentInput = {
    attachments?: InputMaybe<Array<Scalars["FileId"]["input"]>>;
    body?: InputMaybe<Scalars["String"]["input"]>;
    subject?: InputMaybe<Scalars["String"]["input"]>;
};

export type EmailMarketingListOption = {
    __typename?: "EmailMarketingListOption";
    id: Scalars["String"]["output"];
    memberCount: Scalars["Float"]["output"];
    name: Scalars["String"]["output"];
};

export enum EmailMarketingProvider {
    ConstantContact = "ConstantContact",
    Mailchimp = "Mailchimp",
}

export type EmailOpenedTriggerConfigurationEntity = {
    __typename?: "EmailOpenedTriggerConfigurationEntity";
    activityThresholdDays: Scalars["Int"]["output"];
    entityFieldMatchers: Array<TriggerFieldMatcherEntity>;
};

export type EmailOpenedTriggerConfigurationInput = {
    activityThresholdDays: Scalars["Int"]["input"];
    entityFieldMatchers: Array<TriggerFieldMatcherEntityInput>;
};

/** Email template */
export type EmailTemplate = {
    __typename?: "EmailTemplate";
    attachments?: Maybe<Array<Scalars["FileId"]["output"]>>;
    body?: Maybe<Scalars["String"]["output"]>;
    description?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["EmailTemplateId"]["output"];
    isShared: Scalars["Boolean"]["output"];
    isSignature: Scalars["Boolean"]["output"];
    migrationVersion: Scalars["Int"]["output"];
    regionVisibility?: Maybe<EntityRegionVisibility>;
    subject?: Maybe<Scalars["String"]["output"]>;
    type: Scalars["String"]["output"];
};

/** Email thread */
export type EmailThread = {
    __typename?: "EmailThread";
    mailboxMessages: Array<UserMailboxMessage>;
    ownerUserId?: Maybe<Scalars["UserId"]["output"]>;
    sentMessages: Array<SentMessage>;
    threadId?: Maybe<Scalars["String"]["output"]>;
};

export type EntitiesWithoutActiveTasksResult = {
    __typename?: "EntitiesWithoutActiveTasksResult";
    entities: Array<CrmEntity>;
    page: Scalars["Int"]["output"];
    totalCount: Scalars["Int"]["output"];
    totalPages: Scalars["Int"]["output"];
};

export type EntityCollaboratorAdded = {
    __typename?: "EntityCollaboratorAdded";
    collaboratorId: Scalars["UserId"]["output"];
};

export type EntityCollaboratorRemoved = {
    __typename?: "EntityCollaboratorRemoved";
    collaboratorId: Scalars["UserId"]["output"];
};

export type EntityFieldChange = {
    __typename?: "EntityFieldChange";
    field: Scalars["String"]["output"];
    newStringValue?: Maybe<Scalars["String"]["output"]>;
    oldStringValue?: Maybe<Scalars["String"]["output"]>;
};

export type EntityReassign = {
    __typename?: "EntityReassign";
    from?: Maybe<Scalars["UserId"]["output"]>;
    to?: Maybe<Scalars["UserId"]["output"]>;
};

export enum EntityRegionModeOutput {
    IncludeDescendants = "IncludeDescendants",
    Inherited = "Inherited",
    LocalOnly = "LocalOnly",
}

export type EntityRegionPermission = {
    __typename?: "EntityRegionPermission";
    id: Scalars["RegionId"]["output"];
    key: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    type: EntityRegionPermissionType;
};

export enum EntityRegionPermissionType {
    Implied = "Implied",
    Member = "Member",
}

export type EntityRegionPermissions = {
    __typename?: "EntityRegionPermissions";
    editableRegions: Array<EntityRegionPermission>;
};

export type EntityRegionVisibility = {
    __typename?: "EntityRegionVisibility";
    editable: Scalars["Boolean"]["output"];
    regions: Array<EntityRegionVisibilityRegion>;
};

export type EntityRegionVisibilityInput = {
    regions: Array<EntityRegionVisibilityInputRegion>;
};

export type EntityRegionVisibilityInputRegion = {
    mode: EntityRegionModeOutput;
    regionId: Scalars["RegionId"]["input"];
};

export type EntityRegionVisibilityRegion = {
    __typename?: "EntityRegionVisibilityRegion";
    mode: EntityRegionModeOutput;
    regionId: Scalars["RegionId"]["output"];
};

/** A batch of requested changes for a specific entity */
export type EntityUpdateRequest = {
    /** ID of entity */
    id: Scalars["UUID"]["input"];
    stringUpdates?: InputMaybe<Array<StringColumnUpdate>>;
    version: Scalars["Int"]["input"];
};

export type EntityUpdatedFieldMatcherEntity = {
    __typename?: "EntityUpdatedFieldMatcherEntity";
    current?: Maybe<WorkflowTriggerFieldValueEntityValueType>;
    fieldName: Scalars["String"]["output"];
    previous?: Maybe<WorkflowTriggerFieldValueEntityValueType>;
};

export type EntityUpdatedFieldMatcherInput = {
    current?: InputMaybe<WorkflowTriggerFieldValueEntityValueTypeInput>;
    fieldName: Scalars["String"]["input"];
    previous?: InputMaybe<WorkflowTriggerFieldValueEntityValueTypeInput>;
};

export type EntityUpdatedTriggerConfigurationEntity = {
    __typename?: "EntityUpdatedTriggerConfigurationEntity";
    fieldMatchers: Array<EntityUpdatedFieldMatcherEntity>;
};

export type EntityUpdatedTriggerConfigurationInput = {
    fieldMatchers: Array<EntityUpdatedFieldMatcherInput>;
};

export type ErrorField = {
    __typename?: "ErrorField";
    message: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type ErrorResult = {
    __typename?: "ErrorResult";
    fields: Array<ErrorField>;
    message?: Maybe<Scalars["String"]["output"]>;
};

export type EventInvited = {
    __typename?: "EventInvited";
    eventId: Scalars["String"]["output"];
    eventTitle: Scalars["String"]["output"];
    method: Scalars["String"]["output"];
};

export type EventRsvp = {
    __typename?: "EventRsvp";
    eventId: Scalars["String"]["output"];
    eventTitle: Scalars["String"]["output"];
    note?: Maybe<Scalars["String"]["output"]>;
    response: Scalars["String"]["output"];
    rsvpSource: Scalars["String"]["output"];
};

export type EvergreenCommunity = {
    __typename?: "EvergreenCommunity";
    activeLicenseTypes: Array<Scalars["String"]["output"]>;
    address: Scalars["String"]["output"];
    aliases: Array<EvergreenCommunityAlias>;
    city: Scalars["String"]["output"];
    county: Scalars["String"]["output"];
    email: Scalars["String"]["output"];
    id: Scalars["EvergreenCommunityId"]["output"];
    lat?: Maybe<Scalars["String"]["output"]>;
    licensee: Scalars["String"]["output"];
    lng?: Maybe<Scalars["String"]["output"]>;
    mainPhone: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    state: Scalars["String"]["output"];
    status: EvergreenCommunityStatus;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    zip: Scalars["String"]["output"];
};

export type EvergreenCommunityAlias = {
    __typename?: "EvergreenCommunityAlias";
    id: Scalars["UUID"]["output"];
    licenses: Array<EvergreenLicense>;
    name: Scalars["String"]["output"];
    status: EvergreenCommunityStatus;
};

export type EvergreenCommunityListing = {
    __typename?: "EvergreenCommunityListing";
    amenities: Array<Scalars["String"]["output"]>;
    careServices: Array<Scalars["String"]["output"]>;
    careTypes: Array<Scalars["String"]["output"]>;
    evergreenCommunity: EvergreenCommunity;
    evergreenCommunityId: Scalars["EvergreenCommunityId"]["output"];
    googlePlace?: Maybe<GooglePlace>;
    googlePlaceId?: Maybe<Scalars["GooglePlaceId"]["output"]>;
    id: Scalars["EvergreenCommunityListingId"]["output"];
    mostRecentDataRequestUrl?: Maybe<Scalars["String"]["output"]>;
    phoneNumbers: Array<ListingPhoneNumber>;
    preferredName?: Maybe<Scalars["String"]["output"]>;
    reviews: Array<EvergreenReview>;
    slug?: Maybe<Scalars["String"]["output"]>;
    startingPrice?: Maybe<Scalars["Float"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    visibility: ListingVisibility;
    website?: Maybe<Scalars["String"]["output"]>;
};

export enum EvergreenCommunityListingAvailability {
    Available = "Available",
    Unavailable = "Unavailable",
    Unknown = "Unknown",
}

export type EvergreenCommunitySearchHit = {
    __typename?: "EvergreenCommunitySearchHit";
    address: Scalars["String"]["output"];
    aliases: Array<EvergreenCommunitySearchHitAlias>;
    city: Scalars["String"]["output"];
    county: Scalars["String"]["output"];
    id: Scalars["EvergreenCommunityId"]["output"];
    licenseTypes: Array<Scalars["String"]["output"]>;
    listings: Array<EvergreenCommunityListing>;
    name: Scalars["String"]["output"];
    state: Scalars["String"]["output"];
    status: EvergreenCommunityStatus;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
    zip: Scalars["String"]["output"];
};

export type EvergreenCommunitySearchHitAlias = {
    __typename?: "EvergreenCommunitySearchHitAlias";
    id: Scalars["UUID"]["output"];
    licenses: Array<EvergreenCommunitySearchHitLicense>;
    name: Scalars["String"]["output"];
    status: EvergreenCommunityStatus;
};

export type EvergreenCommunitySearchHitLicense = {
    __typename?: "EvergreenCommunitySearchHitLicense";
    id: Scalars["UUID"]["output"];
    jurisdiction: Scalars["String"]["output"];
    licenseNumber: Scalars["String"]["output"];
    licenseTypes: Array<Scalars["String"]["output"]>;
    status: Scalars["String"]["output"];
};

export type EvergreenCommunitySearchRequest = {
    address?: InputMaybe<Scalars["String"]["input"]>;
    county?: InputMaybe<Scalars["String"]["input"]>;
    licenseStatus?: InputMaybe<Scalars["String"]["input"]>;
    licenseType?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type EvergreenCommunitySearchResult = {
    __typename?: "EvergreenCommunitySearchResult";
    count: Scalars["Int"]["output"];
    hits: Array<EvergreenCommunitySearchHit>;
};

export enum EvergreenCommunityStatus {
    Active = "Active",
    Closed = "Closed",
    Obsolete = "Obsolete",
    Pending = "Pending",
}

export type EvergreenDataSource = {
    __typename?: "EvergreenDataSource";
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    duplicatesDetectionWindowInDays?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["UUID"]["output"];
    imports?: Maybe<Array<EvergreenImport>>;
    lastSuccessfulRun?: Maybe<Scalars["DateTime"]["output"]>;
    name: Scalars["ID"]["output"];
    updateFrequencyInDays?: Maybe<Scalars["Int"]["output"]>;
    updateRequested?: Maybe<Scalars["DateTime"]["output"]>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    warningsSilenced?: Maybe<Scalars["DateTime"]["output"]>;
    warningsSnoozeReason?: Maybe<Scalars["String"]["output"]>;
    warningsSnoozedUntil?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EvergreenDataSourceInput = {
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    duplicatesDetectionWindowInDays?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["UUID"]["input"];
    imports?: InputMaybe<Array<EvergreenImportInput>>;
    lastSuccessfulRun?: InputMaybe<Scalars["DateTime"]["input"]>;
    name: Scalars["ID"]["input"];
    updateFrequencyInDays?: InputMaybe<Scalars["Int"]["input"]>;
    updateRequested?: InputMaybe<Scalars["DateTime"]["input"]>;
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    warningsSilenced?: InputMaybe<Scalars["DateTime"]["input"]>;
    warningsSnoozeReason?: InputMaybe<Scalars["String"]["input"]>;
    warningsSnoozedUntil?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EvergreenImport = {
    __typename?: "EvergreenImport";
    created?: Maybe<Scalars["Int"]["output"]>;
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    delisted?: Maybe<Scalars["Int"]["output"]>;
    duplicates?: Maybe<Scalars["Int"]["output"]>;
    endedAt?: Maybe<Scalars["DateTime"]["output"]>;
    errors?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["UUID"]["output"];
    message?: Maybe<Scalars["String"]["output"]>;
    skips?: Maybe<Scalars["Int"]["output"]>;
    sourceName: Scalars["ID"]["output"];
    startedAt?: Maybe<Scalars["DateTime"]["output"]>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EvergreenImportInput = {
    created?: InputMaybe<Scalars["Int"]["input"]>;
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    delisted?: InputMaybe<Scalars["Int"]["input"]>;
    duplicates?: InputMaybe<Scalars["Int"]["input"]>;
    endedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    errors?: InputMaybe<Scalars["Int"]["input"]>;
    id: Scalars["UUID"]["input"];
    message?: InputMaybe<Scalars["String"]["input"]>;
    skips?: InputMaybe<Scalars["Int"]["input"]>;
    sourceName: Scalars["ID"]["input"];
    startedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EvergreenLicense = {
    __typename?: "EvergreenLicense";
    id: Scalars["UUID"]["output"];
    jurisdiction: Scalars["String"]["output"];
    licenseNumber: Scalars["String"]["output"];
    licenseTypes: Array<Scalars["String"]["output"]>;
    status: Scalars["String"]["output"];
};

export type EvergreenLicenseType = {
    __typename?: "EvergreenLicenseType";
    dateAdded?: Maybe<Scalars["DateTime"]["output"]>;
    id: Scalars["EvergreenLicenseTypeId"]["output"];
    licenseType: Scalars["String"]["output"];
    state: Scalars["String"]["output"];
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type EvergreenLicenseTypeInput = {
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    id: Scalars["EvergreenLicenseTypeId"]["input"];
    licenseType: Scalars["String"]["input"];
    state: Scalars["String"]["input"];
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type EvergreenLocation = {
    __typename?: "EvergreenLocation";
    address: Scalars["String"]["output"];
    city: Scalars["String"]["output"];
    country: Scalars["String"]["output"];
    county: Scalars["String"]["output"];
    id: Scalars["UUID"]["output"];
    lat?: Maybe<Scalars["String"]["output"]>;
    lng?: Maybe<Scalars["String"]["output"]>;
    state: Scalars["String"]["output"];
    zip: Scalars["String"]["output"];
};

export type EvergreenReview = {
    __typename?: "EvergreenReview";
    authorDisplayName: Scalars["String"]["output"];
    authorPhotoUri?: Maybe<Scalars["String"]["output"]>;
    authorUri?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["IsoTimestamp"]["output"];
    evergreenCommunityListingId: Scalars["EvergreenCommunityListingId"]["output"];
    externalId?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["EvergreenReviewId"]["output"];
    publishedAt: Scalars["IsoTimestamp"]["output"];
    rating: Scalars["Float"]["output"];
    source: EvergreenReviewSource;
    text: Scalars["String"]["output"];
    updatedAt: Scalars["IsoTimestamp"]["output"];
    webUri: Scalars["String"]["output"];
};

export enum EvergreenReviewSource {
    GooglePlaces = "GooglePlaces",
}

export enum ExternalEmailProvider {
    SendGrid = "SendGrid",
    Ses = "Ses",
}

export type ExternalInvoiceAccountPaymentTerm = {
    __typename?: "ExternalInvoiceAccountPaymentTerm";
    default: Scalars["Boolean"]["output"];
    dueDays?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type ExternalInvoiceAccountSettings = {
    __typename?: "ExternalInvoiceAccountSettings";
    paymentTerms: Array<ExternalInvoiceAccountPaymentTerm>;
};

export type ExternalInvoiceCustomer = {
    __typename?: "ExternalInvoiceCustomer";
    active: Scalars["Boolean"]["output"];
    id: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export type ExternalInvoiceCustomerSearchRequest = {
    regionId: Scalars["RegionId"]["input"];
    searchString: Scalars["String"]["input"];
};

export type ExternalInvoiceCustomerSearchResponse = {
    __typename?: "ExternalInvoiceCustomerSearchResponse";
    count: Scalars["Int"]["output"];
    hits: Array<ExternalInvoiceCustomer>;
};

export type ExternalInvoiceInitialParameters = {
    __typename?: "ExternalInvoiceInitialParameters";
    createCustomerName?: Maybe<Scalars["String"]["output"]>;
    customer?: Maybe<ExternalInvoiceCustomer>;
};

export type ExternalInvoiceInput = {
    commissions?: InputMaybe<Array<InvoiceCommissionCreateInput>>;
    customerId: Scalars["String"]["input"];
    dueDate: Scalars["String"]["input"];
    lineItems: Array<InvoiceLineItemInput>;
    message?: InputMaybe<Scalars["String"]["input"]>;
    recipients?: InputMaybe<Array<Scalars["String"]["input"]>>;
    sendOnSave?: InputMaybe<Scalars["Boolean"]["input"]>;
    termId?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalInvoiceSearchHit = {
    __typename?: "ExternalInvoiceSearchHit";
    amountInCents: Scalars["Int"]["output"];
    customer: Scalars["String"]["output"];
    dueDate: Scalars["String"]["output"];
    externalId: Scalars["String"]["output"];
    invoiceDate: Scalars["String"]["output"];
    serial: Scalars["String"]["output"];
};

export type ExternalInvoiceSearchRequest = {
    regionId: Scalars["RegionId"]["input"];
    serial?: InputMaybe<Scalars["String"]["input"]>;
};

export type ExternalInvoiceSearchResponse = {
    __typename?: "ExternalInvoiceSearchResponse";
    count: Scalars["Int"]["output"];
    hits: Array<ExternalInvoiceSearchHit>;
};

export type ExternalInvoicesCreateRequest = {
    /** Client to attach to invoice */
    clientId: Scalars["PlacementId"]["input"];
    invoices: Array<ExternalInvoiceInput>;
};

export type Feature = {
    __typename?: "Feature";
    enabled: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
};

/** Single feature description */
export type FeatureDescription = {
    __typename?: "FeatureDescription";
    actual: FeatureFlag;
    createdOn: Scalars["String"]["output"];
    description: Scalars["String"]["output"];
    friendlyTitle: Scalars["String"]["output"];
    intent: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    packageEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    skus?: Maybe<Array<Scalars["String"]["output"]>>;
};

/** FeatureFlag */
export type FeatureFlag = {
    __typename?: "FeatureFlag";
    enabled: Scalars["Boolean"]["output"];
    name: Scalars["ID"]["output"];
    status: FeatureStatus;
};

export enum FeatureStatus {
    Beta = "Beta",
    Disabled = "Disabled",
    Enabled = "Enabled",
}

export enum FeatureTrack {
    Beta = "Beta",
    Standard = "Standard",
}

export type FeaturesResult = {
    __typename?: "FeaturesResult";
    features: Array<Feature>;
};

/** Operator to use for field condition */
export enum FieldConditionOperator {
    CountEquals = "CountEquals",
    CountGreaterThan = "CountGreaterThan",
    CountGreaterThanOrEqual = "CountGreaterThanOrEqual",
    CountLessThan = "CountLessThan",
    CountLessThanOrEqual = "CountLessThanOrEqual",
    CustomListAfter = "CustomListAfter",
    CustomListAfterOrEqual = "CustomListAfterOrEqual",
    CustomListBefore = "CustomListBefore",
    CustomListBeforeOrEqual = "CustomListBeforeOrEqual",
    CustomListDoesNotEqual = "CustomListDoesNotEqual",
    CustomListEquals = "CustomListEquals",
    CustomListInCategory = "CustomListInCategory",
    DateAfter = "DateAfter",
    DateBefore = "DateBefore",
    DateMonthEquals = "DateMonthEquals",
    DateOn = "DateOn",
    DateOnOrAfter = "DateOnOrAfter",
    DateOnOrBefore = "DateOnOrBefore",
    IdEquals = "IdEquals",
    IsFalse = "IsFalse",
    IsNotSet = "IsNotSet",
    IsSet = "IsSet",
    IsTrue = "IsTrue",
    NaryContains = "NaryContains",
    NaryDoesNotContain = "NaryDoesNotContain",
    NumberEquals = "NumberEquals",
    NumberGreaterThan = "NumberGreaterThan",
    NumberGreaterThanOrEqual = "NumberGreaterThanOrEqual",
    NumberLessThan = "NumberLessThan",
    NumberLessThanOrEqual = "NumberLessThanOrEqual",
    RangeAbove = "RangeAbove",
    RangeBelow = "RangeBelow",
    RangeContains = "RangeContains",
    RangeContainsOrAbove = "RangeContainsOrAbove",
    RangeContainsOrBelow = "RangeContainsOrBelow",
    RangeDoesNotContain = "RangeDoesNotContain",
    RelationMatches = "RelationMatches",
    StringContains = "StringContains",
    StringDoesNotContain = "StringDoesNotContain",
    StringEquals = "StringEquals",
    UserIsMe = "UserIsMe",
}

/** Uploaded file */
export type File = {
    __typename?: "File";
    accessControls: Array<AccessControlResult>;
    activityEntities?: Maybe<Array<Activity>>;
    byteLength?: Maybe<Scalars["Int"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    createdBy?: Maybe<Scalars["UserId"]["output"]>;
    deleted: Scalars["Boolean"]["output"];
    description?: Maybe<Scalars["String"]["output"]>;
    entityId: Scalars["FileEntityId"]["output"];
    hasSignatureTemplate: Scalars["Boolean"]["output"];
    id: Scalars["FileId"]["output"];
    isGlobal: Scalars["Boolean"]["output"];
    managementLevel: Scalars["String"]["output"];
    mimeType?: Maybe<Scalars["String"]["output"]>;
    originalFilename?: Maybe<Scalars["String"]["output"]>;
    outstandingSignatureRequestsCount: Scalars["Int"]["output"];
    purpose: FilePurpose;
    regionVisibility?: Maybe<EntityRegionVisibility>;
    scanStatus: VirusScanStatus;
    shareWithClient: Scalars["Boolean"]["output"];
    shareWithCommunity: Scalars["Boolean"]["output"];
    shareWithHomeCareLead: Scalars["Boolean"]["output"];
    shareWithReferral: Scalars["Boolean"]["output"];
    slideShowOrder?: Maybe<Scalars["Int"]["output"]>;
    transferBusinessName?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy?: Maybe<Scalars["UserId"]["output"]>;
    uploadSource?: Maybe<UploadSource>;
};

export type FileEntityList = {
    __typename?: "FileEntityList";
    files: Array<File>;
};

export enum FileEntityType {
    Client = "Client",
    Community = "Community",
    HomeCareLead = "HomeCareLead",
    Referral = "Referral",
}

export enum FilePurpose {
    Branding = "Branding",
    File = "File",
    Photo = "Photo",
    ProfilePicture = "ProfilePicture",
    Thumbnail = "Thumbnail",
}

export type FileUpdateInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
    originalFilename: Scalars["String"]["input"];
    shareWithClient: Scalars["Boolean"]["input"];
    shareWithCommunity: Scalars["Boolean"]["input"];
    shareWithHomeCareLead: Scalars["Boolean"]["input"];
    shareWithReferral: Scalars["Boolean"]["input"];
};

/** An entry in the geocache lookup table */
export type GeoCacheEntry = {
    city?: InputMaybe<Scalars["String"]["input"]>;
    country?: InputMaybe<Scalars["String"]["input"]>;
    county?: InputMaybe<Scalars["String"]["input"]>;
    formatted_address?: InputMaybe<Scalars["String"]["input"]>;
    formatted_street?: InputMaybe<Scalars["String"]["input"]>;
    found: Scalars["Boolean"]["input"];
    lat: Scalars["String"]["input"];
    lng: Scalars["String"]["input"];
    number?: InputMaybe<Scalars["String"]["input"]>;
    predirectional?: InputMaybe<Scalars["String"]["input"]>;
    provider?: InputMaybe<Scalars["String"]["input"]>;
    search: Scalars["String"]["input"];
    source?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    street?: InputMaybe<Scalars["String"]["input"]>;
    suffix?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type GetApiKeyResponse = {
    __typename?: "GetApiKeyResponse";
    apiKey: Scalars["String"]["output"];
};

export type GetAudienceGraphQlInput = {
    id: Scalars["AudienceId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type GetAudienceRecipientsGraphQlInput = {
    audienceId: Scalars["AudienceId"]["input"];
    page: Scalars["Float"]["input"];
    pageSize: Scalars["Float"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type GetAudienceRecipientsResult = {
    __typename?: "GetAudienceRecipientsResult";
    recipients: Array<AudienceRecipient>;
    total: Scalars["Float"]["output"];
};

export type GetAudiencesGraphQlInput = {
    regionId: Scalars["RegionId"]["input"];
};

export type GetClientContactsRequest = {
    clientId: Scalars["PlacementId"]["input"];
    relationships: Array<ClientContactRelationship>;
};

export type GetClientOptions = {
    includeCommunityQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
};

export type GetEmailProviderListsInput = {
    provider: EmailMarketingProvider;
    regionId: Scalars["RegionId"]["input"];
};

export type GetEntityByIdResult = {
    __typename?: "GetEntityByIdResult";
    entity?: Maybe<AdvancedSearchResultEntity>;
};

export type GetEntityRegionPermissionsParams = {
    actionType: ActionType;
};

export type GetExternalInvoiceAccountSettingsRequest = {
    regionId: Scalars["RegionId"]["input"];
};

export type GetExternalInvoiceInitialParametersRequest = {
    clientId: Scalars["PlacementId"]["input"];
};

export type GetNotesForEntityFilter = {
    isDraft?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type GetPopularEvergreenCommunitiesRequest = {
    state: Scalars["String"]["input"];
};

export type GetPopularEvergreenCommunitiesResponse = {
    __typename?: "GetPopularEvergreenCommunitiesResponse";
    count: Scalars["Int"]["output"];
    hits: Array<PopularEvergreenCommunityHit>;
};

export type GetRegionFeaturesRequest = {
    regionId: Scalars["RegionId"]["input"];
};

export type GetRegionSettingsRequest = {
    regionId: Scalars["RegionId"]["input"];
};

export type GetSmsConversationByPhoneLineRequest = {
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
    phoneNumber: Scalars["PhoneNumberE164"]["input"];
};

export type GetSmsConversationRequest = {
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
    phoneNumber: Scalars["PhoneNumberE164"]["input"];
};

export type GetTaskResult = {
    __typename?: "GetTaskResult";
    populatedTask?: Maybe<PopulatedTask>;
};

export type GetTasksRequest = {
    completedAt: Scalars["IsoTimestamp"]["input"];
    ownerId: Scalars["UserId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type GetTelecomContactStatusRequest = {
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
    phoneNumber: Scalars["PhoneNumberE164"]["input"];
};

export type GetUsersParameters = {
    userTypes?: InputMaybe<Array<UserType>>;
};

export type GetWorkflowSettingsResult = {
    __typename?: "GetWorkflowSettingsResult";
    tenant: Array<WorkflowSettingValue>;
    user: Array<WorkflowSettingValue>;
};

/** Summary of feature flags */
export type GlobalFeaturesResponse = {
    __typename?: "GlobalFeaturesResponse";
    features: Array<FeatureDescription>;
    skus: Array<Scalars["String"]["output"]>;
};

export type GooglePlace = {
    __typename?: "GooglePlace";
    averageRating?: Maybe<Scalars["Float"]["output"]>;
    displayName?: Maybe<Scalars["String"]["output"]>;
    externalId: Scalars["String"]["output"];
    googleMapsUrl?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["GooglePlaceId"]["output"];
    phoneNumber?: Maybe<Scalars["String"]["output"]>;
    ratingCount?: Maybe<Scalars["Int"]["output"]>;
    websiteUri?: Maybe<Scalars["String"]["output"]>;
};

export type GraphqlDebugResult = {
    __typename?: "GraphqlDebugResult";
    message: Scalars["String"]["output"];
};

export type HomeCareLead = {
    __typename?: "HomeCareLead";
    activityEntities?: Maybe<Array<Activity>>;
    actualStartDate?: Maybe<Scalars["String"]["output"]>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    assignedUserId?: Maybe<Scalars["UserId"]["output"]>;
    bestContactEntity?: Maybe<ContactEntity>;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["IsoTimestamp"]["output"];
    daysNeeded?: Maybe<Array<Scalars["String"]["output"]>>;
    endOfCareDate?: Maybe<Scalars["String"]["output"]>;
    estimatedStartDate?: Maybe<Scalars["String"]["output"]>;
    genericReferralSource?: Maybe<Scalars["String"]["output"]>;
    homeCareLeadContacts?: Maybe<Array<HomeCareLeadContact>>;
    hoursPerWeek?: Maybe<Scalars["Float"]["output"]>;
    id: Scalars["HomeCareLeadId"]["output"];
    noteEntities?: Maybe<Array<Note>>;
    referralBusiness?: Maybe<ReferenceBusiness>;
    referralCommunity?: Maybe<Community>;
    referralContact?: Maybe<ReferenceContact>;
    referralNotes?: Maybe<Scalars["String"]["output"]>;
    regionId: Scalars["RegionId"]["output"];
    selfContactEntity?: Maybe<ContactEntity>;
    statusListItem?: Maybe<CustomListItem>;
    statusListItemId: Scalars["CustomListItemId"]["output"];
    updatedAt: Scalars["IsoTimestamp"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    wellSkyClientUrl?: Maybe<Scalars["String"]["output"]>;
};

/** home care lead contact entity */
export type HomeCareLeadContact = {
    __typename?: "HomeCareLeadContact";
    contact: ContactEntity;
    contactId: Scalars["ContactId"]["output"];
    homeCareLead: HomeCareLead;
    homeCareLeadId: Scalars["HomeCareLeadId"]["output"];
    order: Scalars["Float"]["output"];
    powerOfAttorney?: Maybe<Array<Scalars["String"]["output"]>>;
    relationship: HomeCareLeadContactRelationship;
};

export enum HomeCareLeadContactRelationship {
    CareProvider = "CareProvider",
    MoreContact = "MoreContact",
}

export type HomeCareLeadEntity = CrmEntity & {
    __typename?: "HomeCareLeadEntity";
    contact?: Maybe<CrmEntityContact>;
    createdAt: Scalars["DateTime"]["output"];
    displayName: Scalars["String"]["output"];
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type HostedForm = {
    __typename?: "HostedForm";
    configuration: HostedFormConfiguration;
    customizable: Scalars["Boolean"]["output"];
    dateAdded: Scalars["IsoTimestamp"]["output"];
    displayName: Scalars["String"]["output"];
    fields: Array<BridgeFieldResult>;
    id: Scalars["HostedFormId"]["output"];
    layoutSections: Array<LayoutSection>;
    name?: Maybe<Scalars["String"]["output"]>;
    questions: Array<BridgeQuestion>;
    slugs?: Maybe<Array<HostedFormSlug>>;
    url: Scalars["String"]["output"];
};

export type HostedFormAssigneeInput = {
    /** The list of users that will receive notifications when a form is submitted */
    recipientUserIds?: InputMaybe<Array<Scalars["UserId"]["input"]>>;
    regionId: Scalars["RegionId"]["input"];
    /** The user assigned to the new client */
    userId?: InputMaybe<Scalars["UserId"]["input"]>;
};

export type HostedFormConfiguration = {
    __typename?: "HostedFormConfiguration";
    entityType: Scalars["String"]["output"];
    fileUploadEnabled?: Maybe<Scalars["Boolean"]["output"]>;
    regions?: Maybe<Array<HostedFormRegionConfiguration>>;
    style?: Maybe<HostedFormStyle>;
};

export type HostedFormRegionConfiguration = {
    __typename?: "HostedFormRegionConfiguration";
    /** The list of users that will receive notifications when a form is submitted */
    recipientUserIds?: Maybe<Array<Scalars["UserId"]["output"]>>;
    regionId: Scalars["RegionId"]["output"];
    /** The user assigned to the new client */
    userId?: Maybe<Scalars["UserId"]["output"]>;
};

export type HostedFormSlug = {
    __typename?: "HostedFormSlug";
    dateAdded: Scalars["IsoTimestamp"]["output"];
    hostedFormId: Scalars["HostedFormId"]["output"];
    id: Scalars["HostedFormSlugId"]["output"];
    referenceBusinessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    referenceCommunityId?: Maybe<Scalars["CommunityId"]["output"]>;
    referenceContactId?: Maybe<Scalars["ReferenceContactId"]["output"]>;
    regionId: Scalars["RegionId"]["output"];
    slug: Scalars["String"]["output"];
};

export type HostedFormSlugCheck = {
    __typename?: "HostedFormSlugCheck";
    available: Scalars["Boolean"]["output"];
    errorMessage?: Maybe<Scalars["String"]["output"]>;
};

export type HostedFormSlugClaim = {
    hostedFormId: Scalars["HostedFormId"]["input"];
    regionId: Scalars["RegionId"]["input"];
    slug: Scalars["String"]["input"];
};

export enum HostedFormStyle {
    Embedded = "Embedded",
    Standalone = "Standalone",
}

export type HostedFormToken = {
    __typename?: "HostedFormToken";
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    expiresAt: Scalars["DateTime"]["output"];
    hostedFormId: Scalars["HostedFormId"]["output"];
    id: Scalars["HostedFormTokenId"]["output"];
    sentMessages?: Maybe<Array<SentMessage>>;
    status: HostedFormTokenStatus;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export enum HostedFormTokenStatus {
    Active = "Active",
    Completed = "Completed",
    Expired = "Expired",
}

export type Identity = {
    __typename?: "Identity";
    id: Scalars["IdentityId"]["output"];
    licenses?: Maybe<Array<License>>;
    name?: Maybe<Scalars["String"]["output"]>;
    propagateableLicenseTypes?: Maybe<Array<Scalars["String"]["output"]>>;
    successorId?: Maybe<Scalars["IdentityId"]["output"]>;
    thumbnailUrl?: Maybe<Scalars["String"]["output"]>;
};

export type IdentityFilterInput = {
    county?: InputMaybe<Scalars["String"]["input"]>;
    state: Scalars["String"]["input"];
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type IdentityFilterObject = {
    __typename?: "IdentityFilterObject";
    county?: Maybe<Scalars["String"]["output"]>;
    state: Scalars["String"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ImpliedUser = {
    __typename?: "ImpliedUser";
    user: User;
};

export type Import = {
    __typename?: "Import";
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["ImportId"]["output"];
    name: Scalars["String"]["output"];
    plan?: Maybe<ImportPlan>;
    regionId?: Maybe<Scalars["RegionId"]["output"]>;
    result?: Maybe<ImportResult>;
    runAs: Scalars["UserId"]["output"];
    status: ImportStatus;
};

export type ImportEntityResult = {
    __typename?: "ImportEntityResult";
    entityType: Scalars["String"]["output"];
    errors: Array<ImportResultError>;
    inserts: Array<ImportResultInsert>;
};

export type ImportPlan = {
    __typename?: "ImportPlan";
    errors?: Maybe<Array<ImportPlanError>>;
    inserts: Array<ImportPlanInsert>;
};

export type ImportPlanError = {
    __typename?: "ImportPlanError";
    message: Scalars["String"]["output"];
    rowNumber?: Maybe<Scalars["Float"]["output"]>;
    sheetName: Scalars["String"]["output"];
};

export type ImportPlanInsert = {
    __typename?: "ImportPlanInsert";
    entityType: Scalars["String"]["output"];
    records: Array<Scalars["String"]["output"]>;
};

export type ImportResult = {
    __typename?: "ImportResult";
    error?: Maybe<Scalars["String"]["output"]>;
    results: Array<ImportEntityResult>;
};

export type ImportResultError = {
    __typename?: "ImportResultError";
    message: Scalars["String"]["output"];
    rowNumber: Scalars["Float"]["output"];
    sheetName: Scalars["String"]["output"];
};

export type ImportResultInsert = {
    __typename?: "ImportResultInsert";
    insertedId?: Maybe<Scalars["String"]["output"]>;
    rowNumber: Scalars["Float"]["output"];
    warnings?: Maybe<Array<Scalars["String"]["output"]>>;
};

export enum ImportStatus {
    Failed = "Failed",
    Finished = "Finished",
    Planning = "Planning",
    Ready = "Ready",
    Running = "Running",
}

export type IntakeOptions = {
    dateStamp: Scalars["CalendarDateSerialized"]["input"];
    freeformNotes?: InputMaybe<Scalars["String"]["input"]>;
    includeAdditionalContacts: Scalars["Boolean"]["input"];
    includeCareProviders: Scalars["Boolean"]["input"];
    includeClientBudget: Scalars["Boolean"]["input"];
    includeClientLocation: Scalars["Boolean"]["input"];
    includeContactEmailAddrs: Scalars["Boolean"]["input"];
    includeContactLocations: Scalars["Boolean"]["input"];
    includeContactPhoneNumbers: Scalars["Boolean"]["input"];
    includeHealthInsurance: Scalars["Boolean"]["input"];
    includeMyContact: Scalars["Boolean"]["input"];
    notesOption: Scalars["String"]["input"];
    prebuiltNotes?: InputMaybe<AdditionalNotesImpl>;
};

/** Invoice for a client (and optionally a community) */
export type Invoice = {
    __typename?: "Invoice";
    amountCents: Scalars["CurrencyInCents"]["output"];
    appLink: Scalars["String"]["output"];
    clientName?: Maybe<Scalars["String"]["output"]>;
    community?: Maybe<Community>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    communityName?: Maybe<Scalars["String"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    dueDate?: Maybe<Scalars["String"]["output"]>;
    externalReference?: Maybe<Scalars["String"]["output"]>;
    fileId?: Maybe<Scalars["FileId"]["output"]>;
    hasOutstandingBalance: Scalars["Boolean"]["output"];
    id: Scalars["InvoiceId"]["output"];
    isExternallyManaged: Scalars["Boolean"]["output"];
    lineItems?: Maybe<Array<InvoiceLineItem>>;
    notes?: Maybe<Scalars["String"]["output"]>;
    paidDate?: Maybe<Scalars["String"]["output"]>;
    paymentSchedule?: Maybe<InvoicePaymentSchedule>;
    placement?: Maybe<Client>;
    placementId: Scalars["PlacementId"]["output"];
    remainingBalanceCents: Scalars["Float"]["output"];
    sentDate?: Maybe<Scalars["String"]["output"]>;
    serial: Scalars["String"]["output"];
    status: Scalars["String"]["output"];
    totalPaidCents: Scalars["Float"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type InvoiceCommissionCreateInput = {
    rateBasisPoints: Scalars["Float"]["input"];
    userId: Scalars["UserId"]["input"];
};

export enum InvoiceCreateExperience {
    External = "External",
    Internal = "Internal",
}

export type InvoiceCreateExperienceResponse = {
    __typename?: "InvoiceCreateExperienceResponse";
    experience: InvoiceCreateExperience;
};

export type InvoiceLineItem = {
    __typename?: "InvoiceLineItem";
    description: Scalars["String"]["output"];
    id: Scalars["InvoiceLineItemId"]["output"];
    quantity: Scalars["Float"]["output"];
    unitPriceInCents: Scalars["CurrencyInCents"]["output"];
};

export type InvoiceLineItemInput = {
    description: Scalars["String"]["input"];
    id: Scalars["InvoiceLineItemId"]["input"];
    quantity: Scalars["Float"]["input"];
    unitPriceInCents: Scalars["CurrencyInCents"]["input"];
};

export type InvoicePaymentSchedule = {
    __typename?: "InvoicePaymentSchedule";
    items: Array<InvoicePaymentScheduleItem>;
};

export type InvoicePaymentScheduleInput = {
    items: Array<InvoicePaymentScheduleItemInput>;
};

export type InvoicePaymentScheduleItem = {
    __typename?: "InvoicePaymentScheduleItem";
    amountInCents: Scalars["CurrencyInCents"]["output"];
    dueDate: Scalars["String"]["output"];
    id: Scalars["InvoicePaymentScheduleItemId"]["output"];
    paidDate?: Maybe<Scalars["String"]["output"]>;
    status: InvoicePaymentScheduleItemStatus;
};

export type InvoicePaymentScheduleItemInput = {
    amountInCents: Scalars["CurrencyInCents"]["input"];
    dueDate: Scalars["String"]["input"];
    id: Scalars["InvoicePaymentScheduleItemId"]["input"];
    paidDate?: InputMaybe<Scalars["String"]["input"]>;
    status: InvoicePaymentScheduleItemStatus;
};

export enum InvoicePaymentScheduleItemStatus {
    Due = "Due",
    Paid = "Paid",
}

/** Invoice creation response */
export type InvoiceResult = {
    __typename?: "InvoiceResult";
    errors?: Maybe<ErrorResult>;
    invoices?: Maybe<Array<Invoice>>;
    result: Scalars["String"]["output"];
};

/** Backend job statistics  */
export type JobStats = {
    __typename?: "JobStats";
    available: Scalars["Int"]["output"];
    complete: Scalars["Int"]["output"];
    failed: Scalars["Int"]["output"];
    pending: Scalars["Int"]["output"];
    started: Scalars["Int"]["output"];
};

export type LayoutContainer = {
    __typename?: "LayoutContainer";
    id: Scalars["LayoutContainerId"]["output"];
    key: Scalars["String"]["output"];
    layoutSections: Array<LayoutSection>;
    title: Scalars["String"]["output"];
};

/** LayoutItem */
export type LayoutItem = {
    __typename?: "LayoutItem";
    customTitle?: Maybe<Scalars["String"]["output"]>;
    entityFieldName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["LayoutItemId"]["output"];
    isRequired: Scalars["Boolean"]["output"];
    layoutSectionId: Scalars["LayoutSectionId"]["output"];
    naryFormat?: Maybe<NaryFormat>;
    order: Scalars["Int"]["output"];
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
    showIfBlank: Scalars["Boolean"]["output"];
};

export type LayoutItemInput = {
    customTitle?: InputMaybe<Scalars["String"]["input"]>;
    entityFieldName?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["LayoutItemId"]["input"];
    isRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
    naryFormat?: InputMaybe<NaryFormat>;
    order: Scalars["Int"]["input"];
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
    showIfBlank: Scalars["Boolean"]["input"];
};

/** LayoutSection */
export type LayoutSection = {
    __typename?: "LayoutSection";
    defaultStandardFields?: Maybe<Array<Scalars["String"]["output"]>>;
    entityType: Scalars["String"]["output"];
    icon?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["LayoutSectionId"]["output"];
    includeRelations?: Maybe<Array<Scalars["String"]["output"]>>;
    layoutContainerId: Scalars["LayoutContainerId"]["output"];
    layoutItems: Array<LayoutItem>;
    legacyPerspective?: Maybe<LayoutSectionLegacyPerspective>;
    order: Scalars["Int"]["output"];
    questionCategory?: Maybe<Scalars["String"]["output"]>;
    renderBehavior: SectionRenderBehaviorType;
    sectionKey: Scalars["String"]["output"];
    settings: Array<LayoutSectionSetting>;
    singlePropertyName?: Maybe<Scalars["String"]["output"]>;
    title: Scalars["String"]["output"];
    visible: Scalars["Boolean"]["output"];
};

/** The UI section where the layout item will be placed */
export enum LayoutSectionKey {
    CommunityCardKeyAttributes = "CommunityCardKeyAttributes",
    CommunityComparisonActivitiesRow = "CommunityComparisonActivitiesRow",
    CommunityComparisonAmenitiesRow = "CommunityComparisonAmenitiesRow",
    CommunityComparisonCommunityRecordsRow = "CommunityComparisonCommunityRecordsRow",
    CommunityComparisonCommunityRow = "CommunityComparisonCommunityRow",
    CommunityComparisonCommunityTypeRow = "CommunityComparisonCommunityTypeRow",
    CommunityComparisonDistanceRow = "CommunityComparisonDistanceRow",
    CommunityComparisonFinanceRow = "CommunityComparisonFinanceRow",
    CommunityComparisonHealthServicesRow = "CommunityComparisonHealthServicesRow",
    CommunityComparisonNotesRow = "CommunityComparisonNotesRow",
    CommunityComparisonOtherDetailsRow = "CommunityComparisonOtherDetailsRow",
    CommunityComparisonPhotosRow = "CommunityComparisonPhotosRow",
    CommunityComparisonPrimaryContactRow = "CommunityComparisonPrimaryContactRow",
    CommunityComparisonStaffRow = "CommunityComparisonStaffRow",
    CommunityComparisonSummaryRow = "CommunityComparisonSummaryRow",
    CommunityComparisonToursRow = "CommunityComparisonToursRow",
    CommunityDetailsCommunityContacts = "CommunityDetailsCommunityContacts",
    CommunityDetailsCommunityInfo = "CommunityDetailsCommunityInfo",
    CommunityDetailsNotes = "CommunityDetailsNotes",
    CommunityDetailsPhotos = "CommunityDetailsPhotos",
    HomeCareLeadAdditionalInformation = "HomeCareLeadAdditionalInformation",
    HomeCareLeadIntakeAdl = "HomeCareLeadIntakeAdl",
    HomeCareLeadIntakeCognition = "HomeCareLeadIntakeCognition",
    HomeCareLeadIntakeConsent = "HomeCareLeadIntakeConsent",
    HomeCareLeadIntakeExistingCare = "HomeCareLeadIntakeExistingCare",
    HomeCareLeadIntakeHomeLogistics = "HomeCareLeadIntakeHomeLogistics",
    HomeCareLeadIntakeMedical = "HomeCareLeadIntakeMedical",
    HomeCareLeadIntakePayer = "HomeCareLeadIntakePayer",
    HomeCareLeadIntakeServiceAsk = "HomeCareLeadIntakeServiceAsk",
    HomeCareLeadIntakeSituation = "HomeCareLeadIntakeSituation",
    HostedFormClientBestContact = "HostedFormClientBestContact",
    HostedFormClientClient = "HostedFormClientClient",
    HostedFormClientOther = "HostedFormClientOther",
    ReferenceBusinessAdditionalInformation = "ReferenceBusinessAdditionalInformation",
    ReferenceBusinessContactInformation = "ReferenceBusinessContactInformation",
    ReferenceContactAdditionalInformation = "ReferenceContactAdditionalInformation",
    ReferenceContactContactInformation = "ReferenceContactContactInformation",
    ReferralCommunityCardKeyAttributes = "ReferralCommunityCardKeyAttributes",
}

export enum LayoutSectionLegacyPerspective {
    Client = "Client",
    Community = "Community",
}

/** The UI section where the layout section will be placed (e.g. a document) */
export enum LayoutSectionParentKey {
    CommunityCard = "CommunityCard",
    CommunityComparisonTable = "CommunityComparisonTable",
    CommunityDetailsColumn1 = "CommunityDetailsColumn1",
    CommunityDetailsColumn2 = "CommunityDetailsColumn2",
    HomeCareLeadDetails = "HomeCareLeadDetails",
    HomeCareLeadIntakeColumn1 = "HomeCareLeadIntakeColumn1",
    HomeCareLeadIntakeColumn2 = "HomeCareLeadIntakeColumn2",
    HostedFormClient = "HostedFormClient",
    ReferenceBusiness = "ReferenceBusiness",
    ReferenceContact = "ReferenceContact",
    ReferralCommunityCard = "ReferralCommunityCard",
}

export type LayoutSectionSetting = {
    __typename?: "LayoutSectionSetting";
    id: Scalars["LayoutSectionSettingId"]["output"];
    key: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
    type: LayoutSectionSettingType;
};

export enum LayoutSectionSettingType {
    Boolean = "Boolean",
}

/** LayoutSections */
export type LayoutSectionsOutput = {
    __typename?: "LayoutSectionsOutput";
    layoutSections: Array<LayoutSection>;
};

/** Inbound lead source email that created the entity */
export type LeadSourceEmailThread = {
    __typename?: "LeadSourceEmailThread";
    fromAddress?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["InboundLeadEmailId"]["output"];
    receivedAt: Scalars["IsoTimestamp"]["output"];
    sourceName: Scalars["String"]["output"];
    subject?: Maybe<Scalars["String"]["output"]>;
};

export type License = {
    __typename?: "License";
    id: Scalars["LicenseId"]["output"];
    identity?: Maybe<Identity>;
    jurisdiction: Scalars["String"]["output"];
    licenseNumber: Scalars["String"]["output"];
    licenseType?: Maybe<Array<Scalars["String"]["output"]>>;
    publicRecords?: Maybe<Array<PublicRecord>>;
    status: Scalars["String"]["output"];
};

export type LicenseMappingInput = {
    annotationOnly?: InputMaybe<Scalars["Boolean"]["input"]>;
    licenseIdentifier: Scalars["String"]["input"];
    promptId?: InputMaybe<Scalars["PromptId"]["input"]>;
    questionId?: InputMaybe<Scalars["QuestionId"]["input"]>;
};

export type LicenseMappingObject = {
    __typename?: "LicenseMappingObject";
    annotationOnly?: Maybe<Scalars["Boolean"]["output"]>;
    licenseIdentifier: Scalars["String"]["output"];
    promptId?: Maybe<Scalars["PromptId"]["output"]>;
    questionId?: Maybe<Scalars["QuestionId"]["output"]>;
};

export type ListRentablePhoneNumbersRequest = {
    areaCode: Scalars["AreaCode"]["input"];
};

export type ListRentablePhoneNumbersResponse = {
    __typename?: "ListRentablePhoneNumbersResponse";
    phoneNumbers: Array<RentablePhoneNumber>;
    suggestedAreaCodes?: Maybe<Array<SuggestedAreaCode>>;
};

export type ListingPhoneNumber = {
    __typename?: "ListingPhoneNumber";
    label: Scalars["String"]["output"];
    number: Scalars["String"]["output"];
};

export type ListingPhoneNumberInput = {
    label: Scalars["String"]["input"];
    number: Scalars["String"]["input"];
};

export enum ListingVisibility {
    Internal = "Internal",
    Public = "Public",
}

export type LoadSavedQueryResult = {
    __typename?: "LoadSavedQueryResult";
    canSaveAdditional: Scalars["Boolean"]["output"];
    savedQueries: Array<SavedQueryResult>;
};

/** Mailchimp Credential Details */
export type MailchimpDetails = {
    __typename?: "MailchimpDetails";
    serverPrefix: Scalars["String"]["output"];
};

export type ManageableUser = {
    __typename?: "ManageableUser";
    canDisable: Scalars["Boolean"]["output"];
    user: User;
};

export type MapCluster = {
    __typename?: "MapCluster";
    count: Scalars["Float"]["output"];
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
};

export type MarkPriorSmsConsentRequest = {
    consentedAt: Scalars["IsoTimestamp"]["input"];
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
    phoneNumber: Scalars["PhoneNumberE164"]["input"];
};

/** Message compose information */
export type MessageCompose = {
    __typename?: "MessageCompose";
    files: Array<AttachmentScope>;
    recipientSuggestions: Array<Scalars["String"]["output"]>;
    recipients: Array<Scalars["String"]["output"]>;
    specialCommunityComparisonDefaults?: Maybe<SpecialCommunityComparisonDefaults>;
};

/** Level of tracking for messages */
export enum MessageTrackingLevel {
    Message = "Message",
    Recipient = "Recipient",
}

export type MessagingConfiguration = {
    __typename?: "MessagingConfiguration";
    tenant: TenantMessagingConfiguration;
    user: UserMessagingConfiguration;
};

export type Mutation = {
    __typename?: "Mutation";
    abandonSignatureRequest: Scalars["Boolean"]["output"];
    acceptClientTransfer: Client;
    addClientCommunities: Client;
    addExistingExternalInvoice: Invoice;
    addReferenceContactFromAgentDirectory: ReferenceContact;
    adminUpdateUser: User;
    batchCreateCommunityMaster: BatchUpdateCommunityMasterResult;
    billableEntityCreate: BillableEntity;
    billableEntityInternalUpdate: Scalars["Boolean"]["output"];
    bulkCreateLegacyQuestions: Array<Question>;
    bulkUpdateEvergreenLocations: Array<EvergreenLocation>;
    bulkUpdateIdentities: Array<Identity>;
    cancelClientTransfer: Scalars["Boolean"]["output"];
    cancelWorkflowExecution: WorkflowExecution;
    claimHostedFormSlug: Scalars["Boolean"]["output"];
    claimPhoneNumber: TelecomPhoneLine;
    cloneUser: Scalars["Boolean"]["output"];
    createAudience: AudienceResult;
    createClient: Client;
    createClientReferral: Referral;
    createCommunitiesInAllRegions: Scalars["Boolean"]["output"];
    createCommunitiesInRegion: CommunityUpdateResult;
    createCommunityLicense: CommunityLicense;
    createContact: ContactEntity;
    createCustomListItem: CustomListItem;
    createDisclosure: Disclosure;
    createDisclosureAcknowledgement: DisclosureAcknowledgement;
    createEvergreenCommunityListing: Scalars["Boolean"]["output"];
    createExternalInvoiceCustomer: ExternalInvoiceCustomer;
    createExternalInvoices: InvoiceResult;
    createHostedForm: HostedForm;
    createInvoice: InvoiceResult;
    createLayoutSection: LayoutSection;
    createNote: NoteDto;
    createOrUpdateRegionLicenseMap: RegionLicenseMap;
    createOrUpdateTemplate: TemplateResponse;
    createReferenceBusiness: ReferenceBusiness;
    createReferenceContact: ReferenceContact;
    createSavedQuery: SavedQueryResult;
    createSignatureRequest: SignatureRequest;
    createSmtpCredential: SmtpSaveResult;
    createTask: Task;
    createTenantHistoryEntry: TenantHistory;
    createTenantRegion: Tenant;
    createUser: User;
    createWorkflow: Workflow;
    createWorkflowForTenant: Workflow;
    deleteAudience: Scalars["Boolean"]["output"];
    deleteClientContact: DeleteClientContactResult;
    deleteClientMatches: Client;
    deleteCommunityContact: DeleteCommunityContactResult;
    deleteCommunityLicense: Scalars["Boolean"]["output"];
    deleteEvergreenCommunityListing: Scalars["Boolean"]["output"];
    deleteEvergreenLicenseType: Scalars["Boolean"]["output"];
    deleteFile: Scalars["Boolean"]["output"];
    deleteHostedForm: Scalars["Boolean"]["output"];
    deleteHostedFormSlug: Scalars["Boolean"]["output"];
    deleteHostedFormToken: Scalars["Boolean"]["output"];
    deleteInvoice: Scalars["Boolean"]["output"];
    deleteLayoutSection: Scalars["Boolean"]["output"];
    deleteNote: DeleteNoteResult;
    deletePhoto: Scalars["Boolean"]["output"];
    deleteQuestion: DeleteQuestionResult;
    deleteRegionLicenseMap: Scalars["Boolean"]["output"];
    deleteRegionSetting: Scalars["Boolean"]["output"];
    deleteRegionSettings: Scalars["Boolean"]["output"];
    deleteSavedQuery: Scalars["Boolean"]["output"];
    deleteSavedQuerySchedule: Scalars["Boolean"]["output"];
    deleteSignatureTemplate: SignatureTemplateDeleteResponse;
    deleteSmtpCredentialForUser: Scalars["Boolean"]["output"];
    deleteTask: Scalars["Boolean"]["output"];
    deleteTemplate: Scalars["Boolean"]["output"];
    deleteTenantCredential: Scalars["Boolean"]["output"];
    deleteUserMailbox: Scalars["Boolean"]["output"];
    deleteUserTerritory: Scalars["Boolean"]["output"];
    deleteWorkflow: Scalars["Boolean"]["output"];
    deleteWorkflowForTenant: Scalars["Boolean"]["output"];
    destroyPermission: Scalars["Boolean"]["output"];
    detachAdditionalClient: Scalars["PlacementId"]["output"];
    disableSpecificTwoFactorMethod: Scalars["Boolean"]["output"];
    findOrCreateCommunityInsights?: Maybe<CommunityInsightsResult>;
    findOrCreateCommunityInsightsMany?: Maybe<Array<CommunityInsightsResult>>;
    generateEvergreenCommunityInsights: Scalars["Boolean"]["output"];
    generateInvoice: InvoiceResult;
    geocodeReferenceBusinesses: Scalars["Boolean"]["output"];
    logVoiceCall: Scalars["VoiceCallId"]["output"];
    markPriorSmsConsent: Scalars["Boolean"]["output"];
    modifyUserRole: Scalars["Boolean"]["output"];
    patchClientReferral: Referral;
    patchContact: ContactEntity;
    patchCustomListItem: CustomListItem;
    patchCustomListItems: Array<CustomListItem>;
    patchEvergreenCommunityListing: EvergreenCommunityListing;
    patchHostedForm: HostedForm;
    patchLayoutItem: LayoutItem;
    patchLayoutSection: LayoutSection;
    patchLayoutSections: Array<LayoutSection>;
    patchPhoto: Photo;
    patchPhotos: Array<Photo>;
    patchReferenceBusiness: ReferenceBusiness;
    patchReferenceContact: ReferenceContact;
    patchUserProfile: UserProfile;
    populateGeoCache: PopulateGeoCacheResult;
    promoteCommunityContact: CommunityContactDto;
    putRegionSetting: Scalars["Boolean"]["output"];
    putRegionSettings: Scalars["Boolean"]["output"];
    putTenantSetting: Scalars["Boolean"]["output"];
    regenerateEvergreenListingSlugs: Scalars["Boolean"]["output"];
    rejectClientTransfer: Scalars["Boolean"]["output"];
    releasePhoneNumber: Scalars["Boolean"]["output"];
    relocateImage: RelocateImageResponse;
    removeClientCommunities: Client;
    reorderLegacyQuestions: Scalars["Boolean"]["output"];
    requestClientTransfer: Scalars["Boolean"]["output"];
    requestCommunityListingParticipation: SendMessageResult;
    requestCommunityListingUpdate: SendMessageResult;
    requestVoiceToken: VoiceToken;
    resendClientTransfer: Scalars["Boolean"]["output"];
    resendInvoice: InvoiceResult;
    resendSignatureRequest: Scalars["Boolean"]["output"];
    resetTenant: Scalars["Boolean"]["output"];
    restoreCommunity: Scalars["Boolean"]["output"];
    scheduleImport: Import;
    sendClientIntakeFax: Scalars["Boolean"]["output"];
    sendHostedFormWithPermalink: Scalars["Boolean"]["output"];
    sendHostedFormWithToken: SendHostedFormWithTokenResponse;
    sendMessage: SendMessageResult;
    sendSavedQueryEmail: Scalars["Boolean"]["output"];
    sendSms: Scalars["Boolean"]["output"];
    sendTwoFactorCode: Scalars["Boolean"]["output"];
    setCommunityOrder: Client;
    setEntityAnswer: Answer;
    setSignatureTemplate: SignatureTemplate;
    setWorkflowSetting: Scalars["Boolean"]["output"];
    setupTwoFactor: TwoFactorSetupResult;
    superuserAccountRecovery: Scalars["Boolean"]["output"];
    superuserResetPassword: SuperuserResetPasswordResult;
    superuserUpdateUser: User;
    synchronizeEvergreenListingWithGooglePlace: Scalars["Boolean"]["output"];
    trackExternalSignupRequest: Scalars["Boolean"]["output"];
    triggerAudienceSync: AudienceLatestSyncResult;
    updateAudience: AudienceResult;
    updateCommunityLicense: Scalars["Boolean"]["output"];
    updateEvergreenDataSource: EvergreenDataSource;
    updateEvergreenImport: EvergreenImport;
    updateEvergreenLicenseType: EvergreenLicenseType;
    updateFeatureFlag: FeatureFlag;
    updateFile: File;
    updateGooglePlace: Scalars["Boolean"]["output"];
    updateInvoice: InvoiceResult;
    updateNote: NoteDto;
    updateQueryFavoriteStatus: Scalars["Boolean"]["output"];
    updateRegion: Region;
    updateSavedQuery: SavedQueryResult;
    updateTask: Task;
    updateTenant: Tenant;
    updateToken: Token;
    updateWorkflow: Workflow;
    updateWorkflowForTenant: Workflow;
    upsertEntityQuestion: BridgeQuestion;
    upsertSavedQuerySchedule: SavedQueryScheduleResult;
    upsertUserTerritory: UserTerritory;
    userManagementCreateSystemUser: Scalars["Boolean"]["output"];
    userManagementCreateUser: Scalars["Boolean"]["output"];
    userManagementDisableUser: Scalars["Boolean"]["output"];
    userManagementEnableUser: Scalars["Boolean"]["output"];
    userManagementHideUser: Scalars["Boolean"]["output"];
    userManagementShowUser: Scalars["Boolean"]["output"];
    userManagementUpdatePermission: Scalars["Boolean"]["output"];
    verifySetupCode: TwoFactorVerificationResult;
};

export type MutationAbandonSignatureRequestArgs = {
    signatureRequestId: Scalars["SignatureRequestId"]["input"];
};

export type MutationAcceptClientTransferArgs = {
    clientTransferRequestId: Scalars["ClientTransferRequestId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type MutationAddClientCommunitiesArgs = {
    clientId: Scalars["PlacementId"]["input"];
    includeCommunityQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
    params: Array<AddClientCommunityRequest>;
};

export type MutationAddExistingExternalInvoiceArgs = {
    params: AddExternalInvoiceRequest;
};

export type MutationAddReferenceContactFromAgentDirectoryArgs = {
    regionId: Scalars["RegionId"]["input"];
    userProfileId: Scalars["UserProfileId"]["input"];
};

export type MutationAdminUpdateUserArgs = {
    name: Scalars["String"]["input"];
    userId: Scalars["UserId"]["input"];
};

export type MutationBatchCreateCommunityMasterArgs = {
    communities: Array<PublicRecordInput>;
};

export type MutationBillableEntityCreateArgs = {
    params: BillableEntityCreatePayload;
};

export type MutationBillableEntityInternalUpdateArgs = {
    billableEntityId: Scalars["BillableEntityId"]["input"];
    dates?: InputMaybe<BillableEntityDatePayload>;
    featureTrack?: InputMaybe<FeatureTrack>;
    features?: InputMaybe<Array<Scalars["String"]["input"]>>;
    internalAttributes?: InputMaybe<DictionaryInput>;
    sku?: InputMaybe<Scalars["String"]["input"]>;
    skus?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type MutationBulkCreateLegacyQuestionsArgs = {
    bulkPayload: QuestionBulkCreatePayload;
};

export type MutationBulkUpdateEvergreenLocationsArgs = {
    updates: Array<EntityUpdateRequest>;
};

export type MutationBulkUpdateIdentitiesArgs = {
    updates: Array<EntityUpdateRequest>;
};

export type MutationCancelClientTransferArgs = {
    clientTransferRequestId: Scalars["ClientTransferRequestId"]["input"];
};

export type MutationCancelWorkflowExecutionArgs = {
    workflowExecutionId: Scalars["WorkflowExecutionId"]["input"];
};

export type MutationClaimHostedFormSlugArgs = {
    claim: HostedFormSlugClaim;
};

export type MutationClaimPhoneNumberArgs = {
    request: ClaimPhoneNumberRequest;
};

export type MutationCloneUserArgs = {
    tenantId: Scalars["TenantId"]["input"];
    userId: Scalars["UserId"]["input"];
};

export type MutationCreateAudienceArgs = {
    input: CreateAudienceGraphQlInput;
};

export type MutationCreateClientArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type MutationCreateClientReferralArgs = {
    clientId: Scalars["PlacementId"]["input"];
    referralType: Scalars["String"]["input"];
};

export type MutationCreateCommunitiesInRegionArgs = {
    regionId: Scalars["RegionId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationCreateCommunityLicenseArgs = {
    communityId: Scalars["CommunityId"]["input"];
};

export type MutationCreateContactArgs = {
    params: CreateContactInput;
};

export type MutationCreateCustomListItemArgs = {
    params: CreateCustomListItemRequest;
};

export type MutationCreateDisclosureArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type MutationCreateDisclosureAcknowledgementArgs = {
    acknowledgement: DisclosureAcknowledgementInput;
    disclosureId: Scalars["DisclosureId"]["input"];
};

export type MutationCreateEvergreenCommunityListingArgs = {
    params: CreateEvergreenCommunityListingRequest;
};

export type MutationCreateExternalInvoiceCustomerArgs = {
    params: CreateExternalInvoiceCustomerRequest;
};

export type MutationCreateExternalInvoicesArgs = {
    params: ExternalInvoicesCreateRequest;
};

export type MutationCreateInvoiceArgs = {
    amountCents: Scalars["CurrencyInCents"]["input"];
    clientId: Scalars["PlacementId"]["input"];
    commissions?: InputMaybe<Array<InvoiceCommissionCreateInput>>;
    dueDate?: InputMaybe<Scalars["String"]["input"]>;
    externalReference?: InputMaybe<Scalars["String"]["input"]>;
    generatePdf: Scalars["Boolean"]["input"];
    lineItems?: InputMaybe<Array<InvoiceLineItemInput>>;
    message?: InputMaybe<OutboundMessage>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    paymentSchedule?: InputMaybe<InvoicePaymentScheduleInput>;
    requireCommunity?: InputMaybe<Scalars["Boolean"]["input"]>;
    sentDate?: InputMaybe<Scalars["String"]["input"]>;
    serial?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["String"]["input"];
};

export type MutationCreateLayoutSectionArgs = {
    params: CreateLayoutSectionInput;
};

export type MutationCreateNoteArgs = {
    entityId: Scalars["NoteEntityId"]["input"];
    entityType: Scalars["String"]["input"];
    params: CreateNoteInput;
};

export type MutationCreateOrUpdateRegionLicenseMapArgs = {
    params: RegionLicenseMapUpdateRequest;
};

export type MutationCreateOrUpdateTemplateArgs = {
    template: TemplateUpdate;
};

export type MutationCreateReferenceBusinessArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type MutationCreateReferenceContactArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type MutationCreateSavedQueryArgs = {
    savedQuery: SavedQueryInput;
};

export type MutationCreateSignatureRequestArgs = {
    signatureRequestPayload: SignatureRequestPayload;
};

export type MutationCreateSmtpCredentialArgs = {
    params: CreateSmtpCredentialRequest;
};

export type MutationCreateTaskArgs = {
    params: CreateTaskPayload;
    parentId: Scalars["TaskParentId"]["input"];
};

export type MutationCreateTenantHistoryEntryArgs = {
    message: Scalars["String"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationCreateTenantRegionArgs = {
    key: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationCreateUserArgs = {
    email: Scalars["String"]["input"];
    password: Scalars["String"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationCreateWorkflowArgs = {
    workflow: WorkflowPayload;
};

export type MutationCreateWorkflowForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
    workflow: WorkflowPayload;
};

export type MutationDeleteAudienceArgs = {
    input: DeleteAudienceGraphQlInput;
};

export type MutationDeleteClientContactArgs = {
    clientId: Scalars["PlacementId"]["input"];
    contactId: Scalars["ContactId"]["input"];
    relationship: ClientContactRelationship;
};

export type MutationDeleteClientMatchesArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type MutationDeleteCommunityContactArgs = {
    communityId: Scalars["CommunityId"]["input"];
    contactId: Scalars["ContactId"]["input"];
};

export type MutationDeleteCommunityLicenseArgs = {
    communityId: Scalars["CommunityId"]["input"];
    licenseId: Scalars["CommunityLicenseId"]["input"];
};

export type MutationDeleteEvergreenCommunityListingArgs = {
    id: Scalars["EvergreenCommunityListingId"]["input"];
};

export type MutationDeleteEvergreenLicenseTypeArgs = {
    licenseTypeId: Scalars["EvergreenLicenseTypeId"]["input"];
};

export type MutationDeleteFileArgs = {
    fileId: Scalars["FileId"]["input"];
};

export type MutationDeleteHostedFormArgs = {
    hostedFormId: Scalars["HostedFormId"]["input"];
};

export type MutationDeleteHostedFormSlugArgs = {
    hostedFormSlugId: Scalars["HostedFormSlugId"]["input"];
};

export type MutationDeleteHostedFormTokenArgs = {
    tokenId: Scalars["HostedFormTokenId"]["input"];
};

export type MutationDeleteInvoiceArgs = {
    invoiceId: Scalars["InvoiceId"]["input"];
};

export type MutationDeleteLayoutSectionArgs = {
    id: Scalars["LayoutSectionId"]["input"];
};

export type MutationDeleteNoteArgs = {
    entityId: Scalars["NoteEntityId"]["input"];
    entityType: Scalars["String"]["input"];
    noteId: Scalars["NoteId"]["input"];
};

export type MutationDeletePhotoArgs = {
    params: DeletePhotoInput;
};

export type MutationDeleteQuestionArgs = {
    questionId: Scalars["QuestionId"]["input"];
};

export type MutationDeleteRegionLicenseMapArgs = {
    regionLicenseMapId: Scalars["RegionLicenseMapId"]["input"];
};

export type MutationDeleteRegionSettingArgs = {
    params: DeleteRegionSettingRequest;
};

export type MutationDeleteRegionSettingsArgs = {
    params: DeleteRegionSettingsRequest;
};

export type MutationDeleteSavedQueryArgs = {
    savedQueryId: Scalars["SavedQueryId"]["input"];
};

export type MutationDeleteSavedQueryScheduleArgs = {
    savedQueryId: Scalars["SavedQueryId"]["input"];
};

export type MutationDeleteSignatureTemplateArgs = {
    signatureTemplateId: Scalars["SignatureTemplateId"]["input"];
};

export type MutationDeleteTaskArgs = {
    taskId: Scalars["TaskId"]["input"];
};

export type MutationDeleteTemplateArgs = {
    emailTemplateId: Scalars["EmailTemplateId"]["input"];
};

export type MutationDeleteTenantCredentialArgs = {
    id: Scalars["TenantCredentialId"]["input"];
};

export type MutationDeleteUserMailboxArgs = {
    id: Scalars["UserMailboxId"]["input"];
};

export type MutationDeleteUserTerritoryArgs = {
    id: Scalars["UserTerritoryId"]["input"];
};

export type MutationDeleteWorkflowArgs = {
    workflowId: Scalars["WorkflowId"]["input"];
};

export type MutationDeleteWorkflowForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
    workflowId: Scalars["WorkflowId"]["input"];
};

export type MutationDestroyPermissionArgs = {
    id: Scalars["UUID"]["input"];
};

export type MutationDetachAdditionalClientArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type MutationDisableSpecificTwoFactorMethodArgs = {
    method: TwoFactorMethod;
    password: Scalars["String"]["input"];
};

export type MutationFindOrCreateCommunityInsightsArgs = {
    communityId: Scalars["CommunityId"]["input"];
};

export type MutationFindOrCreateCommunityInsightsManyArgs = {
    communityIds: Array<Scalars["CommunityId"]["input"]>;
};

export type MutationGenerateEvergreenCommunityInsightsArgs = {
    id: Scalars["EvergreenCommunityId"]["input"];
};

export type MutationGenerateInvoiceArgs = {
    invoiceId: Scalars["InvoiceId"]["input"];
};

export type MutationLogVoiceCallArgs = {
    activityTypeId?: InputMaybe<Scalars["TaskTypeId"]["input"]>;
    entityId: Scalars["ActivityParentEntityId"]["input"];
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
    phoneNumber: Scalars["String"]["input"];
};

export type MutationMarkPriorSmsConsentArgs = {
    request: MarkPriorSmsConsentRequest;
};

export type MutationModifyUserRoleArgs = {
    regionKey: Scalars["ID"]["input"];
    role?: InputMaybe<Scalars["String"]["input"]>;
    tenantId: Scalars["TenantId"]["input"];
    userId: Scalars["UserId"]["input"];
};

export type MutationPatchClientReferralArgs = {
    clientId: Scalars["PlacementId"]["input"];
    communityId?: InputMaybe<Scalars["CommunityId"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["ReferralId"]["input"];
    notes?: InputMaybe<Scalars["String"]["input"]>;
    referenceBusinessId?: InputMaybe<Scalars["ReferenceBusinessId"]["input"]>;
    referenceContactId?: InputMaybe<Scalars["ReferenceContactId"]["input"]>;
    when?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type MutationPatchContactArgs = {
    params: PatchContactInput;
};

export type MutationPatchCustomListItemArgs = {
    params: PatchCustomListItemRequest;
};

export type MutationPatchCustomListItemsArgs = {
    params: Array<PatchCustomListItemRequest>;
};

export type MutationPatchEvergreenCommunityListingArgs = {
    params: PatchEvergreenCommunityListingRequest;
};

export type MutationPatchHostedFormArgs = {
    params: PatchHostedFormRequest;
};

export type MutationPatchLayoutItemArgs = {
    params: PatchLayoutItemInput;
};

export type MutationPatchLayoutSectionArgs = {
    params: PatchLayoutSectionInput;
};

export type MutationPatchLayoutSectionsArgs = {
    params: PatchLayoutSectionsInput;
};

export type MutationPatchPhotoArgs = {
    params: PatchPhotoInput;
};

export type MutationPatchPhotosArgs = {
    params: Array<PatchPhotoInput>;
};

export type MutationPatchReferenceBusinessArgs = {
    bestDaysToVisit?: InputMaybe<Array<Scalars["String"]["input"]>>;
    bestTimeToContact?: InputMaybe<Array<Scalars["String"]["input"]>>;
    businessContactEntity?: InputMaybe<ContactInput>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    draftNote?: InputMaybe<Scalars["String"]["input"]>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ReferenceBusinessId"]["input"];
    ownerId?: InputMaybe<Scalars["UserId"]["input"]>;
    showInSearchResults?: InputMaybe<Scalars["Boolean"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPatchReferenceContactArgs = {
    bestDaysToVisit?: InputMaybe<Array<Scalars["String"]["input"]>>;
    bestTimeToContact?: InputMaybe<Array<Scalars["String"]["input"]>>;
    businessId?: InputMaybe<Scalars["ReferenceBusinessId"]["input"]>;
    communityId?: InputMaybe<Scalars["CommunityId"]["input"]>;
    contactEntity?: InputMaybe<ContactInput>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    draftNote?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["ReferenceContactId"]["input"];
    ownerId?: InputMaybe<Scalars["UserId"]["input"]>;
    showInSearchResults?: InputMaybe<Scalars["Boolean"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type MutationPatchUserProfileArgs = {
    params: PatchUserProfileRequest;
};

export type MutationPopulateGeoCacheArgs = {
    entries: Array<GeoCacheEntry>;
};

export type MutationPromoteCommunityContactArgs = {
    communityId: Scalars["CommunityId"]["input"];
    contactId: Scalars["ContactId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type MutationPutRegionSettingArgs = {
    params: PutRegionSettingRequest;
};

export type MutationPutRegionSettingsArgs = {
    params: PutRegionSettingsRequest;
};

export type MutationPutTenantSettingArgs = {
    params: PutTenantSettingRequest;
};

export type MutationRejectClientTransferArgs = {
    clientTransferRequestId: Scalars["ClientTransferRequestId"]["input"];
};

export type MutationReleasePhoneNumberArgs = {
    id: Scalars["TelecomPhoneLineId"]["input"];
};

export type MutationRelocateImageArgs = {
    payload: RelocateImageInput;
};

export type MutationRemoveClientCommunitiesArgs = {
    clientId: Scalars["PlacementId"]["input"];
    params: Array<RemoveClientCommunityRequest>;
};

export type MutationReorderLegacyQuestionsArgs = {
    questionReorderPayload: QuestionReorderPayload;
};

export type MutationRequestClientTransferArgs = {
    params: TransferClientRequest;
};

export type MutationRequestCommunityListingParticipationArgs = {
    communityId: Scalars["CommunityId"]["input"];
    observationFocus?: InputMaybe<ObservationKind>;
    outboundMessage: OutboundMessage;
};

export type MutationRequestCommunityListingUpdateArgs = {
    communityId: Scalars["CommunityId"]["input"];
    message: PredeterminedRecipientMessage;
    observationFocus: ObservationKind;
};

export type MutationRequestVoiceTokenArgs = {
    phoneLineId: Scalars["TelecomPhoneLineId"]["input"];
};

export type MutationResendClientTransferArgs = {
    clientTransferRequestId: Scalars["ClientTransferRequestId"]["input"];
};

export type MutationResendInvoiceArgs = {
    invoiceId: Scalars["InvoiceId"]["input"];
    message: OutboundMessage;
};

export type MutationResendSignatureRequestArgs = {
    signatureRequestId: Scalars["SignatureRequestId"]["input"];
};

export type MutationResetTenantArgs = {
    options: ResetTenantOptions;
};

export type MutationRestoreCommunityArgs = {
    communityId: Scalars["CommunityId"]["input"];
};

export type MutationScheduleImportArgs = {
    importId: Scalars["ImportId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationSendClientIntakeFaxArgs = {
    message: OutboundClientIntakeFax;
};

export type MutationSendHostedFormWithPermalinkArgs = {
    params: SendHostedFormWithPermalinkRequest;
};

export type MutationSendHostedFormWithTokenArgs = {
    params: SendHostedFormWithTokenRequest;
};

export type MutationSendMessageArgs = {
    message: OutboundMessage;
};

export type MutationSendSavedQueryEmailArgs = {
    payload: SavedQuerySendEmailInput;
};

export type MutationSendSmsArgs = {
    request: SendSmsRequest;
};

export type MutationSendTwoFactorCodeArgs = {
    input: TwoFactorSendCodeInput;
};

export type MutationSetCommunityOrderArgs = {
    clientId: Scalars["PlacementId"]["input"];
    includeCommunityQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
    ordering: Array<CommunityOrdering>;
};

export type MutationSetEntityAnswerArgs = {
    answer: AnswerInput;
    entityId: Scalars["AnswerEntityId"]["input"];
};

export type MutationSetSignatureTemplateArgs = {
    fileId: Scalars["FileId"]["input"];
    signatureTemplate: SignatureTemplateInput;
};

export type MutationSetWorkflowSettingArgs = {
    params: SetWorkflowSettingInput;
};

export type MutationSetupTwoFactorArgs = {
    input: TwoFactorSetupInput;
};

export type MutationSuperuserAccountRecoveryArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationSuperuserResetPasswordArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationSuperuserUpdateUserArgs = {
    disabled: Scalars["Boolean"]["input"];
    email: Scalars["String"]["input"];
    firstName?: InputMaybe<Scalars["String"]["input"]>;
    hidden: Scalars["Boolean"]["input"];
    hideSmtpWarning: Scalars["Boolean"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    userId: Scalars["UserId"]["input"];
};

export type MutationSynchronizeEvergreenListingWithGooglePlaceArgs = {
    id: Scalars["EvergreenCommunityListingId"]["input"];
};

export type MutationTrackExternalSignupRequestArgs = {
    params: TrackExternalSignupRequestInput;
};

export type MutationTriggerAudienceSyncArgs = {
    input: TriggerAudienceSyncGraphQlInput;
};

export type MutationUpdateAudienceArgs = {
    input: UpdateAudienceGraphQlInput;
};

export type MutationUpdateCommunityLicenseArgs = {
    license: CommunityLicenseInput;
    licenseId: Scalars["CommunityLicenseId"]["input"];
};

export type MutationUpdateEvergreenDataSourceArgs = {
    input: EvergreenDataSourceInput;
};

export type MutationUpdateEvergreenImportArgs = {
    input: EvergreenImportInput;
};

export type MutationUpdateEvergreenLicenseTypeArgs = {
    input: EvergreenLicenseTypeInput;
};

export type MutationUpdateFeatureFlagArgs = {
    name: Scalars["ID"]["input"];
    status: FeatureStatus;
};

export type MutationUpdateFileArgs = {
    accessControls?: InputMaybe<Array<AccessControlInput>>;
    details: FileUpdateInput;
    fileId: Scalars["FileId"]["input"];
    regionVisibility?: InputMaybe<EntityRegionVisibilityInput>;
};

export type MutationUpdateGooglePlaceArgs = {
    externalId: Scalars["String"]["input"];
    id: Scalars["EvergreenCommunityListingId"]["input"];
};

export type MutationUpdateInvoiceArgs = {
    amountCents: Scalars["CurrencyInCents"]["input"];
    dueDate?: InputMaybe<Scalars["String"]["input"]>;
    externalReference?: InputMaybe<Scalars["String"]["input"]>;
    invoiceId: Scalars["InvoiceId"]["input"];
    lineItems?: InputMaybe<Array<InvoiceLineItemInput>>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    paidDate?: InputMaybe<Scalars["String"]["input"]>;
    paymentSchedule?: InputMaybe<InvoicePaymentScheduleInput>;
    sentDate?: InputMaybe<Scalars["String"]["input"]>;
    serial?: InputMaybe<Scalars["String"]["input"]>;
    status: Scalars["String"]["input"];
};

export type MutationUpdateNoteArgs = {
    entityId: Scalars["NoteEntityId"]["input"];
    noteId: Scalars["NoteId"]["input"];
    params: UpdateNoteInput;
};

export type MutationUpdateQueryFavoriteStatusArgs = {
    isFavorite: Scalars["Boolean"]["input"];
    savedQueryId: Scalars["SavedQueryId"]["input"];
};

export type MutationUpdateRegionArgs = {
    name?: InputMaybe<Scalars["String"]["input"]>;
    parentRegionId?: InputMaybe<Scalars["RegionId"]["input"]>;
    regionId: Scalars["RegionId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type MutationUpdateSavedQueryArgs = {
    savedQuery: SavedQueryInput;
};

export type MutationUpdateTaskArgs = {
    params: UpdateTaskPayload;
    taskId: Scalars["TaskId"]["input"];
};

export type MutationUpdateTenantArgs = {
    baaDocumentUrl?: InputMaybe<Scalars["String"]["input"]>;
    baaEnforced?: InputMaybe<Scalars["Boolean"]["input"]>;
    communicationAcknowledgmentUrl?: InputMaybe<Scalars["String"]["input"]>;
    customAppDomain?: InputMaybe<Scalars["String"]["input"]>;
    customDomains?: InputMaybe<Array<Scalars["String"]["input"]>>;
    customProductName?: InputMaybe<Scalars["String"]["input"]>;
    dateAdded?: InputMaybe<Scalars["String"]["input"]>;
    emailProvider?: InputMaybe<ExternalEmailProvider>;
    features?: InputMaybe<Array<Scalars["String"]["input"]>>;
    franchiseManagementEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["TenantId"]["input"];
    internalEmailSender?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    sku?: InputMaybe<Scalars["String"]["input"]>;
    skus?: InputMaybe<Array<Scalars["String"]["input"]>>;
    supportEmailAddress?: InputMaybe<Scalars["String"]["input"]>;
    whiteLabelContentMode?: InputMaybe<WhiteLabelContentMode>;
};

export type MutationUpdateTokenArgs = {
    updateRequest: UpdateTokenRequest;
};

export type MutationUpdateWorkflowArgs = {
    workflow: WorkflowPayload;
    workflowId: Scalars["WorkflowId"]["input"];
};

export type MutationUpdateWorkflowForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
    workflow: WorkflowPayload;
    workflowId: Scalars["WorkflowId"]["input"];
};

export type MutationUpsertEntityQuestionArgs = {
    entityType: Scalars["String"]["input"];
    question: BridgeQuestionInput;
};

export type MutationUpsertSavedQueryScheduleArgs = {
    schedule: SavedQueryScheduleInput;
};

export type MutationUpsertUserTerritoryArgs = {
    params: UpsertUserTerritoryRequest;
};

export type MutationUserManagementCreateSystemUserArgs = {
    name: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
    roleKey: Scalars["String"]["input"];
};

export type MutationUserManagementCreateUserArgs = {
    regionId: Scalars["RegionId"]["input"];
    roleKey: Scalars["String"]["input"];
    userEmail: Scalars["String"]["input"];
};

export type MutationUserManagementDisableUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationUserManagementEnableUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationUserManagementHideUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationUserManagementShowUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type MutationUserManagementUpdatePermissionArgs = {
    regionId: Scalars["RegionId"]["input"];
    roleKey?: InputMaybe<Scalars["String"]["input"]>;
    userId: Scalars["UserId"]["input"];
};

export type MutationVerifySetupCodeArgs = {
    input: TwoFactorSetupCodeInput;
};

export enum NaryFormat {
    OnePerLine = "OnePerLine",
    SemicolonSeparated = "SemicolonSeparated",
}

export type Note = {
    __typename?: "Note";
    activityEntities?: Maybe<Array<Activity>>;
    client?: Maybe<Client>;
    community?: Maybe<Community>;
    createdAt: Scalars["DateTime"]["output"];
    createdAtOverride?: Maybe<Scalars["DateTime"]["output"]>;
    createdBy: Scalars["UserId"]["output"];
    createdByEntity: User;
    effectiveCreatedAt: Scalars["DateTime"]["output"];
    entityId: Scalars["NoteEntityId"]["output"];
    homeCareLead?: Maybe<HomeCareLead>;
    id: Scalars["NoteId"]["output"];
    isPinned: Scalars["Boolean"]["output"];
    publishedAt?: Maybe<Scalars["DateTime"]["output"]>;
    referenceBusiness?: Maybe<ReferenceBusiness>;
    referenceContact?: Maybe<ReferenceContact>;
    text: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export type NoteDto = {
    __typename?: "NoteDto";
    _id: Scalars["NoteId"]["output"];
    authorId: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    editorId: Scalars["UserId"]["output"];
    isDraft: Scalars["Boolean"]["output"];
    isPinned: Scalars["Boolean"]["output"];
    text: Scalars["String"]["output"];
    transferBusinessName?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    wasEdited: Scalars["Boolean"]["output"];
};

export type NoteTriggerConfigurationEntity = {
    __typename?: "NoteTriggerConfigurationEntity";
    entityFieldMatchers: Array<TriggerFieldMatcherEntity>;
};

export type NoteTriggerConfigurationInput = {
    entityFieldMatchers: Array<TriggerFieldMatcherEntityInput>;
};

/** Observation file */
export type ObservationFileDto = {
    __typename?: "ObservationFileDto";
    downloadUrl: Scalars["String"]["output"];
    id: Scalars["FileId"]["output"];
    mimeType: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    size?: Maybe<Scalars["Int"]["output"]>;
};

export enum ObservationFreshness {
    Expired = "Expired",
    Fresh = "Fresh",
    Stale = "Stale",
    Unknown = "Unknown",
}

export enum ObservationKind {
    Availability = "Availability",
    Pricing = "Pricing",
}

export type OrganizationCoordinates = {
    __typename?: "OrganizationCoordinates";
    appLink?: Maybe<Scalars["String"]["output"]>;
    entityType: AdvancedSearchEntityType;
    id: Scalars["OrganizationId"]["output"];
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type OrganizationMembership = {
    __typename?: "OrganizationMembership";
    memberReferenceContactId: Scalars["ReferenceContactId"]["output"];
    organizationId: Scalars["ActivityParentEntityId"]["output"];
    organizationType: Scalars["String"]["output"];
};

export type OutboundClientIntakeFax = {
    clientId: Scalars["PlacementId"]["input"];
    coverPageTemplateId?: InputMaybe<Scalars["EmailTemplateId"]["input"]>;
    options: IntakeOptions;
    recipients: Array<CommunityFaxNumber>;
};

/** Outbound email composed from within app */
export type OutboundMessage = {
    activityTypeId?: InputMaybe<Scalars["TaskTypeId"]["input"]>;
    attachmentIds: Array<Scalars["FileId"]["input"]>;
    bccMyself: Scalars["Boolean"]["input"];
    body: Scalars["String"]["input"];
    cc?: InputMaybe<Array<Scalars["String"]["input"]>>;
    entityId: Scalars["EmailEntityId"]["input"];
    inReplyToSentMessageId?: InputMaybe<Scalars["SentMessageId"]["input"]>;
    inReplyToUserMailboxMessageId?: InputMaybe<Scalars["UserMailboxMessageId"]["input"]>;
    recipients: Array<Scalars["String"]["input"]>;
    replyAction?: InputMaybe<ReplyAction>;
    specialCommunityComparison?: InputMaybe<OutboundMessageSpecialCommunityComparison>;
    subject: Scalars["String"]["input"];
};

/** Community comparison outbound message details */
export type OutboundMessageSpecialCommunityComparison = {
    coverPageTemplate?: InputMaybe<Scalars["EmailTemplateId"]["input"]>;
    includeLiveLink: Scalars["Boolean"]["input"];
    includePDF: Scalars["Boolean"]["input"];
    sectionKeys?: InputMaybe<Array<LayoutSectionKey>>;
    showCommunityRecords: Scalars["Boolean"]["input"];
    showCoverPage: Scalars["Boolean"]["input"];
    showFinancialDetails: Scalars["Boolean"]["input"];
    showPrimaryContacts: Scalars["Boolean"]["input"];
};

export type OutgoingCall = {
    __typename?: "OutgoingCall";
    fromPhoneNumber: Scalars["String"]["output"];
    phoneNumber: Scalars["String"]["output"];
};

export type PaginatedSignatureRequests = {
    __typename?: "PaginatedSignatureRequests";
    page: Scalars["Int"]["output"];
    signatureRequests: Array<PopulatedSignatureRequest>;
    total: Scalars["Int"]["output"];
};

export type PatchAttachedReferenceContactInput = {
    communityId?: InputMaybe<Scalars["CommunityId"]["input"]>;
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    regionId: Scalars["RegionId"]["input"];
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchClientContactInput = {
    clientId: Scalars["PlacementId"]["input"];
    powerOfAttorney?: InputMaybe<Array<Scalars["String"]["input"]>>;
    relationship: ClientContactRelationship;
};

export type PatchCommunityContactInput = {
    communityId: Scalars["CommunityId"]["input"];
    primary?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PatchContactInput = {
    address1?: InputMaybe<Scalars["String"]["input"]>;
    address2?: InputMaybe<Scalars["String"]["input"]>;
    cellPhone?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    city?: InputMaybe<Scalars["String"]["input"]>;
    clientContacts?: InputMaybe<Array<PatchClientContactInput>>;
    communityContacts?: InputMaybe<Array<PatchCommunityContactInput>>;
    contactNotes?: InputMaybe<Scalars["String"]["input"]>;
    contactType?: InputMaybe<Scalars["String"]["input"]>;
    email1?: InputMaybe<Scalars["String"]["input"]>;
    email1OptOut?: InputMaybe<Scalars["Boolean"]["input"]>;
    fax?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    homeCareLeadContacts?: InputMaybe<Array<PatchHomeCareLeadContactInput>>;
    id: Scalars["ContactId"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    phone1?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    preferredName?: InputMaybe<Scalars["String"]["input"]>;
    referenceContacts?: InputMaybe<Array<PatchAttachedReferenceContactInput>>;
    relationship?: InputMaybe<Scalars["String"]["input"]>;
    role?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
    website?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchCustomListItemRequest = {
    categoryId?: InputMaybe<Scalars["CustomListCategoryId"]["input"]>;
    icon?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["CustomListItemId"]["input"];
    isArchived?: InputMaybe<Scalars["Boolean"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    pipelineVisibility?: InputMaybe<PipelineVisibility>;
};

export type PatchEvergreenCommunityListingRequest = {
    amenities?: InputMaybe<Array<Scalars["String"]["input"]>>;
    careServices?: InputMaybe<Array<Scalars["String"]["input"]>>;
    careTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    id: Scalars["EvergreenCommunityListingId"]["input"];
    phoneNumbers?: InputMaybe<Array<ListingPhoneNumberInput>>;
    preferredName?: InputMaybe<Scalars["String"]["input"]>;
    slug?: InputMaybe<Scalars["String"]["input"]>;
    startingPrice?: InputMaybe<Scalars["Float"]["input"]>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<ListingVisibility>;
    website?: InputMaybe<Scalars["String"]["input"]>;
};

export type PatchHomeCareLeadContactInput = {
    homeCareLeadId: Scalars["HomeCareLeadId"]["input"];
    powerOfAttorney?: InputMaybe<Array<Scalars["String"]["input"]>>;
    relationship: HomeCareLeadContactRelationship;
};

export type PatchHostedFormRequest = {
    fileUploadEnabled?: InputMaybe<Scalars["Boolean"]["input"]>;
    id: Scalars["HostedFormId"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    regions?: InputMaybe<Array<HostedFormAssigneeInput>>;
    style?: InputMaybe<HostedFormStyle>;
};

export type PatchLayoutItemInput = {
    customTitle?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["LayoutItemId"]["input"];
    isRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PatchLayoutSectionInput = {
    icon?: InputMaybe<Scalars["String"]["input"]>;
    id: Scalars["LayoutSectionId"]["input"];
    layoutItems?: InputMaybe<Array<LayoutItemInput>>;
    order?: InputMaybe<Scalars["Int"]["input"]>;
    title?: InputMaybe<Scalars["String"]["input"]>;
    visible?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type PatchLayoutSectionsInput = {
    layoutSections: Array<PatchLayoutSectionInput>;
};

export type PatchPhotoInput = {
    entityId: Scalars["FileEntityId"]["input"];
    id: Scalars["PhotoId"]["input"];
    order?: InputMaybe<Scalars["Int"]["input"]>;
    originalFile?: InputMaybe<PhotoFileInput>;
};

export type PatchUserProfileRequest = {
    approach?: InputMaybe<Scalars["String"]["input"]>;
    businessName?: InputMaybe<Scalars["String"]["input"]>;
    certifications?: InputMaybe<Array<Scalars["String"]["input"]>>;
    email?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    phone?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
    status?: InputMaybe<UserProfileStatus>;
    summary?: InputMaybe<Scalars["String"]["input"]>;
    website?: InputMaybe<Scalars["String"]["input"]>;
};

export type Permission = {
    __typename?: "Permission";
    deletedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    id: Scalars["UUID"]["output"];
    region: Region;
    role: Scalars["String"]["output"];
};

/** User/role mapping */
export type PermissionRecord = {
    __typename?: "PermissionRecord";
    deletedAt?: Maybe<Scalars["IsoTimestamp"]["output"]>;
    id: Scalars["UUID"]["output"];
    role: Scalars["String"]["output"];
    userId: Scalars["UserId"]["output"];
};

/** contact phone number */
export type PhoneNumber = {
    __typename?: "PhoneNumber";
    id?: Maybe<Scalars["UUID"]["output"]>;
    isPrimary: Scalars["Boolean"]["output"];
    number?: Maybe<Scalars["String"]["output"]>;
    phoneNumberType?: Maybe<Scalars["Float"]["output"]>;
};

export type PhoneNumberInput = {
    id?: InputMaybe<Scalars["UUID"]["input"]>;
    isPrimary: Scalars["Boolean"]["input"];
    number?: InputMaybe<Scalars["String"]["input"]>;
    phoneNumberType?: InputMaybe<Scalars["Float"]["input"]>;
};

export type Photo = {
    __typename?: "Photo";
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    entityId: Scalars["FileEntityId"]["output"];
    id: Scalars["PhotoId"]["output"];
    order: Scalars["Int"]["output"];
    originalFile: File;
    originalFileId: Scalars["FileId"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    variations: Array<Scalars["FileId"]["output"]>;
};

export type PhotoFileInput = {
    description?: InputMaybe<Scalars["String"]["input"]>;
};

export type PipelineStageChange = {
    __typename?: "PipelineStageChange";
    fromStageName?: Maybe<Scalars["String"]["output"]>;
    pipelineName: Scalars["String"]["output"];
    toStageName?: Maybe<Scalars["String"]["output"]>;
};

export type PipelineStageChangedTriggerConfigurationEntity = {
    __typename?: "PipelineStageChangedTriggerConfigurationEntity";
    pipelineId: Scalars["PipelineId"]["output"];
    toStageIds: Array<Scalars["PipelineStageId"]["output"]>;
};

export type PipelineStageChangedTriggerConfigurationInput = {
    pipelineId: Scalars["PipelineId"]["input"];
    toStageIds: Array<Scalars["PipelineStageId"]["input"]>;
};

export enum PipelineVisibility {
    Hide = "Hide",
    Show = "Show",
}

export type PopularEvergreenCommunityHit = {
    __typename?: "PopularEvergreenCommunityHit";
    community: EvergreenCommunitySearchHit;
    placementCount: Scalars["Int"]["output"];
};

export type PopulateGeoCacheResult = {
    __typename?: "PopulateGeoCacheResult";
    count: Scalars["Int"]["output"];
};

export type PopulatedSignatureRequest = {
    __typename?: "PopulatedSignatureRequest";
    entity: CrmEntity;
    signatureRequest: SignatureRequest;
};

export type PopulatedTask = {
    __typename?: "PopulatedTask";
    entity: CrmEntity;
    task: Task;
};

export type PopulatedTaskSet = {
    __typename?: "PopulatedTaskSet";
    page: Scalars["Int"]["output"];
    tasks: Array<PopulatedTask>;
    totalPages: Scalars["Int"]["output"];
};

/** Outbound email message where recipients are predetermined by the system */
export type PredeterminedRecipientMessage = {
    attachmentIds: Array<Scalars["FileId"]["input"]>;
    body: Scalars["String"]["input"];
    entityId: Scalars["EmailEntityId"]["input"];
    subject: Scalars["String"]["input"];
};

export type PrefilledSignatureRequestFieldPayload = {
    __typename?: "PrefilledSignatureRequestFieldPayload";
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    isRequired?: Maybe<Scalars["Boolean"]["output"]>;
    placeholder?: Maybe<Scalars["String"]["output"]>;
    signatureTemplateFieldId: Scalars["SignatureTemplateFieldId"]["output"];
    textValue?: Maybe<Scalars["String"]["output"]>;
};

/** Pricing observation data */
export type PricingObservationData = {
    __typename?: "PricingObservationData";
    files?: Maybe<Array<ObservationFileDto>>;
    maxPrice?: Maybe<Scalars["String"]["output"]>;
    minPrice?: Maybe<Scalars["String"]["output"]>;
    notes?: Maybe<Scalars["String"]["output"]>;
};

export type Prompt = {
    __typename?: "Prompt";
    client?: Maybe<Scalars["String"]["output"]>;
    community?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["PromptId"]["output"];
    key: Scalars["String"]["output"];
    order?: Maybe<Scalars["Int"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

/** Propagation information */
export type PropagationResult = {
    __typename?: "PropagationResult";
    communitiesCreated: Scalars["Float"]["output"];
    communitiesMatched: Scalars["Float"]["output"];
    communitiesWithExistingLinks: Scalars["Float"]["output"];
    regionLicenseMapId: Scalars["RegionLicenseMapId"]["output"];
};

export type ProviderSync = {
    __typename?: "ProviderSync";
    latestSyncResult?: Maybe<AudienceLatestSyncResult>;
    tag?: Maybe<Scalars["String"]["output"]>;
};

export type PublicRecord = {
    __typename?: "PublicRecord";
    address: Scalars["String"]["output"];
    administrator: Scalars["String"]["output"];
    capacity: Scalars["Float"]["output"];
    city: Scalars["String"]["output"];
    closedDate: Scalars["String"]["output"];
    contacts?: Maybe<Array<ContactEntity>>;
    country: Scalars["String"]["output"];
    county: Scalars["String"]["output"];
    dataSourceName?: Maybe<Scalars["String"]["output"]>;
    email: Scalars["String"]["output"];
    id?: Maybe<Scalars["PublicRecordId"]["output"]>;
    lastSeenImportId?: Maybe<Scalars["UUID"]["output"]>;
    lat?: Maybe<Scalars["String"]["output"]>;
    license?: Maybe<License>;
    licenseDate: Scalars["String"]["output"];
    licenseNumber: Scalars["String"]["output"];
    licenseStatus: Scalars["String"]["output"];
    licenseType: Array<Scalars["String"]["output"]>;
    licenseUrl: Scalars["String"]["output"];
    licensee: Scalars["String"]["output"];
    lng?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    phone: Scalars["String"]["output"];
    publicRecordContacts?: Maybe<Array<PublicRecordContact>>;
    state: Scalars["String"]["output"];
    syntheticLicenseNumber: Scalars["Boolean"]["output"];
    zip: Scalars["String"]["output"];
};

/** public record contact entity */
export type PublicRecordContact = {
    __typename?: "PublicRecordContact";
    address1?: Maybe<Scalars["String"]["output"]>;
    address2?: Maybe<Scalars["String"]["output"]>;
    cellPhone?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    contactNotes?: Maybe<Scalars["String"]["output"]>;
    email1?: Maybe<Scalars["String"]["output"]>;
    fax?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["PublicRecordContactId"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    phone1?: Maybe<Scalars["String"]["output"]>;
    primary: Scalars["Boolean"]["output"];
    relationship?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    website?: Maybe<Scalars["String"]["output"]>;
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type PublicRecordInput = {
    address?: Scalars["String"]["input"];
    administrator?: Scalars["String"]["input"];
    capacity?: Scalars["Float"]["input"];
    city?: Scalars["String"]["input"];
    closedDate?: Scalars["String"]["input"];
    contacts: Array<ContactInput>;
    country?: Scalars["String"]["input"];
    county?: Scalars["String"]["input"];
    dataSourceName?: InputMaybe<Scalars["String"]["input"]>;
    email?: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["PublicRecordId"]["input"]>;
    lastSeenImportId?: InputMaybe<Scalars["String"]["input"]>;
    licenseDate?: Scalars["String"]["input"];
    licenseNumber?: Scalars["String"]["input"];
    licenseStatus?: Scalars["String"]["input"];
    licenseType: Array<Scalars["String"]["input"]>;
    licenseUrl?: Scalars["String"]["input"];
    licensee?: Scalars["String"]["input"];
    name?: Scalars["String"]["input"];
    phone?: Scalars["String"]["input"];
    state?: Scalars["String"]["input"];
    syntheticLicenseNumber?: Scalars["Boolean"]["input"];
    zip?: Scalars["String"]["input"];
};

export type PublicRecordSearchRequest = {
    address?: InputMaybe<Scalars["String"]["input"]>;
    county?: InputMaybe<Scalars["String"]["input"]>;
    licenseStatus?: InputMaybe<Scalars["String"]["input"]>;
    licenseType?: InputMaybe<Scalars["String"]["input"]>;
    name?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type PublicRecordSearchResult = {
    __typename?: "PublicRecordSearchResult";
    count: Scalars["Int"]["output"];
    records: Array<PublicRecord>;
};

export type PutRegionSettingRequest = {
    key: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
    value: SettingValueInput;
};

export type PutRegionSettingsRequest = {
    regionId: Scalars["RegionId"]["input"];
    settings: Array<PutRegionSettingsRequestKeyValue>;
};

export type PutRegionSettingsRequestKeyValue = {
    key: Scalars["String"]["input"];
    value: SettingValueInput;
};

export type PutTenantSettingRequest = {
    key: Scalars["String"]["input"];
    tenantId: Scalars["TenantId"]["input"];
    value: SettingValueInput;
};

export type Query = {
    __typename?: "Query";
    advancedSearch: AdvancedSearchResult;
    canCreateSignatureTemplate: SignatureCreatePermission;
    checkHostedFormSlug: HostedFormSlugCheck;
    communityNames: CommunityNamesResult;
    communitySearch: CommunitySearchResult;
    communitySearchMapView: CommunityMarkerCollection;
    composeMessage: MessageCompose;
    doTestRequest: TestResponse;
    evergreenCommunitySearch: EvergreenCommunitySearchResult;
    findClientTransferRequestByClientId?: Maybe<ClientTransferRequest>;
    findEvergreenCommunityListingBySlug?: Maybe<EvergreenCommunityListing>;
    getActivityFeed: ActivityFeed;
    getAllSignatureRequests: PaginatedSignatureRequests;
    getAudience: AudienceResult;
    getAudienceRecipients: GetAudienceRecipientsResult;
    getAudiences: Array<AudienceResult>;
    getAuditableEvents: Array<AuditRecord>;
    getBillableEntities: Array<BillableEntity>;
    getBillableEntitiesWithoutWaveCustomer: Array<BillableEntity>;
    getBillableEntity: BillableEntity;
    getCalendarSubscription: CalendarSubscription;
    getClient: Client;
    getClientContacts: Array<ClientContact>;
    getClientIntakeFaxRecipients: Array<ClientIntakeFaxRecipient>;
    getClientReferrals: Array<Referral>;
    getClients: ClientsSearchResult;
    getCommunity: Community;
    getCommunityContacts: Array<CommunityContactDto>;
    getContact: ContactEntity;
    getConversationFeedForEntity: ConversationFeed;
    getCurrentUser: User;
    getCustomList: CustomList;
    getCustomLists: Array<CustomList>;
    getDraftSignatureRequest: DraftSignatureRequest;
    getEmailProviderLists: Array<EmailMarketingListOption>;
    getEntities: Array<BridgeEntityResult>;
    getEntitiesForTenant: Array<BridgeEntityResult>;
    getEntitiesWithoutActiveTasksPaginated: EntitiesWithoutActiveTasksResult;
    getEntityById: GetEntityByIdResult;
    getEntityRegionPermissions: EntityRegionPermissions;
    getEvergreenCommunity?: Maybe<EvergreenCommunity>;
    getEvergreenDataSource: EvergreenDataSource;
    getEvergreenDataSources: Array<EvergreenDataSource>;
    getEvergreenDataSourcesForUpdate: Array<EvergreenDataSource>;
    getEvergreenImports: Array<EvergreenImport>;
    getEvergreenLicenseTypes: Array<EvergreenLicenseType>;
    getEvergreenLocationsWithoutThumbnail: Array<EvergreenLocation>;
    getExternalInvoiceAccountSettings: ExternalInvoiceAccountSettings;
    getExternalInvoiceInitialParameters: ExternalInvoiceInitialParameters;
    getFeaturesForRegion: FeaturesResult;
    getFile: File;
    getFiles: FileEntityList;
    getGlobalFeatures: GlobalFeaturesResponse;
    getHostedFormById: HostedForm;
    getHostedFormTokensForEntity: Array<HostedFormToken>;
    getHostedForms: Array<HostedForm>;
    getIdentitiesWithoutThumbnail: Array<Identity>;
    getIdentity?: Maybe<Identity>;
    getImport: Import;
    getImports: Array<Import>;
    getInvoiceCreateExperience: InvoiceCreateExperienceResponse;
    getLayoutContainerByKey: LayoutContainer;
    getLayoutContainersByKey: Array<LayoutContainer>;
    getLayoutSection: LayoutSection;
    getLayoutSections: LayoutSectionsOutput;
    getLegacyQuestionsForTenant: Array<Question>;
    getLicense?: Maybe<License>;
    getListingsForEvergreenCommunity: Array<EvergreenCommunityListing>;
    getMessage: SentMessage;
    getMessagesForEntity: Array<SentMessage>;
    getMessagingConfiguration: MessagingConfiguration;
    getNextTasksForParentIds: Array<Task>;
    getNotesForEntity: Array<NoteDto>;
    getPendingIncomingClientTransfers: Array<ClientTransferRequest>;
    getPendingOutgoingClientTransfers: Array<ClientTransferRequest>;
    getPersonalPhoneNumbers: Array<TelecomPhoneLine>;
    getPhotosForEntity: Array<Photo>;
    getPopularEvergreenCommunities: GetPopularEvergreenCommunitiesResponse;
    getPopulatedTasksForParent: Array<PopulatedTask>;
    getPublicRecord?: Maybe<PublicRecord>;
    getRecentConversationFeedForUser: ConversationFeed;
    getReferenceBusiness: ReferenceBusiness;
    getReferenceContact: ReferenceContact;
    getReferralsToBusiness: Array<Referral>;
    getReferralsToCommunity: Array<Referral>;
    getReferralsToContact: Array<Referral>;
    getRegion: Region;
    getRegionSettings: RegionSettingsResult;
    getRolesWithActions: Array<RoleWithActions>;
    getSavedQueries: LoadSavedQueryResult;
    getSignableTemplates: Array<File>;
    getSignatureRequest: SignatureRequest;
    getSignatureRequestsForEntity: Array<SignatureRequest>;
    getSignatureTemplate?: Maybe<SignatureTemplate>;
    getSmsConversation: Array<SmsMessage>;
    getSmsConversationByPhoneLine: Array<SmsMessage>;
    getSmtpCredentialForUser?: Maybe<SmtpCredential>;
    getStateReport: Array<StateReportQueryRow>;
    getSuperUserSecurityHealth: SuperUserSecurityHealth;
    getTask: GetTaskResult;
    getTasks: PopulatedTaskSet;
    getTasksForEntity: Array<Task>;
    getTasksv2: Array<PopulatedTask>;
    getTelecomContactStatus: TelecomContactStatus;
    getTemplate: TemplateResponse;
    getTemplates: TemplateList;
    getTenant: Tenant;
    getTenantCredentials: Array<TenantCredential>;
    getTenantHistory: Array<TenantHistory>;
    getTenantSettings: TenantSettingsResult;
    getTenants: Array<Tenant>;
    getTokenForClient: Token;
    getUser: User;
    getUserGroups: Array<UserGroupResult>;
    getUserMailboxes: Array<UserMailbox>;
    getUserProfile: UserProfile;
    getUserTenantRegionOptions: UserTenantRegionOptions;
    getUsers: Array<User>;
    getUsersForRegion: Array<UserDescriptor>;
    getVisibleUsersAcrossRegions: Array<UserDescriptor>;
    getWorkflow: Workflow;
    getWorkflowExecutionsForEntity: Array<WorkflowExecution>;
    getWorkflowSettings: GetWorkflowSettingsResult;
    getWorkflows: Array<Workflow>;
    getWorkflowsForTenant: Array<Workflow>;
    graphqlDebug: GraphqlDebugResult;
    /** Initiate a report export (not intended for client-side use) */
    initiateReportExport: Scalars["ReportExportId"]["output"];
    jobStats: JobStats;
    listRentablePhoneNumbers: ListRentablePhoneNumbersResponse;
    placeholderPerspective: SignatureRequestPerspective;
    publicRecordSearch: PublicRecordSearchResult;
    recentAudienceSyncs: Array<AudienceLatestSyncResult>;
    referenceBusinessMapSearch: ReferenceBusinessMarkerCollection;
    referenceBusinessSearch: ReferenceBusinessSearchResult;
    referenceCommunityMapSearch: ReferenceCommunityMarkerCollection;
    referenceCommunitySearch: ReferenceCommunitySearchResult;
    referenceContactMapSearch: ReferenceContactMarkerCollection;
    referenceContactSearch: ReferenceContactSearchResult;
    referenceOrganizationMapSearch: ReferenceOrganizationMarkerCollection;
    referenceOrganizationSearch: ReferenceOrganizationSearchResult;
    reportClientPlacementRevenue: ClientPlacementRevenueResult;
    searchEvergreenCommunityListings: Array<EvergreenCommunityListing>;
    searchExternalInvoiceCustomers: ExternalInvoiceCustomerSearchResponse;
    searchExternalInvoices: ExternalInvoiceSearchResponse;
    searchNearbyEvergreenCommunityListings: Array<EvergreenCommunityListing>;
    searchUserProfiles: SearchUserProfileResponse;
    searchUserProfilesMapView: UserProfileMarkerCollection;
    simpleSearch: SimpleSearchResponse;
    systemConfiguration: SystemConfiguration;
    userManagementGetApiKey: GetApiKeyResponse;
    userManagementGetImpliedUsers: Array<ImpliedUser>;
    userManagementGetRoles: Array<RoleDescription>;
    userManagementGetUser: ManageableUser;
    userManagementGetUsers: Array<ManageableUser>;
    validateTemplate: TemplateValidationResponse;
};

export type QueryAdvancedSearchArgs = {
    params: AdvancedSearchRequest;
};

export type QueryCanCreateSignatureTemplateArgs = {
    fileId?: InputMaybe<Scalars["FileId"]["input"]>;
};

export type QueryCheckHostedFormSlugArgs = {
    slug: Scalars["String"]["input"];
};

export type QueryCommunityNamesArgs = {
    ids?: InputMaybe<Array<Scalars["CommunityId"]["input"]>>;
    regionKey: Scalars["String"]["input"];
};

export type QueryCommunitySearchArgs = {
    params: CommunitySearchRequest;
};

export type QueryCommunitySearchMapViewArgs = {
    mapView: CommunitySearchRequestMapComponent;
    searchParams: CommunitySearchRequest;
};

export type QueryComposeMessageArgs = {
    id: Scalars["EmailEntityId"]["input"];
    specialMessageExperience?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryDoTestRequestArgs = {
    startingVal: Scalars["Int"]["input"];
};

export type QueryEvergreenCommunitySearchArgs = {
    params: EvergreenCommunitySearchRequest;
};

export type QueryFindClientTransferRequestByClientIdArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type QueryFindEvergreenCommunityListingBySlugArgs = {
    slug: Scalars["String"]["input"];
};

export type QueryGetActivityFeedArgs = {
    entityId: Scalars["ActivityParentEntityId"]["input"];
};

export type QueryGetAllSignatureRequestsArgs = {
    signatureRequestFilter: SignatureRequestFilter;
};

export type QueryGetAudienceArgs = {
    input: GetAudienceGraphQlInput;
};

export type QueryGetAudienceRecipientsArgs = {
    input: GetAudienceRecipientsGraphQlInput;
};

export type QueryGetAudiencesArgs = {
    input: GetAudiencesGraphQlInput;
};

export type QueryGetAuditableEventsArgs = {
    actionTypes: Array<ActionType>;
    after: Scalars["String"]["input"];
    before?: InputMaybe<Scalars["String"]["input"]>;
};

export type QueryGetBillableEntityArgs = {
    billableEntityId: Scalars["BillableEntityId"]["input"];
};

export type QueryGetClientArgs = {
    clientId: Scalars["PlacementId"]["input"];
    options?: InputMaybe<GetClientOptions>;
};

export type QueryGetClientContactsArgs = {
    params: GetClientContactsRequest;
};

export type QueryGetClientIntakeFaxRecipientsArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type QueryGetClientReferralsArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type QueryGetClientsArgs = {
    params: ClientSearchRequest;
};

export type QueryGetCommunityArgs = {
    communityId: Scalars["CommunityId"]["input"];
};

export type QueryGetCommunityContactsArgs = {
    communityId: Scalars["CommunityId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetContactArgs = {
    contactId: Scalars["ContactId"]["input"];
};

export type QueryGetConversationFeedForEntityArgs = {
    entityId: Scalars["EmailEntityId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetCustomListArgs = {
    key: CustomListKey;
};

export type QueryGetDraftSignatureRequestArgs = {
    entityId: Scalars["FileEntityId"]["input"];
    fileId: Scalars["FileId"]["input"];
    signatureRequestId?: InputMaybe<Scalars["SignatureRequestId"]["input"]>;
};

export type QueryGetEmailProviderListsArgs = {
    input: GetEmailProviderListsInput;
};

export type QueryGetEntitiesForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetEntitiesWithoutActiveTasksPaginatedArgs = {
    assignedUserId?: InputMaybe<Scalars["String"]["input"]>;
    entityType: AdvancedSearchEntityType;
    page: Scalars["Int"]["input"];
    pageSize?: Scalars["Int"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetEntityByIdArgs = {
    entityId: Scalars["AnswerEntityId"]["input"];
    entityType: AdvancedSearchEntityType;
    select: Array<AdvancedSearchSelectInput>;
};

export type QueryGetEntityRegionPermissionsArgs = {
    params: GetEntityRegionPermissionsParams;
};

export type QueryGetEvergreenCommunityArgs = {
    id: Scalars["EvergreenCommunityId"]["input"];
};

export type QueryGetEvergreenDataSourceArgs = {
    sourceName: Scalars["String"]["input"];
};

export type QueryGetEvergreenImportsArgs = {
    skip: Scalars["Int"]["input"];
    take: Scalars["Int"]["input"];
};

export type QueryGetExternalInvoiceAccountSettingsArgs = {
    params: GetExternalInvoiceAccountSettingsRequest;
};

export type QueryGetExternalInvoiceInitialParametersArgs = {
    params: GetExternalInvoiceInitialParametersRequest;
};

export type QueryGetFeaturesForRegionArgs = {
    params: GetRegionFeaturesRequest;
};

export type QueryGetFileArgs = {
    fileId: Scalars["FileId"]["input"];
};

export type QueryGetFilesArgs = {
    entityId: Scalars["FileEntityId"]["input"];
};

export type QueryGetHostedFormByIdArgs = {
    id: Scalars["HostedFormId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetHostedFormTokensForEntityArgs = {
    entityId: Scalars["HostedFormEntityId"]["input"];
};

export type QueryGetHostedFormsArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetIdentityArgs = {
    identityId: Scalars["IdentityId"]["input"];
};

export type QueryGetImportArgs = {
    importId: Scalars["ImportId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetImportsArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetInvoiceCreateExperienceArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetLayoutContainerByKeyArgs = {
    key: Scalars["String"]["input"];
};

export type QueryGetLayoutContainersByKeyArgs = {
    keys: Array<LayoutSectionParentKey>;
};

export type QueryGetLayoutSectionArgs = {
    id: Scalars["LayoutSectionId"]["input"];
};

export type QueryGetLayoutSectionsArgs = {
    parentKey: LayoutSectionParentKey;
};

export type QueryGetLegacyQuestionsForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetLicenseArgs = {
    licenseId: Scalars["LicenseId"]["input"];
};

export type QueryGetListingsForEvergreenCommunityArgs = {
    evergreenCommunityId: Scalars["EvergreenCommunityId"]["input"];
};

export type QueryGetMessageArgs = {
    sentMessageId: Scalars["SentMessageId"]["input"];
};

export type QueryGetMessagesForEntityArgs = {
    entityId: Scalars["EmailEntityId"]["input"];
};

export type QueryGetNextTasksForParentIdsArgs = {
    parentIds: Array<Scalars["TaskParentId"]["input"]>;
};

export type QueryGetNotesForEntityArgs = {
    entityId: Scalars["NoteEntityId"]["input"];
    filter?: InputMaybe<GetNotesForEntityFilter>;
};

export type QueryGetPendingIncomingClientTransfersArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetPendingOutgoingClientTransfersArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetPhotosForEntityArgs = {
    entityId: Scalars["FileEntityId"]["input"];
};

export type QueryGetPopularEvergreenCommunitiesArgs = {
    params: GetPopularEvergreenCommunitiesRequest;
};

export type QueryGetPopulatedTasksForParentArgs = {
    parentId: Scalars["TaskParentId"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetPublicRecordArgs = {
    publicRecordId: Scalars["PublicRecordId"]["input"];
};

export type QueryGetRecentConversationFeedForUserArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetReferenceBusinessArgs = {
    referenceBusinessId: Scalars["ReferenceBusinessId"]["input"];
};

export type QueryGetReferenceContactArgs = {
    referenceContactId: Scalars["ReferenceContactId"]["input"];
};

export type QueryGetReferralsToBusinessArgs = {
    referenceBusinessId: Scalars["ReferenceBusinessId"]["input"];
};

export type QueryGetReferralsToCommunityArgs = {
    communityId: Scalars["CommunityId"]["input"];
};

export type QueryGetReferralsToContactArgs = {
    referenceContactId: Scalars["ReferenceContactId"]["input"];
};

export type QueryGetRegionArgs = {
    regionId: Scalars["RegionId"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetRegionSettingsArgs = {
    params: GetRegionSettingsRequest;
};

export type QueryGetRolesWithActionsArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetSignableTemplatesArgs = {
    entityType: FileEntityType;
};

export type QueryGetSignatureRequestArgs = {
    signatureRequestId: Scalars["SignatureRequestId"]["input"];
};

export type QueryGetSignatureRequestsForEntityArgs = {
    entityId: Scalars["FileEntityId"]["input"];
};

export type QueryGetSignatureTemplateArgs = {
    fileId: Scalars["FileId"]["input"];
};

export type QueryGetSmsConversationArgs = {
    request: GetSmsConversationRequest;
};

export type QueryGetSmsConversationByPhoneLineArgs = {
    request: GetSmsConversationByPhoneLineRequest;
};

export type QueryGetTaskArgs = {
    regionId: Scalars["RegionId"]["input"];
    taskId: Scalars["TaskId"]["input"];
};

export type QueryGetTasksArgs = {
    activeOnly: Scalars["Boolean"]["input"];
    page: Scalars["Int"]["input"];
    regionId: Scalars["ID"]["input"];
};

export type QueryGetTasksForEntityArgs = {
    parentId: Scalars["TaskParentId"]["input"];
};

export type QueryGetTasksv2Args = {
    params: GetTasksRequest;
};

export type QueryGetTelecomContactStatusArgs = {
    request: GetTelecomContactStatusRequest;
};

export type QueryGetTemplateArgs = {
    emailTemplateId: Scalars["EmailTemplateId"]["input"];
};

export type QueryGetTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetTenantHistoryArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGetTokenForClientArgs = {
    clientId: Scalars["PlacementId"]["input"];
};

export type QueryGetUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type QueryGetUsersForRegionArgs = {
    regionId: Scalars["RegionId"]["input"];
};

export type QueryGetWorkflowArgs = {
    tenantId: Scalars["TenantId"]["input"];
    workflowId: Scalars["WorkflowId"]["input"];
};

export type QueryGetWorkflowExecutionsForEntityArgs = {
    workflowTargetId: Scalars["WorkflowTargetId"]["input"];
};

export type QueryGetWorkflowsForTenantArgs = {
    tenantId: Scalars["TenantId"]["input"];
};

export type QueryGraphqlDebugArgs = {
    expectedResult: Scalars["String"]["input"];
};

export type QueryInitiateReportExportArgs = {
    params: AdvancedSearchRequest;
};

export type QueryListRentablePhoneNumbersArgs = {
    request: ListRentablePhoneNumbersRequest;
};

export type QueryPublicRecordSearchArgs = {
    params: PublicRecordSearchRequest;
};

export type QueryRecentAudienceSyncsArgs = {
    input: RecentAudienceSyncsInput;
};

export type QueryReferenceBusinessMapSearchArgs = {
    mapView: CommunitySearchRequestMapComponent;
    searchParams: ReferenceBusinessSearchRequest;
};

export type QueryReferenceBusinessSearchArgs = {
    search: ReferenceBusinessSearchRequest;
};

export type QueryReferenceCommunityMapSearchArgs = {
    mapView: CommunitySearchRequestMapComponent;
    searchParams: ReferenceCommunitySearchRequest;
};

export type QueryReferenceCommunitySearchArgs = {
    search: ReferenceCommunitySearchRequest;
};

export type QueryReferenceContactMapSearchArgs = {
    mapView: CommunitySearchRequestMapComponent;
    searchParams: ReferenceContactSearchRequest;
};

export type QueryReferenceContactSearchArgs = {
    search: ReferenceContactSearchRequest;
};

export type QueryReferenceOrganizationMapSearchArgs = {
    mapView: CommunitySearchRequestMapComponent;
    searchParams: ReferenceOrganizationSearchRequest;
};

export type QueryReferenceOrganizationSearchArgs = {
    search: ReferenceOrganizationSearchRequest;
};

export type QueryReportClientPlacementRevenueArgs = {
    amountBasis: RevenueAmountBasis;
    endDate: Scalars["String"]["input"];
    region: Scalars["String"]["input"];
    revenueBasis: RevenueBasis;
    startDate: Scalars["String"]["input"];
};

export type QuerySearchEvergreenCommunityListingsArgs = {
    params: SearchEvergreenCommunityListingsRequest;
};

export type QuerySearchExternalInvoiceCustomersArgs = {
    params: ExternalInvoiceCustomerSearchRequest;
};

export type QuerySearchExternalInvoicesArgs = {
    params: ExternalInvoiceSearchRequest;
};

export type QuerySearchNearbyEvergreenCommunityListingsArgs = {
    params: SearchNearbyEvergreenCommunityListingsRequest;
};

export type QuerySearchUserProfilesArgs = {
    params: SearchUserProfileRequest;
};

export type QuerySearchUserProfilesMapViewArgs = {
    mapView: CommunitySearchRequestMapComponent;
    params: SearchUserProfileRequest;
};

export type QuerySimpleSearchArgs = {
    query: SimpleSearchRequest;
};

export type QueryUserManagementGetApiKeyArgs = {
    userId: Scalars["UserId"]["input"];
};

export type QueryUserManagementGetUserArgs = {
    userId: Scalars["UserId"]["input"];
};

export type QueryUserManagementGetUsersArgs = {
    params?: InputMaybe<GetUsersParameters>;
};

export type QueryValidateTemplateArgs = {
    emailTemplateId: Scalars["EmailTemplateId"]["input"];
    messageType: Scalars["String"]["input"];
};

export type Question = {
    __typename?: "Question";
    annotation?: Maybe<Scalars["String"]["output"]>;
    category?: Maybe<Scalars["String"]["output"]>;
    clientAnnotation?: Maybe<Scalars["String"]["output"]>;
    clientInteraction?: Maybe<Scalars["String"]["output"]>;
    clientPdfBehavior?: Maybe<Scalars["String"]["output"]>;
    clientRulesString?: Maybe<Scalars["String"]["output"]>;
    clientSearchBehavior?: Maybe<Scalars["String"]["output"]>;
    clientTitle?: Maybe<Scalars["String"]["output"]>;
    communityAnnotation?: Maybe<Scalars["String"]["output"]>;
    communityInteraction?: Maybe<Scalars["String"]["output"]>;
    communityPdfBehavior?: Maybe<Scalars["String"]["output"]>;
    communityRulesString?: Maybe<Scalars["String"]["output"]>;
    communitySearchBehavior?: Maybe<Scalars["String"]["output"]>;
    communityTitle?: Maybe<Scalars["String"]["output"]>;
    comparisonBehavior?: Maybe<Scalars["String"]["output"]>;
    entityType?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["QuestionId"]["output"];
    interaction?: Maybe<Scalars["String"]["output"]>;
    key: Scalars["String"]["output"];
    order?: Maybe<Scalars["Int"]["output"]>;
    prompts?: Maybe<Array<Prompt>>;
    questionType?: Maybe<Scalars["String"]["output"]>;
    regionVisibility?: Maybe<EntityRegionVisibility>;
    rulesString?: Maybe<Scalars["String"]["output"]>;
    title?: Maybe<Scalars["String"]["output"]>;
};

/** A string-based payload of questions */
export type QuestionBulkCreatePayload = {
    serializedQuestions: Scalars["String"]["input"];
    tenantId: Scalars["TenantId"]["input"];
};

/** A payload for reordering questions */
export type QuestionReorderPayload = {
    questionIds: Array<Scalars["QuestionId"]["input"]>;
};

export enum QuestionSource {
    Entity = "Entity",
    Legacy = "Legacy",
}

/** QuickBooks Credential Details */
export type QuickBooksDetails = {
    __typename?: "QuickBooksDetails";
    realmId: Scalars["String"]["output"];
};

export type RecentAudienceSyncsInput = {
    audienceId: Scalars["AudienceId"]["input"];
    limit: Scalars["Float"]["input"];
    provider: EmailMarketingProvider;
    regionId: Scalars["RegionId"]["input"];
};

export enum RecurrencePattern {
    Daily = "Daily",
    Monthly = "Monthly",
    None = "None",
    Weekly = "Weekly",
}

/** Reference contact */
export type ReferenceBusiness = {
    __typename?: "ReferenceBusiness";
    activityEntities?: Maybe<Array<Activity>>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    bestDaysToVisit?: Maybe<Array<Scalars["String"]["output"]>>;
    bestTimeToContact?: Maybe<Array<Scalars["String"]["output"]>>;
    business: ContactEntity;
    businessContactEntity?: Maybe<ContactEntity>;
    contacts: Array<ReferenceContact>;
    createdBy?: Maybe<Scalars["UserId"]["output"]>;
    dateAdded: Scalars["DateTime"]["output"];
    deleted: Scalars["Boolean"]["output"];
    draftNote?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ReferenceBusinessId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    noteEntities?: Maybe<Array<Note>>;
    notes: Array<NoteDto>;
    ownerId?: Maybe<Scalars["UserId"]["output"]>;
    regionId: Scalars["RegionId"]["output"];
    summary?: Maybe<Scalars["String"]["output"]>;
    tierListItem?: Maybe<CustomListItem>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy?: Maybe<Scalars["UserId"]["output"]>;
};

export type ReferenceBusinessCoordinates = {
    __typename?: "ReferenceBusinessCoordinates";
    appLink?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ReferenceBusinessId"]["output"];
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceBusinessEntity = CrmEntity & {
    __typename?: "ReferenceBusinessEntity";
    contact?: Maybe<CrmEntityContact>;
    createdAt: Scalars["DateTime"]["output"];
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type ReferenceBusinessMarkerCollection = {
    __typename?: "ReferenceBusinessMarkerCollection";
    coordinates?: Maybe<Coordinates>;
    recommendedZoom: Scalars["Float"]["output"];
    referenceBusinessClusters: Array<MapCluster>;
    referenceBusinessCoordinates: Array<ReferenceBusinessCoordinates>;
};

export type ReferenceBusinessSearchHit = {
    __typename?: "ReferenceBusinessSearchHit";
    address?: Maybe<Scalars["String"]["output"]>;
    assignedTo?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    fax?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ReferenceBusinessId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    mostRecentReferral?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    numberOfReferrals: Scalars["Float"]["output"];
    organizationType?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceBusinessSearchRequest = {
    assignedUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    bestDaysToVisit?: InputMaybe<Array<Scalars["String"]["input"]>>;
    businessCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    geoParams?: InputMaybe<SearchGeoParams>;
    ids?: InputMaybe<Array<Scalars["ReferenceBusinessId"]["input"]>>;
    organizationTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    page: Scalars["Float"]["input"];
    perPage: Scalars["Float"]["input"];
    referralTierIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    regionId?: InputMaybe<Scalars["RegionId"]["input"]>;
    regionIds?: InputMaybe<Array<Scalars["RegionId"]["input"]>>;
    search: Scalars["String"]["input"];
    sort: Scalars["String"]["input"];
    sortDirection: Scalars["String"]["input"];
};

export type ReferenceBusinessSearchResult = {
    __typename?: "ReferenceBusinessSearchResult";
    coordinates?: Maybe<Coordinates>;
    hits: Array<ReferenceBusinessSearchHit>;
    total: Scalars["Float"]["output"];
};

export type ReferenceCommunityMarkerCollection = {
    __typename?: "ReferenceCommunityMarkerCollection";
    communityClusters: Array<MapCluster>;
    communityCoordinates: Array<CommunityCoordinates>;
    coordinates?: Maybe<Coordinates>;
    recommendedZoom: Scalars["Float"]["output"];
};

export type ReferenceCommunitySearchHit = {
    __typename?: "ReferenceCommunitySearchHit";
    address?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    fax?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["CommunityId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    mostRecentReferral?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    numberOfReferrals: Scalars["Float"]["output"];
    phone?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceCommunitySearchRequest = {
    communityCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    communityTypes?: InputMaybe<Array<Scalars["PromptId"]["input"]>>;
    geoParams?: InputMaybe<SearchGeoParams>;
    page: Scalars["Float"]["input"];
    perPage: Scalars["Float"]["input"];
    referralTierIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    regionId: Scalars["RegionId"]["input"];
    search: Scalars["String"]["input"];
    sort: Scalars["String"]["input"];
    sortDirection: Scalars["String"]["input"];
};

export type ReferenceCommunitySearchResult = {
    __typename?: "ReferenceCommunitySearchResult";
    coordinates?: Maybe<Coordinates>;
    hits: Array<ReferenceCommunitySearchHit>;
    total: Scalars["Float"]["output"];
};

/** Reference contact */
export type ReferenceContact = {
    __typename?: "ReferenceContact";
    activityEntities?: Maybe<Array<Activity>>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    bestDaysToVisit?: Maybe<Array<Scalars["String"]["output"]>>;
    bestTimeToContact?: Maybe<Array<Scalars["String"]["output"]>>;
    business?: Maybe<ReferenceBusiness>;
    businessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    community?: Maybe<Community>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    contact?: Maybe<ContactEntity>;
    contactEntity?: Maybe<ContactEntity>;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    deleted: Scalars["Boolean"]["output"];
    draftNote?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ReferenceContactId"]["output"];
    noteEntities?: Maybe<Array<Note>>;
    notes: Array<NoteDto>;
    ownerId?: Maybe<Scalars["UserId"]["output"]>;
    regionId: Scalars["RegionId"]["output"];
    summary?: Maybe<Scalars["String"]["output"]>;
    tierListItem?: Maybe<CustomListItem>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    userProfile?: Maybe<UserProfile>;
    userProfileId?: Maybe<Scalars["UserProfileId"]["output"]>;
};

export type ReferenceContactCoordinates = {
    __typename?: "ReferenceContactCoordinates";
    appLink?: Maybe<Scalars["String"]["output"]>;
    businessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    contacts: Array<ReferenceContactCoordinatesContact>;
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceContactCoordinatesContact = {
    __typename?: "ReferenceContactCoordinatesContact";
    appLink: Scalars["String"]["output"];
    id: Scalars["ReferenceContactId"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceContactEntity = CrmEntity & {
    __typename?: "ReferenceContactEntity";
    contact?: Maybe<CrmEntityContact>;
    createdAt: Scalars["DateTime"]["output"];
    displayName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["String"]["output"];
    kind: Scalars["String"]["output"];
    kindTitle: Scalars["String"]["output"];
    path: Scalars["String"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type ReferenceContactInput = {
    deleted?: InputMaybe<Scalars["Boolean"]["input"]>;
    regionId: Scalars["RegionId"]["input"];
    summary?: InputMaybe<Scalars["String"]["input"]>;
};

export type ReferenceContactMarkerCollection = {
    __typename?: "ReferenceContactMarkerCollection";
    coordinates?: Maybe<Coordinates>;
    recommendedZoom: Scalars["Float"]["output"];
    referenceContactClusters: Array<MapCluster>;
    referenceContactCoordinates: Array<ReferenceContactCoordinates>;
};

export type ReferenceContactSearchHit = {
    __typename?: "ReferenceContactSearchHit";
    address?: Maybe<Scalars["String"]["output"]>;
    answers: Array<Answer>;
    appLink: Scalars["String"]["output"];
    assignedTo?: Maybe<Scalars["String"]["output"]>;
    businessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    cellPhone?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    email?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["ReferenceContactId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    mostRecentReferral?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    numberOfReferrals: Scalars["Float"]["output"];
    organizationAnswers: Array<Answer>;
    organizationFax?: Maybe<Scalars["String"]["output"]>;
    organizationName?: Maybe<Scalars["String"]["output"]>;
    organizationPhone?: Maybe<Scalars["String"]["output"]>;
    organizationType?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
    role?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceContactSearchRequest = {
    assignedUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    bestDaysToVisit?: InputMaybe<Array<Scalars["String"]["input"]>>;
    businessCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    businessId?: InputMaybe<Scalars["ReferenceBusinessId"]["input"]>;
    communityCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    communityTypes?: InputMaybe<Array<Scalars["PromptId"]["input"]>>;
    contactCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    geoParams?: InputMaybe<SearchGeoParams>;
    ids?: InputMaybe<Array<Scalars["ReferenceContactId"]["input"]>>;
    includeQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
    organizationTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    page: Scalars["Float"]["input"];
    perPage: Scalars["Float"]["input"];
    referralTierIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    regionId?: InputMaybe<Scalars["RegionId"]["input"]>;
    regionIds?: InputMaybe<Array<Scalars["RegionId"]["input"]>>;
    search: Scalars["String"]["input"];
    sort: Scalars["String"]["input"];
    sortDirection: Scalars["String"]["input"];
};

export type ReferenceContactSearchResult = {
    __typename?: "ReferenceContactSearchResult";
    coordinates?: Maybe<Coordinates>;
    hits: Array<ReferenceContactSearchHit>;
    total: Scalars["Float"]["output"];
};

export type ReferenceOrganizationMarkerCollection = {
    __typename?: "ReferenceOrganizationMarkerCollection";
    coordinates?: Maybe<Coordinates>;
    organizationClusters: Array<MapCluster>;
    organizationCoordinates: Array<OrganizationCoordinates>;
    recommendedZoom: Scalars["Float"]["output"];
};

export type ReferenceOrganizationSearchHit = {
    __typename?: "ReferenceOrganizationSearchHit";
    address?: Maybe<Scalars["String"]["output"]>;
    answers: Array<Answer>;
    appLink?: Maybe<Scalars["String"]["output"]>;
    assignedTo?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    contacts: Array<ReferenceContactSearchHit>;
    email?: Maybe<Scalars["String"]["output"]>;
    entityType: AdvancedSearchEntityType;
    fax?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["OrganizationId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    mostRecentReferral?: Maybe<Scalars["DateTime"]["output"]>;
    name?: Maybe<Scalars["String"]["output"]>;
    numberOfReferrals: Scalars["Float"]["output"];
    organizationType?: Maybe<Scalars["String"]["output"]>;
    phone?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export type ReferenceOrganizationSearchRequest = {
    assignedUserId?: InputMaybe<Scalars["UserId"]["input"]>;
    bestDaysToVisit?: InputMaybe<Array<Scalars["String"]["input"]>>;
    businessCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    communityCondition?: InputMaybe<AdvancedSearchRequestCondition>;
    communityTypes?: InputMaybe<Array<Scalars["PromptId"]["input"]>>;
    geoParams?: InputMaybe<SearchGeoParams>;
    ids?: InputMaybe<Array<Scalars["OrganizationId"]["input"]>>;
    includeQuestionIds?: InputMaybe<Array<Scalars["QuestionId"]["input"]>>;
    organizationTypes?: InputMaybe<Array<Scalars["String"]["input"]>>;
    page: Scalars["Float"]["input"];
    perPage: Scalars["Float"]["input"];
    referralTierIds?: InputMaybe<Array<Scalars["String"]["input"]>>;
    regionId?: InputMaybe<Scalars["RegionId"]["input"]>;
    regionIds?: InputMaybe<Array<Scalars["RegionId"]["input"]>>;
    search: Scalars["String"]["input"];
    sort: Scalars["String"]["input"];
    sortDirection: Scalars["String"]["input"];
};

export type ReferenceOrganizationSearchResult = {
    __typename?: "ReferenceOrganizationSearchResult";
    coordinates?: Maybe<Coordinates>;
    hits: Array<ReferenceOrganizationSearchHit>;
    total: Scalars["Float"]["output"];
};

export type Referral = {
    __typename?: "Referral";
    community?: Maybe<Community>;
    communityId?: Maybe<Scalars["CommunityId"]["output"]>;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["ReferralId"]["output"];
    notes?: Maybe<Scalars["String"]["output"]>;
    placement?: Maybe<Client>;
    placementId: Scalars["PlacementId"]["output"];
    referenceBusiness?: Maybe<ReferenceBusiness>;
    referenceBusinessId?: Maybe<Scalars["ReferenceBusinessId"]["output"]>;
    referenceContact?: Maybe<ReferenceContact>;
    referenceContactId?: Maybe<Scalars["ReferenceContactId"]["output"]>;
    referralType: Scalars["String"]["output"];
    sentMessage?: Maybe<SentMessage>;
    sentMessageId?: Maybe<Scalars["SentMessageId"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    when: Scalars["DateTime"]["output"];
};

/** Region */
export type Region = {
    __typename?: "Region";
    billableEntityId?: Maybe<Scalars["BillableEntityId"]["output"]>;
    /** Identifier */
    id: Scalars["RegionId"]["output"];
    /** Machine friendly name */
    key: Scalars["String"]["output"];
    membershipType: EntityRegionPermissionType;
    /** Human readable name */
    name: Scalars["String"]["output"];
    parentRegionId?: Maybe<Scalars["RegionId"]["output"]>;
    /** User permissions in region */
    permissions: Array<PermissionRecord>;
    regionLicenseMaps: Array<RegionLicenseMap>;
};

/** Region/license type mapping */
export type RegionLicenseMap = {
    __typename?: "RegionLicenseMap";
    autoPropagateEnabled: Scalars["Boolean"]["output"];
    id: Scalars["RegionLicenseMapId"]["output"];
    identityFilterObjects: Array<IdentityFilterObject>;
    licenseMappingObjects: Array<LicenseMappingObject>;
    region: Region;
    settings?: Maybe<RegionLicenseMapSettings>;
};

export type RegionLicenseMapSettings = {
    __typename?: "RegionLicenseMapSettings";
    closedHandling?: Maybe<RegionLicenseMapSettingsClosedHandling>;
    mode?: Maybe<RegionLicenseMapSettingsMode>;
    updateAttributes?: Maybe<RegionLicenseMapSettingsUpdateAttributes>;
};

export enum RegionLicenseMapSettingsClosedHandling {
    Cautious = "Cautious",
    Donothing = "Donothing",
    Forceful = "Forceful",
}

export type RegionLicenseMapSettingsInput = {
    closedHandling?: InputMaybe<RegionLicenseMapSettingsClosedHandling>;
    mode?: InputMaybe<RegionLicenseMapSettingsMode>;
    updateAttributes?: InputMaybe<RegionLicenseMapSettingsUpdateAttributes>;
};

export enum RegionLicenseMapSettingsMode {
    Default = "default",
    Perlicensetype = "perlicensetype",
}

export enum RegionLicenseMapSettingsUpdateAttributes {
    Always = "always",
    Never = "never",
}

export type RegionLicenseMapUpdateRequest = {
    autoPropagateEnabled: Scalars["Boolean"]["input"];
    existingRegionLicenseMapId?: InputMaybe<Scalars["RegionLicenseMapId"]["input"]>;
    identityFilters: Array<IdentityFilterInput>;
    licenseMappings: Array<LicenseMappingInput>;
    regionId: Scalars["RegionId"]["input"];
    settings: RegionLicenseMapSettingsInput;
    tenantId: Scalars["TenantId"]["input"];
};

export type RegionSetting = {
    __typename?: "RegionSetting";
    key: Scalars["String"]["output"];
    source: RegionSettingSource;
    value: SettingValue;
};

export enum RegionSettingSource {
    Region = "Region",
    Tenant = "Tenant",
}

export type RegionSettingsResult = {
    __typename?: "RegionSettingsResult";
    regionId: Scalars["RegionId"]["output"];
    settings: Array<RegionSetting>;
};

export type RelocateImageInput = {
    id: Scalars["String"]["input"];
    src: Scalars["String"]["input"];
};

export type RelocateImageResponse = {
    __typename?: "RelocateImageResponse";
    id: Scalars["String"]["output"];
    src: Scalars["String"]["output"];
};

export type RemoveClientCommunityRequest = {
    communityId: Scalars["CommunityId"]["input"];
};

export type RentablePhoneNumber = {
    __typename?: "RentablePhoneNumber";
    friendlyLocation?: Maybe<Scalars["String"]["output"]>;
    friendlyName: Scalars["String"]["output"];
    locality?: Maybe<Scalars["String"]["output"]>;
    phoneNumber: Scalars["PhoneNumberE164"]["output"];
    postalCode?: Maybe<Scalars["String"]["output"]>;
    region?: Maybe<Scalars["String"]["output"]>;
};

export enum ReplyAction {
    Reply = "Reply",
    ReplyAll = "ReplyAll",
}

/** An individual slice of time in a client placement report */
export type ReportSegment = {
    __typename?: "ReportSegment";
    /** Total moves for time period */
    moves: Scalars["Int"]["output"];
    /** Total revenue for time period */
    revenue: Scalars["Float"]["output"];
    /** The beginning of the time window in YYYY-MM-DD format */
    startDate: Scalars["String"]["output"];
    /** broken down by user */
    users: Array<UserReportSegment>;
};

export type ResetTenantOptions = {
    /** Delete all communities */
    deleteCommunities: Scalars["Boolean"]["input"];
    /** Tenant ID */
    tenantId: Scalars["TenantId"]["input"];
};

/** Which dollars to count: 'invoiced' = full amount on every non-void invoice; 'received' = only money actually collected (paid invoices plus Paid items on payment schedules). */
export enum RevenueAmountBasis {
    Invoiced = "Invoiced",
    Received = "Received",
}

/** Date used to attribute revenue: client move date (placed), invoice sent date, or invoice paid date */
export enum RevenueBasis {
    Paid = "Paid",
    Placed = "Placed",
    Sent = "Sent",
}

export type RoleDescription = {
    __typename?: "RoleDescription";
    humanReadableName: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
};

export type RoleWithActions = {
    __typename?: "RoleWithActions";
    actions: Array<ActionType>;
    humanReadableName: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    userAssignable: Scalars["Boolean"]["output"];
};

export type SavedQueryInput = {
    condition: AdvancedSearchRequestCondition;
    entityType: Scalars["String"]["input"];
    folderName?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["SavedQueryId"]["input"]>;
    isShared: Scalars["Boolean"]["input"];
    name: Scalars["String"]["input"];
    regionVisibility?: InputMaybe<EntityRegionVisibilityInput>;
    select: Array<AdvancedSearchSelectInput>;
    sort: AdvancedSearchRequestSort;
    summaries?: InputMaybe<Array<AdvancedSearchRequestSummaryInput>>;
};

export type SavedQueryResult = {
    __typename?: "SavedQueryResult";
    condition: AdvancedSearchCondition;
    createdAt: Scalars["DateTime"]["output"];
    createdBy: Scalars["UserId"]["output"];
    editable: Scalars["Boolean"]["output"];
    entityType: AdvancedSearchEntityType;
    folderName?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["SavedQueryId"]["output"];
    isFavorite: Scalars["Boolean"]["output"];
    isMyQuery: Scalars["Boolean"]["output"];
    isShared: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
    regionVisibility: EntityRegionVisibility;
    schedule?: Maybe<SavedQueryScheduleResult>;
    select: Array<AdvancedSearchSelect>;
    sort: AdvancedSearchSort;
    summaries?: Maybe<Array<AdvancedSearchRequestSummary>>;
    updatedAt: Scalars["DateTime"]["output"];
    warnings?: Maybe<Array<SavedQueryWarning>>;
};

export type SavedQueryScheduleInput = {
    audience: UserAudienceInput;
    emailDescription?: InputMaybe<Scalars["String"]["input"]>;
    savedQueryId: Scalars["SavedQueryId"]["input"];
    schedule: Scalars["String"]["input"];
};

export type SavedQueryScheduleResult = {
    __typename?: "SavedQueryScheduleResult";
    audience: UserAudience;
    emailDescription?: Maybe<Scalars["String"]["output"]>;
    schedule: Scalars["String"]["output"];
};

export type SavedQuerySendEmailInput = {
    audience: UserAudienceInput;
    emailDescription?: InputMaybe<Scalars["String"]["input"]>;
    savedQueryId: Scalars["SavedQueryId"]["input"];
};

export type SavedQueryWarning = {
    __typename?: "SavedQueryWarning";
    location: SavedQueryWarningLocation;
    message: Scalars["String"]["output"];
};

export enum SavedQueryWarningLocation {
    Condition = "Condition",
    Select = "Select",
    Sort = "Sort",
}

export type ScheduleTriggerConfigurationEntity = {
    __typename?: "ScheduleTriggerConfigurationEntity";
    cron: Scalars["String"]["output"];
    entityCondition: AdvancedSearchCondition;
};

export type ScheduleTriggerConfigurationEntityInput = {
    cron: Scalars["String"]["input"];
    entityCondition: AdvancedSearchRequestCondition;
};

export type SearchEvergreenCommunityListingsRequest = {
    geoSearch?: InputMaybe<SearchGeoParams>;
    searchText?: InputMaybe<Scalars["String"]["input"]>;
    visibility?: InputMaybe<Array<ListingVisibility>>;
};

export type SearchGeoParams = {
    address?: InputMaybe<Scalars["String"]["input"]>;
    bounds?: InputMaybe<BoundsInput>;
    city?: InputMaybe<Scalars["String"]["input"]>;
    coordinates?: InputMaybe<CoordinatesInput>;
    county?: InputMaybe<Scalars["String"]["input"]>;
    distance?: InputMaybe<Scalars["Float"]["input"]>;
    matchType?: InputMaybe<Scalars["String"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

export type SearchNearbyEvergreenCommunityListingsRequest = {
    geoSearch?: InputMaybe<SearchGeoParams>;
};

export type SearchUserProfileRequest = {
    geoParams?: InputMaybe<SearchGeoParams>;
    page: Scalars["Int"]["input"];
    perPage: Scalars["Int"]["input"];
    query: Scalars["String"]["input"];
    regionId: Scalars["String"]["input"];
    sort: Scalars["String"]["input"];
    sortDirection: Scalars["String"]["input"];
    verticals?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type SearchUserProfileResponse = {
    __typename?: "SearchUserProfileResponse";
    coordinates?: Maybe<Coordinates>;
    hits: Array<UserProfile>;
    referenceContacts: Array<ReferenceContact>;
    total: Scalars["Int"]["output"];
};

export enum SectionRenderBehaviorType {
    Custom = "Custom",
    CustomWithLayoutItems = "CustomWithLayoutItems",
    LayoutItems = "LayoutItems",
    None = "None",
    Notes = "Notes",
    SingleProperty = "SingleProperty",
}

export type SendHostedFormWithPermalinkRequest = {
    formLinkQueryParams?: InputMaybe<Scalars["String"]["input"]>;
    hostedFormId: Scalars["HostedFormId"]["input"];
    message: OutboundMessage;
    regionId: Scalars["RegionId"]["input"];
};

export type SendHostedFormWithTokenRequest = {
    entityId: Scalars["HostedFormEntityId"]["input"];
    hostedFormId: Scalars["HostedFormId"]["input"];
    message: OutboundMessage;
};

export type SendHostedFormWithTokenResponse = {
    __typename?: "SendHostedFormWithTokenResponse";
    token: HostedFormToken;
};

/** Result of attempting to send message  */
export type SendMessageResult = {
    __typename?: "SendMessageResult";
    accepted: Array<Scalars["String"]["output"]>;
    code?: Maybe<Scalars["String"]["output"]>;
    rejected: Array<Scalars["String"]["output"]>;
    sentMessage?: Maybe<SentMessage>;
    status: Scalars["String"]["output"];
};

export type SendSmsRequest = {
    activityTypeId?: InputMaybe<Scalars["TaskTypeId"]["input"]>;
    body: Scalars["String"]["input"];
    entityId?: InputMaybe<Scalars["ActivityParentEntityId"]["input"]>;
    from: Scalars["TelecomPhoneLineId"]["input"];
    to: Scalars["PhoneNumberE164"]["input"];
};

export type SentMessage = {
    __typename?: "SentMessage";
    activityEntities?: Maybe<Array<Activity>>;
    attachments?: Maybe<Array<Scalars["String"]["output"]>>;
    body?: Maybe<Scalars["String"]["output"]>;
    bodyPreview?: Maybe<Scalars["String"]["output"]>;
    bouncedRecipients: Array<Scalars["String"]["output"]>;
    cc?: Maybe<Array<Scalars["String"]["output"]>>;
    clickedLinkEvents?: Maybe<Array<ClickedLink>>;
    clientIdUuid?: Maybe<Scalars["PlacementId"]["output"]>;
    communityIdUuid?: Maybe<Scalars["CommunityId"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    events?: Maybe<Array<SentMessageEvent>>;
    from?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["SentMessageId"]["output"];
    /** Client sent to iff intake (must be explicitly populated */
    intakeClient?: Maybe<Client>;
    /** Community sent to iff intake (must be explicitly populated */
    intakeCommunity?: Maybe<Community>;
    invoice?: Maybe<Invoice>;
    latestEventStatus?: Maybe<Scalars["String"]["output"]>;
    messageId?: Maybe<Scalars["String"]["output"]>;
    messageType?: Maybe<Scalars["String"]["output"]>;
    status: Scalars["String"]["output"];
    subject?: Maybe<Scalars["String"]["output"]>;
    to?: Maybe<Array<Scalars["String"]["output"]>>;
    userId?: Maybe<Scalars["String"]["output"]>;
};

export type SentMessageEvent = {
    __typename?: "SentMessageEvent";
    eventTimestamp: Scalars["DateTime"]["output"];
    eventType: Scalars["String"]["output"];
    recipient?: Maybe<Scalars["String"]["output"]>;
    remoteAddress?: Maybe<Scalars["String"]["output"]>;
};

export type SentToPartner = {
    __typename?: "SentToPartner";
    integration: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
};

export type SetWorkflowSettingInput = {
    key: Scalars["String"]["input"];
    textValue?: InputMaybe<Scalars["String"]["input"]>;
    workflowId: Scalars["WorkflowId"]["input"];
};

export type SettingValue = {
    __typename?: "SettingValue";
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    intValue?: Maybe<Scalars["Int"]["output"]>;
    jsonValue?: Maybe<Scalars["String"]["output"]>;
    textValue?: Maybe<Scalars["String"]["output"]>;
};

export type SettingValueInput = {
    booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    intValue?: InputMaybe<Scalars["Int"]["input"]>;
    jsonValue?: InputMaybe<Scalars["String"]["input"]>;
    textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export enum SignatureCreatePermission {
    Allowed = "Allowed",
    NotAllowed = "NotAllowed",
    TooMany = "TooMany",
}

export enum SignatureFieldType {
    Checkbox = "Checkbox",
    Date = "Date",
    Initial = "Initial",
    Signature = "Signature",
    Text = "Text",
}

export type SignaturePotentialRecipient = {
    __typename?: "SignaturePotentialRecipient";
    email: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    source: Scalars["String"]["output"];
};

export type SignatureRequest = {
    __typename?: "SignatureRequest";
    ccRecipients: Array<SignatureRequestCcRecipient>;
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    completedEmailTemplateId?: Maybe<Scalars["EmailTemplateId"]["output"]>;
    completedFileId?: Maybe<Scalars["FileId"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    createdBy: Scalars["UserId"]["output"];
    emailTemplateId?: Maybe<Scalars["EmailTemplateId"]["output"]>;
    entityId: Scalars["FileEntityId"]["output"];
    filename: Scalars["String"]["output"];
    id: Scalars["SignatureRequestId"]["output"];
    ownedBy: Scalars["UserId"]["output"];
    signatureRequestFields: Array<SignatureRequestField>;
    signatureRequestRecipients: Array<SignatureRequestRecipient>;
    signatureTemplateFileId?: Maybe<Scalars["FileId"]["output"]>;
    sourceFileId: Scalars["FileId"]["output"];
    state: SignatureRequestState;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export type SignatureRequestCcRecipient = {
    __typename?: "SignatureRequestCcRecipient";
    email: Scalars["String"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type SignatureRequestCcRecipientInput = {
    email: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureRequestField = {
    __typename?: "SignatureRequestField";
    booleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    fieldType: SignatureFieldType;
    filledBy?: Maybe<Scalars["SignatureRequestRecipientId"]["output"]>;
    font: Scalars["String"]["output"];
    fontSize: Scalars["Int"]["output"];
    height: Scalars["Int"]["output"];
    id: Scalars["SignatureRequestFieldId"]["output"];
    isRequired: Scalars["Boolean"]["output"];
    order: Scalars["Int"]["output"];
    page: Scalars["Int"]["output"];
    placeholder?: Maybe<Scalars["String"]["output"]>;
    recipientIndex: Scalars["Int"]["output"];
    signatureRequest: SignatureRequest;
    textValue?: Maybe<Scalars["String"]["output"]>;
    width: Scalars["Int"]["output"];
    x: Scalars["Int"]["output"];
    y: Scalars["Int"]["output"];
};

export type SignatureRequestFieldPayload = {
    booleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    isRequired?: InputMaybe<Scalars["Boolean"]["input"]>;
    placeholder?: InputMaybe<Scalars["String"]["input"]>;
    signatureTemplateFieldId: Scalars["SignatureTemplateFieldId"]["input"];
    textValue?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureRequestFilter = {
    includeStates?: InputMaybe<Array<SignatureRequestState>>;
    regionId: Scalars["RegionId"]["input"];
    search?: InputMaybe<Scalars["String"]["input"]>;
};

export type SignatureRequestPayload = {
    ccRecipients?: InputMaybe<Array<SignatureRequestCcRecipientInput>>;
    completedEmailTemplate?: InputMaybe<EmailContentInput>;
    emailTemplate?: InputMaybe<EmailContentInput>;
    fields: Array<SignatureRequestFieldPayload>;
    fileEntityId: Scalars["FileEntityId"]["input"];
    fileId: Scalars["FileId"]["input"];
    recipients: Array<SignatureRequestRecipientPayload>;
};

export type SignatureRequestPerspective = {
    __typename?: "SignatureRequestPerspective";
    allSignatureRequestFields: Array<SignatureRequestField>;
    filename: Scalars["String"]["output"];
    logo: Scalars["String"]["output"];
    perspectiveSignatureRequestFields: Array<SignatureRequestField>;
    recipientCompletedAt: Scalars["DateTime"]["output"];
    recipientIndex: Scalars["Int"]["output"];
    recipientName: Scalars["String"]["output"];
    senderName: Scalars["String"]["output"];
    signable: Scalars["Boolean"]["output"];
};

export type SignatureRequestRecipient = {
    __typename?: "SignatureRequestRecipient";
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    email: Scalars["String"]["output"];
    id: Scalars["SignatureRequestRecipientId"]["output"];
    isComplete: Scalars["Boolean"]["output"];
    name: Scalars["String"]["output"];
    order: Scalars["Int"]["output"];
    remindAfter?: Maybe<Scalars["DateTime"]["output"]>;
    remindersSent: Scalars["Float"]["output"];
    updatedAt: Scalars["DateTime"]["output"];
};

export type SignatureRequestRecipientPayload = {
    email: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
};

export type SignatureRequestRecipientPayloadResponse = {
    __typename?: "SignatureRequestRecipientPayloadResponse";
    email: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
};

export enum SignatureRequestState {
    Abandoned = "Abandoned",
    Complete = "Complete",
    InProgress = "InProgress",
}

export type SignatureTemplate = {
    __typename?: "SignatureTemplate";
    completedEmailTemplate?: Maybe<EmailTemplate>;
    completedEmailTemplateId?: Maybe<Scalars["EmailTemplateId"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    createdBy: Scalars["UserId"]["output"];
    emailTemplate?: Maybe<EmailTemplate>;
    emailTemplateId?: Maybe<Scalars["EmailTemplateId"]["output"]>;
    fileId: Scalars["FileId"]["output"];
    id: Scalars["SignatureTemplateId"]["output"];
    recipientCount: Scalars["Int"]["output"];
    signatureTemplateFields: Array<SignatureTemplateField>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export type SignatureTemplateDeleteResponse = {
    __typename?: "SignatureTemplateDeleteResponse";
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type SignatureTemplateField = {
    __typename?: "SignatureTemplateField";
    defaultBooleanValue?: Maybe<Scalars["Boolean"]["output"]>;
    defaultTextValue?: Maybe<Scalars["String"]["output"]>;
    fieldType: SignatureFieldType;
    font: Scalars["String"]["output"];
    fontSize: Scalars["Int"]["output"];
    height: Scalars["Int"]["output"];
    id: Scalars["SignatureTemplateFieldId"]["output"];
    isRequired: Scalars["Boolean"]["output"];
    order: Scalars["Int"]["output"];
    page: Scalars["Int"]["output"];
    placeholder?: Maybe<Scalars["String"]["output"]>;
    recipientIndex: Scalars["Int"]["output"];
    signatureTemplate: SignatureTemplate;
    width: Scalars["Int"]["output"];
    x: Scalars["Int"]["output"];
    y: Scalars["Int"]["output"];
};

export type SignatureTemplateFieldInput = {
    defaultBooleanValue?: InputMaybe<Scalars["Boolean"]["input"]>;
    defaultTextValue?: InputMaybe<Scalars["String"]["input"]>;
    fieldType: SignatureFieldType;
    font: Scalars["String"]["input"];
    fontSize: Scalars["Int"]["input"];
    height: Scalars["Int"]["input"];
    id: Scalars["SignatureTemplateFieldId"]["input"];
    isRequired: Scalars["Boolean"]["input"];
    order: Scalars["Int"]["input"];
    page: Scalars["Int"]["input"];
    placeholder?: InputMaybe<Scalars["String"]["input"]>;
    recipientIndex: Scalars["Int"]["input"];
    signatureTemplateRecipientId?: InputMaybe<
        Scalars["SignatureTemplateRecipientId"]["input"]
    >;
    width: Scalars["Int"]["input"];
    x: Scalars["Int"]["input"];
    y: Scalars["Int"]["input"];
};

export type SignatureTemplateInput = {
    completedEmailTemplate?: InputMaybe<EmailContentInput>;
    emailTemplate?: InputMaybe<EmailContentInput>;
    recipientCount: Scalars["Int"]["input"];
    signatureTemplateFields: Array<SignatureTemplateFieldInput>;
};

export type SimpleSearchHit = {
    __typename?: "SimpleSearchHit";
    entityId: Scalars["SimpleSearchEntityId"]["output"];
    excerpt: Scalars["String"]["output"];
    type: Scalars["String"]["output"];
};

export type SimpleSearchRequest = {
    query: Scalars["String"]["input"];
    regionId: Scalars["RegionId"]["input"];
};

export type SimpleSearchResponse = {
    __typename?: "SimpleSearchResponse";
    hits: Array<SimpleSearchHit>;
};

export enum SmsConsentStatus {
    Implied = "Implied",
    NewContact = "NewContact",
    None = "None",
    Prior = "Prior",
    Subscribed = "Subscribed",
    Unsubscribed = "Unsubscribed",
}

export enum SmsDirection {
    Inbound = "Inbound",
    Outbound = "Outbound",
}

export type SmsMessage = {
    __typename?: "SmsMessage";
    body: Scalars["String"]["output"];
    createdBy: Scalars["UserId"]["output"];
    createdByUser: User;
    dateAdded: Scalars["IsoTimestamp"]["output"];
    direction: SmsDirection;
    externalId: Scalars["String"]["output"];
    from: Scalars["PhoneNumberE164"]["output"];
    id: Scalars["SmsMessageId"]["output"];
    status: SmsMessageStatus;
    tenantId: Scalars["TenantId"]["output"];
    to: Scalars["PhoneNumberE164"]["output"];
    updatedAt: Scalars["IsoTimestamp"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export enum SmsMessageStatus {
    Accepted = "Accepted",
    Delivered = "Delivered",
    Failed = "Failed",
    Queued = "Queued",
    Received = "Received",
    Scheduled = "Scheduled",
    Sent = "Sent",
    Undelivered = "Undelivered",
    Unknown = "Unknown",
}

export type SmsSent = {
    __typename?: "SmsSent";
    body: Scalars["String"]["output"];
};

/** SMS thread */
export type SmsThread = {
    __typename?: "SmsThread";
    contact: TelecomContact;
    messages: Array<SmsMessage>;
    ownerUserId?: Maybe<Scalars["UserId"]["output"]>;
    phoneLine: TelecomPhoneLine;
};

export enum SmtpAuthenticationType {
    Gmail = "Gmail",
    Graph = "Graph",
    Password = "Password",
}

export type SmtpCredential = {
    __typename?: "SmtpCredential";
    authenticationType: SmtpAuthenticationType;
    host: Scalars["String"]["output"];
    id: Scalars["SmtpCredentialId"]["output"];
    port: Scalars["Int"]["output"];
    provider?: Maybe<UserMailboxProvider>;
    status: SmtpCredentialStatus;
    username: Scalars["String"]["output"];
};

export enum SmtpCredentialStatus {
    Active = "Active",
    Disconnected = "Disconnected",
}

export type SmtpSaveResult = {
    __typename?: "SmtpSaveResult";
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

/** Special: CommunityComparison defaults (enabled if object defined) */
export type SpecialCommunityComparisonDefaults = {
    __typename?: "SpecialCommunityComparisonDefaults";
    attachCommunityPDFByDefault: Scalars["Boolean"]["output"];
    coverPageTemplateId?: Maybe<Scalars["EmailTemplateId"]["output"]>;
    liveLinkText: Scalars["String"]["output"];
    showCoverPage: Scalars["Boolean"]["output"];
    showRecords: Scalars["Boolean"]["output"];
    showSummary: Scalars["Boolean"]["output"];
    useLiveLinkByDefault: Scalars["Boolean"]["output"];
};

export type SpecificUserAudience = {
    __typename?: "SpecificUserAudience";
    groupIds: Array<Scalars["UserGroupId"]["output"]>;
    userIds: Array<Scalars["UserId"]["output"]>;
};

export type SpecificUserAudienceInput = {
    groupIds: Array<Scalars["UserGroupId"]["input"]>;
    userIds: Array<Scalars["UserId"]["input"]>;
};

export type StateReportQueryRow = {
    __typename?: "StateReportQueryRow";
    regionid: Scalars["RegionId"]["output"];
    regionkey: Scalars["String"]["output"];
    regionname: Scalars["String"]["output"];
    state: Scalars["String"]["output"];
    tenantid: Scalars["TenantId"]["output"];
    tenantname: Scalars["String"]["output"];
    thecount: Scalars["Int"]["output"];
    totalrlmcount: Scalars["Int"]["output"];
};

/** Update a field to equal a string value */
export type StringColumnUpdate = {
    key: Scalars["String"]["input"];
    value: Scalars["String"]["input"];
};

export type SuggestedAreaCode = {
    __typename?: "SuggestedAreaCode";
    areaCode: Scalars["AreaCode"]["output"];
    metroName: Scalars["String"]["output"];
};

export type SuperUserSecurityHealth = {
    __typename?: "SuperUserSecurityHealth";
    inactiveSuperUsers: Array<SuperUserSecurityRecord>;
    superUsersWithoutMfa: Array<SuperUserSecurityRecord>;
};

export type SuperUserSecurityRecord = {
    __typename?: "SuperUserSecurityRecord";
    createdAt: Scalars["String"]["output"];
    email: Scalars["String"]["output"];
    lastLoginAt?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    tenantId: Scalars["TenantId"]["output"];
    twoFactorEnabled: Scalars["Boolean"]["output"];
    userId: Scalars["UserId"]["output"];
};

export type SuperuserResetPasswordResult = {
    __typename?: "SuperuserResetPasswordResult";
    password: Scalars["String"]["output"];
    userId: Scalars["String"]["output"];
};

export type SystemConfiguration = {
    __typename?: "SystemConfiguration";
    fileStorage: Scalars["String"]["output"];
};

export type Task = {
    __typename?: "Task";
    activityEntities?: Maybe<Array<Activity>>;
    appLink: Scalars["String"]["output"];
    completedAt?: Maybe<Scalars["DateTime"]["output"]>;
    compositeDueDateTime?: Maybe<Scalars["DateTime"]["output"]>;
    createdAt?: Maybe<Scalars["DateTime"]["output"]>;
    done: Scalars["Boolean"]["output"];
    dueDate?: Maybe<Scalars["String"]["output"]>;
    dueDateTime?: Maybe<Scalars["DateTime"]["output"]>;
    id: Scalars["TaskId"]["output"];
    notes?: Maybe<Scalars["String"]["output"]>;
    ownerId?: Maybe<Scalars["UserId"]["output"]>;
    parentClient?: Maybe<Client>;
    parentCommunity?: Maybe<Community>;
    parentHomeCareLead?: Maybe<HomeCareLead>;
    parentId: Scalars["TaskParentId"]["output"];
    parentReferenceBusiness?: Maybe<ReferenceBusiness>;
    parentReferenceContact?: Maybe<ReferenceContact>;
    recurrenceDayOfMonth?: Maybe<Scalars["Float"]["output"]>;
    recurrenceDaysOfWeek?: Maybe<Array<DayOfWeek>>;
    recurrenceInterval?: Maybe<Scalars["Float"]["output"]>;
    recurrencePattern?: Maybe<RecurrencePattern>;
    status: Scalars["String"]["output"];
    taskType?: Maybe<TaskType>;
    taskTypeId?: Maybe<Scalars["TaskTypeId"]["output"]>;
    text?: Maybe<Scalars["String"]["output"]>;
    type?: Maybe<Scalars["String"]["output"]>;
    updatedAt?: Maybe<Scalars["DateTime"]["output"]>;
};

export type TaskType = {
    __typename?: "TaskType";
    category: Scalars["String"]["output"];
    id: Scalars["TaskTypeId"]["output"];
    name: Scalars["String"]["output"];
};

export type TelecomContact = {
    __typename?: "TelecomContact";
    id: Scalars["TelecomContactId"]["output"];
    phoneNumber: Scalars["PhoneNumberE164"]["output"];
};

export type TelecomContactStatus = {
    __typename?: "TelecomContactStatus";
    canSend: Scalars["Boolean"]["output"];
    consentStatus: SmsConsentStatus;
    needsStopReminder: Scalars["Boolean"]["output"];
    phoneNumber: Scalars["PhoneNumberE164"]["output"];
};

export type TelecomPhoneLine = {
    __typename?: "TelecomPhoneLine";
    createdAt: Scalars["IsoTimestamp"]["output"];
    credentialType: TelecomPhoneLineCredentialType;
    externalId: Scalars["String"]["output"];
    id: Scalars["TelecomPhoneLineId"]["output"];
    phoneNumber: Scalars["PhoneNumberE164"]["output"];
    status: TelecomPhoneLineStatus;
    tenantCredentialId?: Maybe<Scalars["TenantCredentialId"]["output"]>;
    updatedAt: Scalars["IsoTimestamp"]["output"];
    userId: Scalars["UserId"]["output"];
};

export enum TelecomPhoneLineCredentialType {
    Global = "Global",
    Tenant = "Tenant",
}

export enum TelecomPhoneLineStatus {
    Active = "Active",
    Provisioning = "Provisioning",
}

export type TemplateList = {
    __typename?: "TemplateList";
    templates: Array<TemplateResponse>;
};

export type TemplateResponse = {
    __typename?: "TemplateResponse";
    author: User;
    isDefaultSignature: Scalars["Boolean"]["output"];
    isEditable: Scalars["Boolean"]["output"];
    template: EmailTemplate;
};

export type TemplateUpdate = {
    attachments?: InputMaybe<Array<Scalars["FileId"]["input"]>>;
    body: Scalars["String"]["input"];
    description: Scalars["String"]["input"];
    entityRegionVisibility?: InputMaybe<EntityRegionVisibilityInput>;
    id?: InputMaybe<Scalars["EmailTemplateId"]["input"]>;
    isDefaultSignature: Scalars["Boolean"]["input"];
    isShared: Scalars["Boolean"]["input"];
    isSignature?: InputMaybe<Scalars["Boolean"]["input"]>;
    migrationVersion: Scalars["Int"]["input"];
    subject?: InputMaybe<Scalars["String"]["input"]>;
    type?: InputMaybe<Scalars["String"]["input"]>;
};

export type TemplateValidationResponse = {
    __typename?: "TemplateValidationResponse";
    isValid: Scalars["Boolean"]["output"];
    message?: Maybe<Scalars["String"]["output"]>;
    missingTokens: Array<TemplateValidationTokenWarning>;
};

export type TemplateValidationTokenWarning = {
    __typename?: "TemplateValidationTokenWarning";
    description: Scalars["String"]["output"];
    humanFriendlyName: Scalars["String"]["output"];
    tokenKey: Scalars["String"]["output"];
};

/** Tenant */
export type Tenant = {
    __typename?: "Tenant";
    /** Active users who are visible and not "system" users */
    activeHumanUsers: Scalars["Int"]["output"];
    activeUsers: Scalars["Int"]["output"];
    baaDocumentUrl?: Maybe<Scalars["String"]["output"]>;
    baaEnforced: Scalars["Boolean"]["output"];
    billableEntityId: Scalars["BillableEntityId"]["output"];
    communicationAcknowledgmentUrl?: Maybe<Scalars["String"]["output"]>;
    credentials: Array<TenantCredential>;
    customAppDomain?: Maybe<Scalars["String"]["output"]>;
    customDomains: Array<Scalars["String"]["output"]>;
    customProductName?: Maybe<Scalars["String"]["output"]>;
    dateAdded: Scalars["String"]["output"];
    emailProvider: ExternalEmailProvider;
    features: Array<TenantFeature>;
    franchiseManagementEnabled: Scalars["Boolean"]["output"];
    id: Scalars["TenantId"]["output"];
    internalEmailSender?: Maybe<Scalars["String"]["output"]>;
    legacySku: Scalars["String"]["output"];
    name: Scalars["String"]["output"];
    productName: Scalars["String"]["output"];
    /** List of regions */
    regions: Array<Region>;
    /** @deprecated Use skus */
    sku: Scalars["String"]["output"];
    skus: Array<Scalars["String"]["output"]>;
    supportEmailAddress?: Maybe<Scalars["String"]["output"]>;
    users: Array<User>;
    whiteLabelContentMode: WhiteLabelContentMode;
};

/** Tenant Credential */
export type TenantCredential = {
    __typename?: "TenantCredential";
    constantContactDetails?: Maybe<ConstantContactDetails>;
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["TenantCredentialId"]["output"];
    mailchimpDetails?: Maybe<MailchimpDetails>;
    name: Scalars["String"]["output"];
    quickBooksDetails?: Maybe<QuickBooksDetails>;
    regionVisibility?: Maybe<EntityRegionVisibility>;
    status: TenantCredentialStatus;
    tenant: Tenant;
    twilioDetails?: Maybe<TwilioDetails>;
    type: TenantCredentialType;
    updatedAt: Scalars["DateTime"]["output"];
    wellSkyPersonalCareDetails?: Maybe<WellSkyPersonalCareDetails>;
};

export enum TenantCredentialStatus {
    Active = "Active",
    Disconnected = "Disconnected",
}

export enum TenantCredentialType {
    AxisCare = "AxisCare",
    ConstantContact = "ConstantContact",
    Mailchimp = "Mailchimp",
    QuickBooks = "QuickBooks",
    Twilio = "Twilio",
    WellSkyPersonalCare = "WellSkyPersonalCare",
    WellSkyPersonalCareApi = "WellSkyPersonalCareApi",
}

/** Feature value for tenant */
export type TenantFeature = {
    __typename?: "TenantFeature";
    enabled: Scalars["Boolean"]["output"];
    enabledUpstream: Scalars["Boolean"]["output"];
    name: Scalars["ID"]["output"];
};

/** Tenant history entry */
export type TenantHistory = {
    __typename?: "TenantHistory";
    author: User;
    dateAdded: Scalars["DateTime"]["output"];
    id: Scalars["UUID"]["output"];
    message: Scalars["String"]["output"];
    tenant: Tenant;
};

export type TenantMessagingConfiguration = {
    __typename?: "TenantMessagingConfiguration";
    customDomains: Array<Scalars["String"]["output"]>;
    trackingLevel: MessageTrackingLevel;
};

export type TenantSetting = {
    __typename?: "TenantSetting";
    key: Scalars["String"]["output"];
    value: SettingValue;
};

export type TenantSettingsResult = {
    __typename?: "TenantSettingsResult";
    settings: Array<TenantSetting>;
    tenantId: Scalars["TenantId"]["output"];
};

export type TestResponse = {
    __typename?: "TestResponse";
    val: Scalars["Int"]["output"];
};

/** Live community comparison token */
export type Token = {
    __typename?: "Token";
    clientId: Scalars["PlacementId"]["output"];
    id: Scalars["TokenId"]["output"];
    includeContacts: Scalars["Boolean"]["output"];
    includeFinancial: Scalars["Boolean"]["output"];
    includeLicensing: Scalars["Boolean"]["output"];
    sectionKeys?: Maybe<Array<LayoutSectionKey>>;
    tenantId: Scalars["TenantId"]["output"];
    token: Scalars["String"]["output"];
    url: Scalars["String"]["output"];
    userId: Scalars["UserId"]["output"];
};

export type TouchpointLogged = {
    __typename?: "TouchpointLogged";
    channel: Scalars["String"]["output"];
    note?: Maybe<Scalars["String"]["output"]>;
};

export enum TouchpointSnoozeScope {
    Business = "Business",
    Contact = "Contact",
    Touchpoint = "Touchpoint",
}

export type TouchpointSnoozed = {
    __typename?: "TouchpointSnoozed";
    reason?: Maybe<Scalars["String"]["output"]>;
    scope: TouchpointSnoozeScope;
    snoozeUntil: Scalars["String"]["output"];
};

export type Tour = {
    __typename?: "Tour";
    appLink: Scalars["String"]["output"];
    /** @deprecated use placement */
    client?: Maybe<Client>;
    /** @deprecated use placementId */
    clientId?: Maybe<Scalars["PlacementId"]["output"]>;
    community?: Maybe<Community>;
    communityId: Scalars["CommunityId"]["output"];
    dateAdded: Scalars["IsoTimestamp"]["output"];
    familyNotes?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["TourId"]["output"];
    placement?: Maybe<Client>;
    placementId?: Maybe<Scalars["PlacementId"]["output"]>;
    privateNotes?: Maybe<Scalars["String"]["output"]>;
    showOnFamilyView: Scalars["Boolean"]["output"];
    tourDate: Scalars["CalendarDateSerialized"]["output"];
    tourDuration: Scalars["Int"]["output"];
    tourTime?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["IsoTimestamp"]["output"];
    userId: Scalars["UserId"]["output"];
};

export type TrackExternalSignupRequestInput = {
    externalCampaignId?: InputMaybe<Scalars["String"]["input"]>;
    externalLeadId: Scalars["String"]["input"];
    externalSentMessageId: Scalars["String"]["input"];
    externalSequenceId?: InputMaybe<Scalars["String"]["input"]>;
    listingSlug: Scalars["String"]["input"];
    recipientEmails: Array<Scalars["String"]["input"]>;
    timestamp: Scalars["DateTime"]["input"];
};

export type TransferClientRequest = {
    clientId: Scalars["PlacementId"]["input"];
    note?: InputMaybe<Scalars["String"]["input"]>;
    toUserProfileId: Scalars["UserProfileId"]["input"];
};

export type TriggerAudienceSyncGraphQlInput = {
    audienceId: Scalars["AudienceId"]["input"];
    listId: Scalars["String"]["input"];
    provider: EmailMarketingProvider;
    regionId: Scalars["RegionId"]["input"];
};

export type TriggerFieldMatcherEntity = {
    __typename?: "TriggerFieldMatcherEntity";
    current?: Maybe<WorkflowTriggerFieldValueEntityValueType>;
    fieldName: Scalars["String"]["output"];
};

export type TriggerFieldMatcherEntityInput = {
    current?: InputMaybe<WorkflowTriggerFieldValueEntityValueTypeInput>;
    fieldName: Scalars["String"]["input"];
};

/** Twilio Credential Details */
export type TwilioDetails = {
    __typename?: "TwilioDetails";
    accountSid: Scalars["String"]["output"];
};

/** Two-factor authentication method */
export enum TwoFactorMethod {
    Email = "Email",
    Sms = "Sms",
}

export type TwoFactorSendCodeInput = {
    method: TwoFactorMethod;
};

export type TwoFactorSetupCodeInput = {
    code: Scalars["String"]["input"];
    method: TwoFactorMethod;
};

export type TwoFactorSetupInput = {
    method: TwoFactorMethod;
    password: Scalars["String"]["input"];
    phoneNumber?: InputMaybe<Scalars["PhoneNumberE164"]["input"]>;
};

export type TwoFactorSetupResult = {
    __typename?: "TwoFactorSetupResult";
    success: Scalars["Boolean"]["output"];
};

export type TwoFactorVerificationResult = {
    __typename?: "TwoFactorVerificationResult";
    message?: Maybe<Scalars["String"]["output"]>;
    success: Scalars["Boolean"]["output"];
};

export type UpdateAudienceGraphQlInput = {
    id: Scalars["String"]["input"];
    name?: InputMaybe<Scalars["String"]["input"]>;
    query?: InputMaybe<AudienceQueryInput>;
    regionId: Scalars["RegionId"]["input"];
};

export type UpdateNoteInput = {
    dateAdded?: InputMaybe<Scalars["DateTime"]["input"]>;
    dateAddedOverride?: InputMaybe<Scalars["DateTime"]["input"]>;
    isPinned?: InputMaybe<Scalars["Boolean"]["input"]>;
    isPublished?: InputMaybe<Scalars["Boolean"]["input"]>;
    text: Scalars["UserText"]["input"];
    updatedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
};

export type UpdateTaskPayload = {
    completedAt?: InputMaybe<Scalars["DateTime"]["input"]>;
    dueDate?: InputMaybe<Scalars["String"]["input"]>;
    dueDateTime?: InputMaybe<Scalars["DateTime"]["input"]>;
    notes?: InputMaybe<Scalars["String"]["input"]>;
    ownerId?: InputMaybe<Scalars["UserId"]["input"]>;
    recurrenceDayOfMonth?: InputMaybe<Scalars["Float"]["input"]>;
    recurrenceDaysOfWeek?: InputMaybe<Array<DayOfWeek>>;
    recurrenceInterval?: InputMaybe<Scalars["Float"]["input"]>;
    recurrencePattern?: InputMaybe<RecurrencePattern>;
    status?: InputMaybe<Scalars["String"]["input"]>;
    taskTypeId?: InputMaybe<Scalars["TaskTypeId"]["input"]>;
    text?: InputMaybe<Scalars["String"]["input"]>;
};

export type UpdateTokenRequest = {
    clientId: Scalars["PlacementId"]["input"];
    includeContacts: Scalars["Boolean"]["input"];
    includeFinancial: Scalars["Boolean"]["input"];
    includeLicensing: Scalars["Boolean"]["input"];
    sectionKeys?: InputMaybe<Array<LayoutSectionKey>>;
};

export enum UploadSource {
    AuthenticatedUser = "AuthenticatedUser",
    System = "System",
    UnauthenticatedUser = "UnauthenticatedUser",
}

export type UpsertUserTerritoryRequest = {
    address?: InputMaybe<Scalars["String"]["input"]>;
    city?: InputMaybe<Scalars["String"]["input"]>;
    county?: InputMaybe<Scalars["String"]["input"]>;
    distance?: InputMaybe<Scalars["Int"]["input"]>;
    state?: InputMaybe<Scalars["String"]["input"]>;
    type: UserTerritoryType;
    zip?: InputMaybe<Scalars["String"]["input"]>;
};

/** User */
export type User = {
    __typename?: "User";
    activatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    apiToken: Scalars["String"]["output"];
    calendarToken: Scalars["String"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    deactivatedAt?: Maybe<Scalars["DateTime"]["output"]>;
    disabled: Scalars["Boolean"]["output"];
    displayEmail?: Maybe<Scalars["String"]["output"]>;
    displayName: Scalars["String"]["output"];
    email: Scalars["String"]["output"];
    /** [internal] User's first name for bulk emails */
    firstName?: Maybe<Scalars["String"]["output"]>;
    hidden: Scalars["Boolean"]["output"];
    hideSmtpWarning: Scalars["Boolean"]["output"];
    id: Scalars["UserId"]["output"];
    /** User's preferred name */
    name?: Maybe<Scalars["String"]["output"]>;
    permissions: Array<Permission>;
    phone?: Maybe<Scalars["PhoneNumberE164"]["output"]>;
    preferredName: Scalars["String"]["output"];
    tenant: Tenant;
    tenantId: Scalars["TenantId"]["output"];
    token?: Maybe<Scalars["String"]["output"]>;
    twoFactorEmailEnabled: Scalars["Boolean"]["output"];
    twoFactorSmsEnabled: Scalars["Boolean"]["output"];
    type: UserType;
    updatedAt: Scalars["DateTime"]["output"];
};

export type UserAudience = {
    __typename?: "UserAudience";
    specific?: Maybe<SpecificUserAudience>;
    type: UserAudienceType;
};

export type UserAudienceInput = {
    specific?: InputMaybe<SpecificUserAudienceInput>;
    type: UserAudienceType;
};

export enum UserAudienceType {
    Everyone = "Everyone",
    Specific = "Specific",
}

/** Lightweight placeholder for user, safe for sending to any logged in user. */
export type UserDescriptor = {
    __typename?: "UserDescriptor";
    disabled: Scalars["Boolean"]["output"];
    email: Scalars["String"]["output"];
    hidden: Scalars["Boolean"]["output"];
    id: Scalars["UserId"]["output"];
    preferredName: Scalars["String"]["output"];
    type: UserType;
};

export type UserGroupResult = {
    __typename?: "UserGroupResult";
    id: Scalars["UserGroupId"]["output"];
    name: Scalars["String"]["output"];
};

export type UserMailbox = {
    __typename?: "UserMailbox";
    email?: Maybe<Scalars["String"]["output"]>;
    id: Scalars["UserMailboxId"]["output"];
    isHistoricalSyncRunning: Scalars["Boolean"]["output"];
    provider: UserMailboxProvider;
    status: UserMailboxStatus;
};

export type UserMailboxContact = {
    __typename?: "UserMailboxContact";
    email: Scalars["String"]["output"];
    id: Scalars["UserMailboxContactId"]["output"];
    name: Scalars["String"]["output"];
    resolvedName?: Maybe<Scalars["String"]["output"]>;
};

export type UserMailboxMessage = {
    __typename?: "UserMailboxMessage";
    attachmentCount: Scalars["Int"]["output"];
    bcc: Array<UserMailboxMessageRecipient>;
    bodyPreview: Scalars["String"]["output"];
    cc: Array<UserMailboxMessageRecipient>;
    createdAt: Scalars["IsoTimestamp"]["output"];
    externalId: Scalars["String"]["output"];
    from?: Maybe<UserMailboxContact>;
    id: Scalars["UserMailboxMessageId"]["output"];
    isDraft: Scalars["Boolean"]["output"];
    isRead: Scalars["Boolean"]["output"];
    providerMessageId: Scalars["String"]["output"];
    receivedTimestamp: Scalars["IsoTimestamp"]["output"];
    recipients: Array<UserMailboxMessageRecipient>;
    replyTo: Array<UserMailboxMessageRecipient>;
    sender?: Maybe<UserMailboxContact>;
    sentTimestamp: Scalars["IsoTimestamp"]["output"];
    subject: Scalars["String"]["output"];
    threadId?: Maybe<Scalars["String"]["output"]>;
    to: Array<UserMailboxMessageRecipient>;
};

export type UserMailboxMessageRecipient = {
    __typename?: "UserMailboxMessageRecipient";
    contact: UserMailboxContact;
    id: Scalars["UserMailboxMessageRecipientId"]["output"];
    order: Scalars["Int"]["output"];
    type: UserMailboxMessageRecipientType;
};

export enum UserMailboxMessageRecipientType {
    Bcc = "Bcc",
    Cc = "Cc",
    ReplyTo = "ReplyTo",
    To = "To",
}

export enum UserMailboxProvider {
    Gmail = "Gmail",
    Outlook = "Outlook",
}

export enum UserMailboxStatus {
    Active = "Active",
    Authenticated = "Authenticated",
    Authenticating = "Authenticating",
    Disconnected = "Disconnected",
}

export type UserMessagingConfiguration = {
    __typename?: "UserMessagingConfiguration";
    directSmtp: Scalars["Boolean"]["output"];
};

export type UserProfile = {
    __typename?: "UserProfile";
    approach: Scalars["String"]["output"];
    businessName: Scalars["String"]["output"];
    certifications: Array<Scalars["String"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    createdBy: Scalars["UserId"]["output"];
    email: Scalars["String"]["output"];
    id: Scalars["UserProfileId"]["output"];
    isComplete: Scalars["Boolean"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    name: Scalars["String"]["output"];
    phone: Scalars["PhoneNumberE164"]["output"];
    pictureUrl?: Maybe<Scalars["String"]["output"]>;
    referenceContacts: Array<ReferenceContact>;
    status: UserProfileStatus;
    summary: Scalars["String"]["output"];
    territories: Array<UserTerritory>;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
    verticals: Array<Scalars["String"]["output"]>;
    website?: Maybe<Scalars["String"]["output"]>;
};

export type UserProfileCoordinates = {
    __typename?: "UserProfileCoordinates";
    id: Scalars["UserProfileId"]["output"];
    lat: Scalars["Float"]["output"];
    lng: Scalars["Float"]["output"];
    name?: Maybe<Scalars["String"]["output"]>;
};

export type UserProfileMarkerCollection = {
    __typename?: "UserProfileMarkerCollection";
    coordinates?: Maybe<Coordinates>;
    recommendedZoom: Scalars["Float"]["output"];
    userProfileClusters: Array<MapCluster>;
    userProfileCoordinates: Array<UserProfileCoordinates>;
};

export enum UserProfileStatus {
    Private = "Private",
    Public = "Public",
}

/** A single user's result in a single time segment in a client placement report */
export type UserReportSegment = {
    __typename?: "UserReportSegment";
    /** Moves for user */
    moves: Scalars["Int"]["output"];
    /** Revenue for user */
    revenue: Scalars["Float"]["output"];
    /** Assigned user */
    user?: Maybe<ConcreteUser>;
};

export type UserTenantRegionOption = {
    __typename?: "UserTenantRegionOption";
    regionId: Scalars["RegionId"]["output"];
    regionKey: Scalars["String"]["output"];
    regionName: Scalars["String"]["output"];
    tenantId: Scalars["TenantId"]["output"];
    tenantName: Scalars["String"]["output"];
    userId: Scalars["UserId"]["output"];
};

export type UserTenantRegionOptions = {
    __typename?: "UserTenantRegionOptions";
    options: Array<UserTenantRegionOption>;
    preferredRegionId?: Maybe<Scalars["RegionId"]["output"]>;
};

export type UserTerritory = {
    __typename?: "UserTerritory";
    address?: Maybe<Scalars["String"]["output"]>;
    city?: Maybe<Scalars["String"]["output"]>;
    county?: Maybe<Scalars["String"]["output"]>;
    createdAt: Scalars["DateTime"]["output"];
    distance?: Maybe<Scalars["Int"]["output"]>;
    id: Scalars["UserTerritoryId"]["output"];
    latitude?: Maybe<Scalars["String"]["output"]>;
    longitude?: Maybe<Scalars["String"]["output"]>;
    state?: Maybe<Scalars["String"]["output"]>;
    tenantId: Scalars["TenantId"]["output"];
    type: UserTerritoryType;
    updatedAt: Scalars["DateTime"]["output"];
    userProfileId: Scalars["UserProfileId"]["output"];
    zip?: Maybe<Scalars["String"]["output"]>;
};

export enum UserTerritoryType {
    Proximity = "Proximity",
}

export enum UserType {
    System = "System",
    User = "User",
}

export enum VirusScanStatus {
    Clean = "Clean",
    Error = "Error",
    Infected = "Infected",
    NotRequired = "NotRequired",
    Pending = "Pending",
    Scanning = "Scanning",
}

export type VisitScheduled = {
    __typename?: "VisitScheduled";
    eventDate: Scalars["String"]["output"];
    title?: Maybe<Scalars["String"]["output"]>;
};

export type VoiceCall = {
    __typename?: "VoiceCall";
    createdBy: Scalars["UserId"]["output"];
    createdByUser: User;
    dateAdded: Scalars["IsoTimestamp"]["output"];
    direction: VoiceCallDirection;
    externalId?: Maybe<Scalars["String"]["output"]>;
    from: Scalars["PhoneNumberE164"]["output"];
    id: Scalars["VoiceCallId"]["output"];
    recordingDurationSec?: Maybe<Scalars["Int"]["output"]>;
    recordingSid?: Maybe<Scalars["String"]["output"]>;
    recordingStatus?: Maybe<Scalars["String"]["output"]>;
    summary?: Maybe<Scalars["String"]["output"]>;
    tenantId: Scalars["TenantId"]["output"];
    to: Scalars["PhoneNumberE164"]["output"];
    transcriptStatus?: Maybe<Scalars["String"]["output"]>;
    updatedAt: Scalars["IsoTimestamp"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export enum VoiceCallDirection {
    Inbound = "Inbound",
    Outbound = "Outbound",
}

export type VoiceToken = {
    __typename?: "VoiceToken";
    identity: Scalars["String"]["output"];
    token: Scalars["String"]["output"];
};

/** WellSky Personal Care Credential Details */
export type WellSkyPersonalCareDetails = {
    __typename?: "WellSkyPersonalCareDetails";
    accountName: Scalars["String"]["output"];
    username: Scalars["String"]["output"];
};

export enum WhiteLabelContentMode {
    Full = "Full",
    Restricted = "Restricted",
}

export type Workflow = {
    __typename?: "Workflow";
    actions: Array<WorkflowActionEntityType>;
    actorMode: WorkflowActorMode;
    attachTo: AdvancedSearchEntityType;
    createdBy: Scalars["UserId"]["output"];
    dateAdded: Scalars["DateTime"]["output"];
    defaultActorId: Scalars["UserId"]["output"];
    delay: Scalars["Int"]["output"];
    delayRecipe?: Maybe<Scalars["String"]["output"]>;
    description: Scalars["String"]["output"];
    id: Scalars["WorkflowId"]["output"];
    name: Scalars["String"]["output"];
    regionVisibility?: Maybe<EntityRegionVisibility>;
    settings: Array<WorkflowPayloadSettings>;
    status: WorkflowStatus;
    tenantId: Scalars["TenantId"]["output"];
    trigger: WorkflowTriggerEntity;
    updatedAt: Scalars["DateTime"]["output"];
    updatedBy: Scalars["UserId"]["output"];
};

export type WorkflowActionEmailEntity = {
    __typename?: "WorkflowActionEmailEntity";
    attachments?: Maybe<Scalars["String"]["output"]>;
    bccMyself?: Maybe<Scalars["String"]["output"]>;
    body: Scalars["String"]["output"];
    delayRecipe?: Maybe<Scalars["String"]["output"]>;
    discreteTo?: Maybe<Scalars["String"]["output"]>;
    id?: Maybe<Scalars["WorkflowActionId"]["output"]>;
    subject: Scalars["String"]["output"];
    to: Scalars["String"]["output"];
};

export type WorkflowActionEmailEntityInput = {
    attachments?: InputMaybe<Scalars["String"]["input"]>;
    bccMyself?: InputMaybe<Scalars["String"]["input"]>;
    body: Scalars["String"]["input"];
    delayRecipe?: InputMaybe<Scalars["String"]["input"]>;
    discreteTo?: InputMaybe<Scalars["String"]["input"]>;
    id?: InputMaybe<Scalars["WorkflowActionId"]["input"]>;
    subject: Scalars["String"]["input"];
    to: Scalars["String"]["input"];
};

export type WorkflowActionEntityInput = {
    email?: InputMaybe<WorkflowActionEmailEntityInput>;
    sms?: InputMaybe<WorkflowActionSmsEntityInput>;
    task?: InputMaybe<WorkflowActionTaskEntityInput>;
};

export type WorkflowActionEntityType =
    | WorkflowActionEmailEntity
    | WorkflowActionSmsEntity
    | WorkflowActionTaskEntity;

export type WorkflowActionSmsEntity = {
    __typename?: "WorkflowActionSmsEntity";
    body: Scalars["String"]["output"];
    consentAcknowledged: Scalars["Boolean"]["output"];
    delayRecipe?: Maybe<Scalars["String"]["output"]>;
    fromPhoneLineId?: Maybe<Scalars["TelecomPhoneLineId"]["output"]>;
    id?: Maybe<Scalars["WorkflowActionId"]["output"]>;
    to: Scalars["String"]["output"];
};

export type WorkflowActionSmsEntityInput = {
    body: Scalars["String"]["input"];
    consentAcknowledged: Scalars["Boolean"]["input"];
    delayRecipe?: InputMaybe<Scalars["String"]["input"]>;
    fromPhoneLineId?: InputMaybe<Scalars["TelecomPhoneLineId"]["input"]>;
    id?: InputMaybe<Scalars["WorkflowActionId"]["input"]>;
    to: Scalars["String"]["input"];
};

export type WorkflowActionTaskEntity = {
    __typename?: "WorkflowActionTaskEntity";
    assignedTo?: Maybe<Scalars["String"]["output"]>;
    delayRecipe?: Maybe<Scalars["String"]["output"]>;
    dueDate: Scalars["String"]["output"];
    id?: Maybe<Scalars["WorkflowActionId"]["output"]>;
    notification?: Maybe<WorkflowActionTaskNotification>;
    notifyOwner?: Maybe<Scalars["Boolean"]["output"]>;
    recurrenceDayOfMonth?: Maybe<Scalars["String"]["output"]>;
    recurrenceDaysOfWeek?: Maybe<Scalars["String"]["output"]>;
    recurrenceInterval?: Maybe<Scalars["String"]["output"]>;
    recurrencePattern?: Maybe<Scalars["String"]["output"]>;
    taskTypeId?: Maybe<Scalars["String"]["output"]>;
    text: Scalars["String"]["output"];
};

export type WorkflowActionTaskEntityInput = {
    assignedTo?: InputMaybe<Scalars["String"]["input"]>;
    delayRecipe?: InputMaybe<Scalars["String"]["input"]>;
    dueDate: Scalars["String"]["input"];
    id?: InputMaybe<Scalars["WorkflowActionId"]["input"]>;
    notification?: InputMaybe<WorkflowActionTaskNotificationInput>;
    notifyOwner?: InputMaybe<Scalars["Boolean"]["input"]>;
    recurrenceDayOfMonth?: InputMaybe<Scalars["String"]["input"]>;
    recurrenceDaysOfWeek?: InputMaybe<Scalars["String"]["input"]>;
    recurrenceInterval?: InputMaybe<Scalars["String"]["input"]>;
    recurrencePattern?: InputMaybe<Scalars["String"]["input"]>;
    taskTypeId?: InputMaybe<Scalars["String"]["input"]>;
    text: Scalars["String"]["input"];
};

export type WorkflowActionTaskNotification = {
    __typename?: "WorkflowActionTaskNotification";
    subject?: Maybe<Scalars["String"]["output"]>;
};

export type WorkflowActionTaskNotificationInput = {
    subject?: InputMaybe<Scalars["String"]["input"]>;
};

export enum WorkflowActorMode {
    AssignedUser = "AssignedUser",
    DefaultActor = "DefaultActor",
}

export enum WorkflowEventType {
    EmailOpened = "EmailOpened",
    EntityUpdated = "EntityUpdated",
    NoteAdded = "NoteAdded",
    NoteDeleted = "NoteDeleted",
    NoteUpdated = "NoteUpdated",
    PipelineStageChanged = "PipelineStageChanged",
    Schedule = "Schedule",
}

export type WorkflowExecution = {
    __typename?: "WorkflowExecution";
    actionId?: Maybe<Scalars["WorkflowActionId"]["output"]>;
    appLink: Scalars["String"]["output"];
    cancelledAt?: Maybe<Scalars["DateTime"]["output"]>;
    client?: Maybe<Client>;
    dateAdded: Scalars["DateTime"]["output"];
    entityId: Scalars["WorkflowTargetId"]["output"];
    finishedAt?: Maybe<Scalars["DateTime"]["output"]>;
    homeCareLead?: Maybe<HomeCareLead>;
    id: Scalars["WorkflowExecutionId"]["output"];
    isCancelRequested: Scalars["Boolean"]["output"];
    referenceBusiness?: Maybe<ReferenceBusiness>;
    referenceContact?: Maybe<ReferenceContact>;
    result?: Maybe<WorkflowExecutionResult>;
    resultDetail?: Maybe<Scalars["String"]["output"]>;
    scheduledAt?: Maybe<Scalars["DateTime"]["output"]>;
    updatedAt: Scalars["DateTime"]["output"];
    workflow: Workflow;
};

/** The result of a workflow execution */
export enum WorkflowExecutionResult {
    Cancelled = "Cancelled",
    Error = "Error",
    Pending = "Pending",
    Success = "Success",
    Warning = "Warning",
}

export type WorkflowPayload = {
    actionEntities: Array<WorkflowActionEntityInput>;
    actorMode: WorkflowActorMode;
    attachTo: AdvancedSearchEntityType;
    defaultActorId: Scalars["UserId"]["input"];
    delay: Scalars["Int"]["input"];
    delayRecipe?: InputMaybe<Scalars["String"]["input"]>;
    description: Scalars["String"]["input"];
    name: Scalars["String"]["input"];
    regionVisibility: EntityRegionVisibilityInput;
    settings: Array<WorkflowPayloadSettingsInput>;
    status: WorkflowStatus;
    triggerInput: WorkflowTriggerInput;
};

export type WorkflowPayloadSettings = {
    __typename?: "WorkflowPayloadSettings";
    defaultValue: Scalars["String"]["output"];
    description: Scalars["String"]["output"];
    key: Scalars["String"]["output"];
    label: Scalars["String"]["output"];
    scope: Scalars["String"]["output"];
    type: WorkflowSettingType;
};

export type WorkflowPayloadSettingsInput = {
    defaultValue: Scalars["String"]["input"];
    description: Scalars["String"]["input"];
    key: Scalars["String"]["input"];
    label: Scalars["String"]["input"];
    scope: Scalars["String"]["input"];
    type: WorkflowSettingType;
};

export enum WorkflowSettingType {
    ClientEmails = "ClientEmails",
    ClientPhones = "ClientPhones",
    EmailTemplateId = "EmailTemplateId",
    Number = "Number",
    SmsBody = "SmsBody",
    Boolean = "boolean",
    Html = "html",
    String = "string",
    User = "user",
}

export type WorkflowSettingValue = {
    __typename?: "WorkflowSettingValue";
    key: Scalars["String"]["output"];
    textValue?: Maybe<Scalars["String"]["output"]>;
    workflowId: Scalars["WorkflowId"]["output"];
};

export enum WorkflowStatus {
    Draft = "Draft",
    Published = "Published",
}

export type WorkflowTriggerEntity = {
    __typename?: "WorkflowTriggerEntity";
    emailOpened?: Maybe<EmailOpenedTriggerConfigurationEntity>;
    entityUpdated?: Maybe<EntityUpdatedTriggerConfigurationEntity>;
    eventType: WorkflowEventType;
    noteAdded?: Maybe<NoteTriggerConfigurationEntity>;
    pipelineStageChanged?: Maybe<PipelineStageChangedTriggerConfigurationEntity>;
    schedule?: Maybe<ScheduleTriggerConfigurationEntity>;
};

export type WorkflowTriggerFieldValueEntityValueType = {
    __typename?: "WorkflowTriggerFieldValueEntityValueType";
    specialValue?: Maybe<Scalars["String"]["output"]>;
    values?: Maybe<Array<Scalars["String"]["output"]>>;
};

export type WorkflowTriggerFieldValueEntityValueTypeInput = {
    specialValue?: InputMaybe<Scalars["String"]["input"]>;
    values?: InputMaybe<Array<Scalars["String"]["input"]>>;
};

export type WorkflowTriggerInput = {
    emailOpened?: InputMaybe<EmailOpenedTriggerConfigurationInput>;
    entityUpdated?: InputMaybe<EntityUpdatedTriggerConfigurationInput>;
    eventType: WorkflowEventType;
    noteAdded?: InputMaybe<NoteTriggerConfigurationInput>;
    noteDeleted?: InputMaybe<NoteTriggerConfigurationInput>;
    noteUpdated?: InputMaybe<NoteTriggerConfigurationInput>;
    pipelineStageChanged?: InputMaybe<PipelineStageChangedTriggerConfigurationInput>;
    schedule?: InputMaybe<ScheduleTriggerConfigurationEntityInput>;
};
